{
  "ASPxReportsStringId.DocumentViewer_ExternalRibbonNotFound_Error": "Belirtilen adı taşıyan bir araç çubuğu denetimi bulunamıyor: '{0}'.",
  "ASPxReportsStringId.DocumentViewer_NoRemoteDocumentInformation_Error": "İçin bir belge değil henüz oluşturulan bu komut yürütülemiyor.",
  "ASPxReportsStringId.DocumentViewer_RemoteAuthenticatorCredential_Error": "Kullanıcı kimlik bilgileri boş olamaz.",
  "ASPxReportsStringId.DocumentViewer_RemoteAuthenticatorLogin_Error": "Belirtilen kullanıcı kimlik bilgileriyle oturum başarısız oldu.",
  "ASPxReportsStringId.DocumentViewer_RemotePageByPage_Error": "Uzak bir rapor görüntülemek için SettingsReportViewer PageByPage özelliğini etkinleştirin.",
  "ASPxReportsStringId.DocumentViewer_RemoteSourceConnection_Error": "Belirtilen rapor hizmet bulunamadı.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_DocumentMap": "Doküman Haritası",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_FindText": "Metin bulma",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_FirstPage": "İlk Sayfa",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_LastPage": "Son sayfa",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_NextPage": "Sonraki Sayfa",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_ParametersPanel": "Parametreler paneli",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_PreviousPage": "Önceki Sayfa",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_PrintPage": "Sayfayı Yazdır",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_PrintReport": "Raporu Yazdır",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_SaveToFile": "Dosyaya Kaydet",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandText_SaveToWindow": "Pencereyi Kaydet",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_DocumentMap": "Yer imleri rapor hiyerarşisi aracılığıyla gezin.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_FindText": "Belge içinde metin bul.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_FirstPage": "İlk belge sayfasını görüntülemek.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_LastPage": "Son belge sayfasını görüntüleme.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_NextPage": "Sonraki belge sayfasını görüntüleme.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_ParametersPanel": "Erişim ve rapor parametre değerlerini değiştirme.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_PreviousPage": "Önceki belge sayfasını görüntüleme.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_PrintPage": "Yazdırma ayarlarını belirtin ve geçerli sayfayı yazdırmak.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_PrintReport": "Belgeyi yazdırma ayarlarını belirtin ve.",
  "ASPxReportsStringId.DocumentViewer_RibbonCommandToolTip_SaveToFile": "Belgeyi belirtilen biçimde bir dosyaya kaydedin.",
  "ASPxReportsStringId.DocumentViewer_RibbonCurrentPageText": "Geçerli sayfa",
  "ASPxReportsStringId.DocumentViewer_RibbonCurrentPageToolTip": "Belirtilen sayfayı görüntüler.",
  "ASPxReportsStringId.DocumentViewer_RibbonExportGroupText": "Dışa Aktar",
  "ASPxReportsStringId.DocumentViewer_RibbonHomeTabText": "Ana Sayfa",
  "ASPxReportsStringId.DocumentViewer_RibbonNavigationGroupText": "Gezinti",
  "ASPxReportsStringId.DocumentViewer_RibbonPageCountText": "Sayfa sayısı:",
  "ASPxReportsStringId.DocumentViewer_RibbonPrintGroupText": "Yazdır",
  "ASPxReportsStringId.DocumentViewer_RibbonReportGroupText": "Rapor",
  "ASPxReportsStringId.ExportName_csv": "CSV",
  "ASPxReportsStringId.ExportName_docx": "DOCX",
  "ASPxReportsStringId.ExportName_html": "HTML",
  "ASPxReportsStringId.ExportName_mht": "MHT",
  "ASPxReportsStringId.ExportName_pdf": "PDF",
  "ASPxReportsStringId.ExportName_png": "Resim",
  "ASPxReportsStringId.ExportName_rtf": "RTF",
  "ASPxReportsStringId.ExportName_txt": "Metin",
  "ASPxReportsStringId.ExportName_xls": "XLS",
  "ASPxReportsStringId.ExportName_xlsx": "XLSX",
  "ASPxReportsStringId.List_More": "Daha fazla",
  "ASPxReportsStringId.ParametersPanel_False": "Hayır",
  "ASPxReportsStringId.ParametersPanel_GenericRegexValidationError": "Değeri geçerli değil.",
  "ASPxReportsStringId.ParametersPanel_Reset": "Sıfırlama",
  "ASPxReportsStringId.ParametersPanel_Submit": "Gönder",
  "ASPxReportsStringId.ParametersPanel_True": "Evet",
  "ASPxReportsStringId.ReportDesigner_FieldListActions_Rename": "Yeniden adlandırma",
  "ASPxReportsStringId.ReportDesigner_FontOptions_Unit_Document": "Belge",
  "ASPxReportsStringId.ReportDesigner_FontOptions_Unit_Point": "Nokta",
  "ASPxReportsStringId.ReportDesigner_GaugeViewType_Linear": "Doğrusal",
  "ASPxReportsStringId.ReportDesigner_Groups": "Gruplar",
  "ASPxReportsStringId.ReportDesigner_MasterDetailWizard_ChooseDataMembers_SelectDataFields": "Veri alanları seçin",
  "ASPxReportsStringId.ReportDesigner_MasterDetailWizard_SummaryOptions_SelectFieldsAndSummaries": "Alanları seçin ve onlara özet işlevleri atama",
  "ASPxReportsStringId.ReportDesigner_MasterDetailWizard_SummaryOptions_SummaryFunctions": "Özet işlevleri",
  "ASPxReportsStringId.ReportDesigner_MenuButtons_RunWizard": "Sihirbazı Çalıştır",
  "ASPxReportsStringId.ReportDesigner_Menu_Text": "Menü",
  "ASPxReportsStringId.ReportDesigner_NameUniqueError": "Adı benzersiz değil",
  "ASPxReportsStringId.ReportDesigner_ParametersDialog_AddParameter": "Parametre Ekle",
  "ASPxReportsStringId.ReportDesigner_ParametersDialog_GroupOrientation": "Yön",
  "ASPxReportsStringId.ReportDesigner_ParametersDialog_GroupTitle": "Başlık",
  "ASPxReportsStringId.ReportDesigner_PropertyGrid_AutoValueString": "(Otomatik)",
  "ASPxReportsStringId.ReportDesigner_ScriptEditor_Toolbar_SelectEvent": "Olay seç...",
  "ASPxReportsStringId.ReportDesigner_StylesEditor_CreateNew": "Yeni Stil Oluştur",
  "ASPxReportsStringId.ReportDesigner_SummaryEditor_Weight": "Ağırlık",
  "ASPxReportsStringId.ReportDesigner_TableActions_DeleteColumn": "Sütun Sil",
  "ASPxReportsStringId.ReportDesigner_TableActions_DeleteRow": "Satır Sil",
  "ASPxReportsStringId.ReportDesigner_TableActions_InsertCell": "Hücre Ekle",
  "ASPxReportsStringId.ReportDesigner_TableActions_InsertColumnToLeft": "Sola Sütun Ekle",
  "ASPxReportsStringId.ReportDesigner_TableActions_InsertColumnToRight": "Sağa Sütun Ekle",
  "ASPxReportsStringId.ReportDesigner_TableActions_InsertRowBelow": "Aşağıya Satır Ekle",
  "ASPxReportsStringId.ReportDesigner_Tables": "Tablolar",
  "ASPxReportsStringId.ReportDesigner_TextAlignment_Horizontal": "Yatay",
  "ASPxReportsStringId.ReportDesigner_TextAlignment_Vertical": "Dikey",
  "ASPxReportsStringId.ReportDesigner_Wizard_AddGroup_Text": "Grup Ekle",
  "ASPxReportsStringId.ReportDesigner_Wizard_AddSummaryFields_Placeholder": "Rapora Özet alanı eklemek için bir veri alanı (sayısal, tarih-saat veya Boole) seçin ve gruplarda kullanılmadığından emin olun.",
  "ASPxReportsStringId.ReportDesigner_Wizard_ChooseColumns_Description": "Raporda görüntülemek istediğiniz sütunları seçin.",
  "ASPxReportsStringId.ReportDesigner_Wizard_ChooseColumns_Title": "Raporda görüntülenecek sütunları seçin",
  "ASPxReportsStringId.ReportDesigner_Wizard_ColorScheme_Description": "Bir rapor renk düzenini seçin.",
  "ASPxReportsStringId.ReportDesigner_Wizard_CreateNewDataSource": "Hayır, yeni bir SQL veri kaynağı oluşturmak istiyorum",
  "ASPxReportsStringId.ReportDesigner_Wizard_DataSourceHeader": "Veri kaynağı Sihirbazı",
  "ASPxReportsStringId.ReportDesigner_Wizard_Header": "Rapor Sihirbazı",
  "ASPxReportsStringId.ReportDesigner_Wizard_Height": "Yükseklik:",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_BottomMargin": "Alt:",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_LeftMargin": "Sol:",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_Orientation": "Yön:",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_Paper": "Kağıt",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_RightMargin": "Sağ:",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_Size": "Boyut:",
  "ASPxReportsStringId.ReportDesigner_Wizard_PageSetup_TopMargin": "Üst:",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportComplete_Title": "Rapor tamamlandı",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportLayout_Landscape": "Yatay",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportLayout_Outline1": "Anahat 1",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportLayout_Outline2": "Anahat 2",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportLayout_Portrait": "Dikey",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportLayout_Tabular": "Sekmeli",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportStyle_Bold": "Kalın",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportStyle_Caption": "Resim yazısı",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportStyle_Corporate": "Kurumsal",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportStyle_Data": "Veri",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportStyle_Formal": "Resmi",
  "ASPxReportsStringId.ReportDesigner_Wizard_ReportStyle_Title": "Başlık",
  "ASPxReportsStringId.ReportDesigner_Wizard_SpecifyPageSettingsColorScheme": "Sayfa ayarlarını ve rapor renk düzenini belirtin.",
  "ASPxReportsStringId.ReportDesigner_Wizard_SummaryFields_Text": "Alan",
  "ASPxReportsStringId.ReportDesigner_Wizard_SummaryOptions_Average": "Ortalama",
  "ASPxReportsStringId.ReportDesigner_Wizard_SummaryOptions_Count": "Adet",
  "ASPxReportsStringId.ReportDesigner_Wizard_SummaryOptions_Max": "Max",
  "ASPxReportsStringId.ReportDesigner_Wizard_SummaryOptions_Min": "Min",
  "ASPxReportsStringId.ReportDesigner_Wizard_SummaryOptions_Sum": "Toplam",
  "ASPxReportsStringId.ReportDesigner_Wizard_TopMargin": "Üst Kenar Boşluğu:",
  "ASPxReportsStringId.ReportDesigner_Wizard_Width": "Genişliği:",
  "ASPxReportsStringId.SearchDialog_Cancel": "İptal",
  "ASPxReportsStringId.SearchDialog_Case": "Harf eşleştir",
  "ASPxReportsStringId.SearchDialog_Down": "Aşağı",
  "ASPxReportsStringId.SearchDialog_EnterText": "Belge içinde bulmak için metin girin.",
  "ASPxReportsStringId.SearchDialog_FindNext": "Sonrakini bul",
  "ASPxReportsStringId.SearchDialog_FindWhat": "Bul&nbsp;ne",
  "ASPxReportsStringId.SearchDialog_Finished": "Belge aramasını tamamlandı.",
  "ASPxReportsStringId.SearchDialog_Header": "Arama",
  "ASPxReportsStringId.SearchDialog_SearchButton": "Arama",
  "ASPxReportsStringId.SearchDialog_Up": "Yukarı",
  "ASPxReportsStringId.SearchDialog_WholeWord": "Sadece tam sözcükleri eşleştir",
  "ASPxReportsStringId.SidePanel_Collapse": "Daralt",
  "ASPxReportsStringId.SidePanel_Open": "Aç",
  "ASPxReportsStringId.ToolBarItemText_Design": "Tasarım",
  "ASPxReportsStringId.ToolBarItemText_FirstPage": "İlk Sayfa",
  "ASPxReportsStringId.ToolBarItemText_LastPage": "Son Sayfa",
  "ASPxReportsStringId.ToolBarItemText_NextPage": "Sonraki Sayfa",
  "ASPxReportsStringId.ToolBarItemText_OfLabel": "of",
  "ASPxReportsStringId.ToolBarItemText_PageLabel": "Sayfa",
  "ASPxReportsStringId.ToolBarItemText_Preview": "Önizleme",
  "ASPxReportsStringId.ToolBarItemText_PreviousPage": "Önceki Sayfa",
  "ASPxReportsStringId.ToolBarItemText_PrintPage": "Geçerli sayfayı yazdır",
  "ASPxReportsStringId.ToolBarItemText_PrintReport": "Raporu yazdırma",
  "ASPxReportsStringId.ToolBarItemText_SaveToDisk": "Rapor dışa aktar ve diske kaydet",
  "ASPxReportsStringId.ToolBarItemText_SaveToWindow": "Rapor dışa aktar ve yeni bir pencerede göster",
  "ASPxReportsStringId.ToolBarItemText_Search": "Arama penceresini görüntüleme",
  "ASPxReportsStringId.WebDocumentViewer_0Pages": "0 sayfa",
  "ASPxReportsStringId.WebDocumentViewer_AriaLabelZoomCombobox": "Yakınlaştır",
  "ASPxReportsStringId.WebDocumentViewer_CustomDocumentOperationsDenied_Error": "İstenen belge işlemi gerçekleştirilemez.",
  "ASPxReportsStringId.WebDocumentViewer_DocumentCreationError": "Geçerli rapor için bir belge oluşturulamıyor",
  "ASPxReportsStringId.WebDocumentViewer_DrillThroughError": "Ayrıntıya aracılığıyla işlemi başarısız oldu",
  "ASPxReportsStringId.WebDocumentViewer_ExportError": "Dışa aktarma işlemi sırasında bir hata oluştu",
  "ASPxReportsStringId.WebDocumentViewer_ExportToText": "İhracat",
  "ASPxReportsStringId.WebDocumentViewer_InitializationError": "Rapor önizleme başlatma başarısız oldu",
  "ASPxReportsStringId.WebDocumentViewer_SearchError": "Arama sırasında bir hata oluştu",
  "ASPxReportsStringId.WebDocumentViewer_SearchResultText": "Arama sonucu",
  "ChartDesignerStringIDs.AnnotationFreePosition": "Boş pozisyon",
  "ChartDesignerStringIDs.AnnotationRelativePosition": "Göreli konumu",
  "ChartDesignerStringIDs.AreaFullStackedSeries2D": "Tam yığılmış serisi 2D",
  "ChartDesignerStringIDs.AreaFullStackedSeries3D": "Tam yığılmış alan 3D",
  "ChartDesignerStringIDs.AreaSeries2D": "Alan 2D",
  "ChartDesignerStringIDs.AreaSeries3D": "Alan 3D",
  "ChartDesignerStringIDs.AreaStackedSeries2D": "Serisi 2B yığılmış",
  "ChartDesignerStringIDs.AreaStackedSeries3D": "Alan 3B Yığılmış",
  "ChartDesignerStringIDs.AreaStepFullStackedSeries2D": "Tam yığılmış adım alan 2D",
  "ChartDesignerStringIDs.AreaStepSeries2D": "Adım alan 2D",
  "ChartDesignerStringIDs.Auto": "Otomatik",
  "ChartDesignerStringIDs.AxisCategoryTitle": "Eksen seçenekleri",
  "ChartDesignerStringIDs.AxisOptions_AppearanceGroup": "Görünüm",
  "ChartDesignerStringIDs.AxisOptions_AxisAlignment": "Hizalama",
  "ChartDesignerStringIDs.AxisOptions_AxisKind": "Pozisyon",
  "ChartDesignerStringIDs.AxisOptions_AxisKindNoneCaption": "Hiçbiri",
  "ChartDesignerStringIDs.AxisOptions_AxisKindNoneDescription": "Eksen görüntüleme.",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_BottomCaption": "Altta göster",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_BottomDescription": "Alt diyagramın ekseni göster.",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_CircularAxisYVisibleCaption": "Ekseni göster",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_CircularAxisYVisibleDescription": "Y ekseni göster",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_LeftCaption": "Sol tarafta göster",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_LeftDescription": "Diyagram eksenini sol tarafta göster.",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_RightCaption": "Sağ tarafta göster",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_RightDescription": "Diyagram eksenini sağ tarafta göster.",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_TopCaption": "Üstte göster",
  "ChartDesignerStringIDs.AxisOptions_AxisKind_TopDescription": "Üst kısmında bir diyagram ekseni göster.",
  "ChartDesignerStringIDs.AxisOptions_AxisLabelNoneCaption": "Hiçbiri",
  "ChartDesignerStringIDs.AxisOptions_AxisLabelNoneDescription": "Eksen etiketlerini kapat.",
  "ChartDesignerStringIDs.AxisOptions_AxisReverse": "Ters çevir",
  "ChartDesignerStringIDs.AxisOptions_CircularXLabelOrientation_NormalCaption": "Etiketlerini göster",
  "ChartDesignerStringIDs.AxisOptions_CircularXLabelOrientation_NormalDescription": "Eksen etiketlerini göster.",
  "ChartDesignerStringIDs.AxisOptions_CircularYLabelOrientation_NormalCaption": "Etiketleri Göster",
  "ChartDesignerStringIDs.AxisOptions_CircularYLabelOrientation_NormalDescription": "Eksen etiketlerini göster.",
  "ChartDesignerStringIDs.AxisOptions_DateTimeFormat": "Biçim:",
  "ChartDesignerStringIDs.AxisOptions_DateTimeMeasureUnit": "Ölçü birimi:",
  "ChartDesignerStringIDs.AxisOptions_ElementsGroup": "Öğeler",
  "ChartDesignerStringIDs.AxisOptions_GeneralGroup": "Genel",
  "ChartDesignerStringIDs.AxisOptions_GridlinesStaticText": "Kılavuz çizgileri",
  "ChartDesignerStringIDs.AxisOptions_Interlaced": "Titreşimli",
  "ChartDesignerStringIDs.AxisOptions_LabelsOrientation": "Etiketler",
  "ChartDesignerStringIDs.AxisOptions_MajorVisible": "Büyük",
  "ChartDesignerStringIDs.AxisOptions_MinorVisible": "Küçük",
  "ChartDesignerStringIDs.AxisOptions_RangeGroup": "Aralık",
  "ChartDesignerStringIDs.AxisOptions_TickMarksStaticText": "Onay İşaretleri",
  "ChartDesignerStringIDs.AxisOptions_TitleContent": "Metin:",
  "ChartDesignerStringIDs.AxisOptions_TitleGroup": "Eksen başlığı",
  "ChartDesignerStringIDs.AxisOptions_TitlePosition": "Başlık",
  "ChartDesignerStringIDs.AxisOptions_TitlePosition_NoneCaption": "Hiçbiri",
  "ChartDesignerStringIDs.AxisOptions_TitlePosition_NoneDescription": "Eksen başlığını kapat.",
  "ChartDesignerStringIDs.AxisOptions_TitleVisibility": "Başlık görünürlüğü",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_NormalCaption": "Etiketlerini göster",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_NormalDescription": "Eksen etiketlerini göster.",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_Rotated45Caption": "45 Derece",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_Rotated45Description": "45 Derece döndürülmüş eksen etiketlerini göster.",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_Rotated90Caption": "90 Derece",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_Rotated90Description": "90 Derece döndürülmüş eksen etiketlerini göster.",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_RotatedMinus45Caption": "-45 Derece",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_RotatedMinus45Description": "-45 Derece döndürülmüş eksen etiketlerini göster.",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_RotatedMinus90Caption": "90 Derece",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_RotatedMinus90Description": "90 Derece döndürülmüş eksen etiketlerini göster.",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_StaggeredCaption": "Sendeleyerek",
  "ChartDesignerStringIDs.AxisOptions_XLabelOrientation_StaggeredDescription": "Damalı sırayla eksen etiketlerini göster.",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_BottomCaption": "Alt",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_BottomDescription": "Alt kısmında bir eksen başlığını göster.",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_CenterCaption": "Merkezi",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_CenterDescription": "Merkezi bir eksen başlığını göster.",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_LeftCaption": "Sol",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_LeftDescription": "Sol eksen başlığını göster.",
  "ChartDesignerStringIDs.AxisOptions_XTitlePosition_RightCaption": "Sağ",
  "ChartDesignerStringIDs.AxisOptions_YLabelOrientation_DescriptionCaption": "Eksen etiketlerini göster.",
  "ChartDesignerStringIDs.AxisOptions_YLabelOrientation_NormalCaption": "Etiketleri Göster",
  "ChartDesignerStringIDs.AxisOptions_YLabelOrientation_Rotated90Caption": "90 Derece",
  "ChartDesignerStringIDs.AxisOptions_YLabelOrientation_Rotated90Description": "90 Derece döndürülmüş eksen etiketlerini göster.",
  "ChartDesignerStringIDs.AxisOptions_YLabelOrientation_RotatedMinus90Caption": "90 Derece",
  "ChartDesignerStringIDs.AxisOptions_YLabelOrientation_RotatedMinus90Description": "90 Derece döndürülmüş eksen etiketlerini göster.",
  "ChartDesignerStringIDs.AxisOptions_YTitlePosition_CenterCaption": "Merkezi",
  "ChartDesignerStringIDs.AxisOptions_YTitlePosition_CenterDescription": "Merkezi bir eksen başlığını göster.",
  "ChartDesignerStringIDs.AxisOptions_YTitlePosition_TopCaption": "Üst",
  "ChartDesignerStringIDs.AxisOptions_YTitlePosition_TopDescription": "Üst kısmında bir eksen başlığını göster.",
  "ChartDesignerStringIDs.AxisPageCategoryTitle": "Eksen",
  "ChartDesignerStringIDs.Bar2DModelGradient": "Gradyan",
  "ChartDesignerStringIDs.BarFullStackedSeries2D": "Tam yığılmış çubuk 2D",
  "ChartDesignerStringIDs.BarItemMenu_ChartTitle": "Grafik başlığı",
  "ChartDesignerStringIDs.BarItemMenu_ConstantLine": "Sabit hat",
  "ChartDesignerStringIDs.BarItemMenu_SecondaryAxisX": "İkincil ekseni X",
  "ChartDesignerStringIDs.BarItemMenu_SecondaryAxisY": "İkincil eksen Y",
  "ChartDesignerStringIDs.BarItemMenu_Series": "Serisi...",
  "ChartDesignerStringIDs.BarItemMenu_SeriesElements": "Dizi öğeleri",
  "ChartDesignerStringIDs.BarItemMenu_StackedBarTotalLabel": "Toplam etiket yığılmış",
  "ChartDesignerStringIDs.BarItemMenu_Strip": "Şerit",
  "ChartDesignerStringIDs.BarItemMenu_Title": "Başlık",
  "ChartDesignerStringIDs.BarSeries3D": "Bar 3D (Manhattan Bar)",
  "ChartDesignerStringIDs.BarSideBySideFullStackedSeries2D": "Yan yana tam yığılmış çubuk 2D",
  "ChartDesignerStringIDs.BarSideBySideSeries2D": "Yan yana Bar 2B",
  "ChartDesignerStringIDs.BarSideBySideSeries3D": "Yan yana Bar 3D",
  "ChartDesignerStringIDs.BarSideBySideStackedSeries2D": "Yan yana 2B yığılmış",
  "ChartDesignerStringIDs.BarStackedSeries2D": "Bar 2B yığılmış",
  "ChartDesignerStringIDs.BubbleSeries2D": "Kabarcık 2D",
  "ChartDesignerStringIDs.BubbleSeries3D": "Kabarcık 3D",
  "ChartDesignerStringIDs.CancelButtonCaption": "İptal",
  "ChartDesignerStringIDs.CandleStickSeries2D": "Mum çubuk 2D",
  "ChartDesignerStringIDs.ChangeChartType": "Grafik türünü değiştir",
  "ChartDesignerStringIDs.ChartAnnotationOptions_General": "Genel",
  "ChartDesignerStringIDs.ChartAnnotationOptions_Text": "Metin",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_Boolean": "Boole",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_DateTime": "Tarih Saat",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_Decimal": "Ondalık",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_Double": "Çift",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_Guid": "GUID",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_Int32": "Int32",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_None": "Hiçbiri",
  "ChartDesignerStringIDs.ChartDesignerCalculatedFieldType_String": "Dize",
  "ChartDesignerStringIDs.ChartDesignerDeleteCalculatedField": "Sil",
  "ChartDesignerStringIDs.ChartDesignerWindowTitle": "Grafik Tasarımcısı",
  "ChartDesignerStringIDs.ChartStructureDockPanelTitle": "Grafik yapısı",
  "ChartDesignerStringIDs.ChartTitleOptionsRibbonCategoryTitle": "Başlık seçenekleri",
  "ChartDesignerStringIDs.ChartTitleOptions_General": "Genel",
  "ChartDesignerStringIDs.ChartTitleOptions_Position": "Pozisyon",
  "ChartDesignerStringIDs.ChartTitleOptions_SelectedTitle": "Başlık",
  "ChartDesignerStringIDs.ChartTitleOptions_Text": "Metin:",
  "ChartDesignerStringIDs.ChartViewGallery_Area": "Alan serisi",
  "ChartDesignerStringIDs.ChartViewGallery_BarSeries": "Bar serisi",
  "ChartDesignerStringIDs.ChartViewGallery_Financial": "Finansal seri",
  "ChartDesignerStringIDs.ChartViewGallery_LineSeries": "Çizgi dizi",
  "ChartDesignerStringIDs.ChartViewGallery_Pie": "Pasta serisi",
  "ChartDesignerStringIDs.ChartViewGallery_PointBubble": "Noktası ve kabarcık serisi",
  "ChartDesignerStringIDs.ChartViewGallery_Polar": "Polar serisi",
  "ChartDesignerStringIDs.ChartViewGallery_Radar": "Radar serisi",
  "ChartDesignerStringIDs.ChartViewGallery_RangeSeries": "Aralık serisi",
  "ChartDesignerStringIDs.ChooseDataSource": "Bir veri kaynağı seçin:",
  "ChartDesignerStringIDs.CircularAreaZoomInAnimation": "Yakınlaştır",
  "ChartDesignerStringIDs.CircularLineZoomInAnimation": "Yakınlaştır",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeConstantLineValueCaption": "Hatalı değer biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeConstantLineValueMessage": "Girilen değer yanlış tipe sahip. Tarih/Saat olmalıdır",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeScaleBreakEdge1Caption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeScaleBreakEdge1Message": "Girilen değer yanlış türüne sahip. Tarih/saat olmalıdır",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeScaleBreakEdge2Caption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeScaleBreakEdge2Message": "Girilen değer yanlış türüne sahip. Tarih/saat olmalıdır",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeStripMaxLimitCaption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeStripMaxLimitMessage": "Girilen değer yanlış türüne sahip. Tarih/saat olmalıdır",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeStripMinLimitCaption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithDateTimeStripMinLimitMessage": "Girilen değer yanlış türüne sahip. Tarih/saat olmalıdır",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericConstantLineValueCaption": "Hatalı değer biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericConstantLineValueMessage": "Girilen değeri yanlış tipe sahip. Sayısal olmalıdır",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalScaleBreakEdge1Caption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalScaleBreakEdge1Message": "Girilen değer yanlış türe sahip. Sayısal olmalıdır.",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalScaleBreakEdge2Caption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalScaleBreakEdge2Message": "Girilen değer yanlış türe sahip. Sayısal olmalıdır.",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalStripMaxLimitCaption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalStripMaxLimitMessage": "Girilen değer yanlış türe sahip. Sayısal olmalıdır.",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalStripMinLimitCaption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithNumericalStripMinLimitMessage": "Girilen değer yanlış türe sahip. Sayısal olmalıdır.",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithTimeSpanConstantLineValueCaption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithTimeSpanScaleBreakEdge1Caption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithTimeSpanScaleBreakEdge2Caption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithTimeSpanStripMaxLimitCaption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.CommandMessages_IncompatibleWithTimeSpanStripMinLimitCaption": "Hatalı Değer Biçimi",
  "ChartDesignerStringIDs.ComplexTitleContent": "Karmaşık içerik",
  "ChartDesignerStringIDs.ConstantLineCategoryTitle": "Sabit hat seçenekleri",
  "ChartDesignerStringIDs.ConstantLinePageCategoryTitle": "Sabit hat",
  "ChartDesignerStringIDs.ConstantLine_GeneralGroupTitle": "Genel",
  "ChartDesignerStringIDs.ConstantLine_LegendText": "Gösterge metni:",
  "ChartDesignerStringIDs.ConstantLine_LineColor": "Renk",
  "ChartDesignerStringIDs.ConstantLine_Thickness": "Kalınlık:",
  "ChartDesignerStringIDs.ConstantLine_TitleForeground": "Renk",
  "ChartDesignerStringIDs.ConstantLine_TitleGroupTitle": "Başlık",
  "ChartDesignerStringIDs.ConstantLine_TitlePosition": "Başlık",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_FarAboveHorizontal": "Sağ üst",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_FarAboveVertical": "Sağ üst",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_FarBelowHorizontal": "Hemen altında",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_FarBelowVertical": "Hemen altında",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_NearAboveHorizontal": "Sol yukarıdaki",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_NearAboveVertical": "Sol yukarıdaki",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_NearBelowHorizontal": "Sol aşağıda",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_NearBelowVertical": "Sol aşağıda",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionCaption_None": "Hiçbiri",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionDescription_FarAboveHorizontal": "Sağ tarafta çizgisinin üstündeki başlığı göster.",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionDescription_FarAboveVertical": "Sağ tarafta çizgisinin üstündeki başlığı göster.",
  "ChartDesignerStringIDs.ConstantLine_TitlePositionDescription_NearAboveVertical": "Sol tarafta çizgisinin üstündeki başlığı göster.",
  "ChartDesignerStringIDs.ConstantLine_TitleText": "Metin:",
  "ChartDesignerStringIDs.ConstantLine_Value": "Değer:",
  "ChartDesignerStringIDs.DashStyle_Dot": "Nokta",
  "ChartDesignerStringIDs.DashStyle_Solid": "Katı",
  "ChartDesignerStringIDs.DataEditor_ArgumentColumnHeader": "Sav",
  "ChartDesignerStringIDs.DataEditor_CloseValueColumnHeader": "Kapat",
  "ChartDesignerStringIDs.DataEditor_HighValueColumnHeader": "Yüksek",
  "ChartDesignerStringIDs.DataEditor_LowValueColumnHeader": "Düşük",
  "ChartDesignerStringIDs.DataEditor_MaxColumnHeader": "Max",
  "ChartDesignerStringIDs.DataEditor_MinColumnHeader": "Min",
  "ChartDesignerStringIDs.DataEditor_OpenValueColumnHeader": "Açık",
  "ChartDesignerStringIDs.DataEditor_Value2ColumnHeader": "2 Değeri",
  "ChartDesignerStringIDs.DataEditor_ValueColumnHeader": "Değer",
  "ChartDesignerStringIDs.DataEditor_WeightValueColumnHeader": "Ağırlık",
  "ChartDesignerStringIDs.DefaultAxisTitleText": "Eksen",
  "ChartDesignerStringIDs.DefaultChartTitleContent": "Başlık",
  "ChartDesignerStringIDs.DefaultConstantLineTitle": "Sabit hat",
  "ChartDesignerStringIDs.DefaultPane": "Varsayılan Bölmesi",
  "ChartDesignerStringIDs.DefaultSeriesNamePrefix": "Seri",
  "ChartDesignerStringIDs.DefaultStripLegendText": "Şerit",
  "ChartDesignerStringIDs.Default_ElementsPageTitle": "Öğeler",
  "ChartDesignerStringIDs.Default_Elements_AddChartTitle": "Grafik başlığı ekleme",
  "ChartDesignerStringIDs.Default_Elements_AddConstantLine": "Sabit hat Ekle",
  "ChartDesignerStringIDs.Default_Elements_AddConstantLineX": "X ekseni için sabit hat Ekle",
  "ChartDesignerStringIDs.Default_Elements_AddConstantLineXDescription": "Sabit satır eklemek için birincil ekseni.",
  "ChartDesignerStringIDs.Default_Elements_AddConstantLineY": "Y ekseni sabit hat Ekle",
  "ChartDesignerStringIDs.Default_Elements_AddPaneHorizontal": "Sağ Bölmesi ekleme",
  "ChartDesignerStringIDs.Default_Elements_AddPaneHorizontalDescription": "Yeni bir bölmesi geçerli bölmesini sağına eklemek ve onları yatay olarak yığın.",
  "ChartDesignerStringIDs.Default_Elements_AddSecondaryAxisX": "X eksen ekleme",
  "ChartDesignerStringIDs.Default_Elements_AddSecondaryAxisY": "Y eksen ekleme",
  "ChartDesignerStringIDs.Default_Elements_AddStripX": "X ekseni için şerit eklemek",
  "ChartDesignerStringIDs.Default_Elements_AddStripXDescription": "Bir şerit eklemek için birincil ekseni.",
  "ChartDesignerStringIDs.Default_Elements_AddStripY": "Y ekseni için şerit eklemek",
  "ChartDesignerStringIDs.Default_Elements_AddStripYDescription": "Bir şerit eklemek için birincil ekseni.",
  "ChartDesignerStringIDs.Default_Elements_AnnotationsGroup": "ek açıklamaları",
  "ChartDesignerStringIDs.Default_Elements_AxesElementsGroupTitle": "Eksen öğeleri",
  "ChartDesignerStringIDs.Default_Elements_AxesGroupTitle": "Eksenler",
  "ChartDesignerStringIDs.Default_Elements_ChartAreaElementsGroupTitle": "Grafik alanı öğeleri",
  "ChartDesignerStringIDs.Default_Elements_IndicatorsGroup": "Göstergeler",
  "ChartDesignerStringIDs.Default_Elements_Legend": "Gösterge",
  "ChartDesignerStringIDs.Default_Elements_Pane": "Bölme",
  "ChartDesignerStringIDs.Default_MainPageTitle": "Grafik",
  "ChartDesignerStringIDs.Default_Main_ChangeChartTypeGroupTitle": "Grafik türünü değiştir",
  "ChartDesignerStringIDs.Default_Main_CircularDiagramCircleShapeStyleCaption": "Daire",
  "ChartDesignerStringIDs.Default_Main_CircularDiagramPolygonShapeStyleCaption": "Çokgen",
  "ChartDesignerStringIDs.Default_Main_CircularDiagramRotationDirectionClockwise": "Saat yönünde",
  "ChartDesignerStringIDs.Default_Main_CircularDiagramRotationDirectionCounterclockwise": "Saat yönünün tersine",
  "ChartDesignerStringIDs.Default_Main_Diagram3DPerspectiveAngle": "Perspektif Açısı:",
  "ChartDesignerStringIDs.Default_Main_EnableAxisXNavigationCheckCaption": "X Ekseni",
  "ChartDesignerStringIDs.Default_Main_EnableAxisYNavigationCheckCaption": "Y Ekseni",
  "ChartDesignerStringIDs.Default_Main_Palette": "Palet",
  "ChartDesignerStringIDs.Default_Main_PaneOrientationHorizontal": "Yatay",
  "ChartDesignerStringIDs.Default_Main_PaneOrientationVertical": "Dikey",
  "ChartDesignerStringIDs.Default_Main_SimpleDiagramLayoutDimensionWithoutColon": "Boyut",
  "ChartDesignerStringIDs.Default_Main_SimpleDiagramLayoutDirectionHorizontalCaption": "Yatay",
  "ChartDesignerStringIDs.Default_Main_SimpleDiagramLayoutDirectionVerticalCaption": "Dikey",
  "ChartDesignerStringIDs.Default_Main_XYDiagramRotated": "döndürülmüş",
  "ChartDesignerStringIDs.DragDropDataMembers_Argument": "Sav",
  "ChartDesignerStringIDs.DragDropDataMembers_Close": "Kapat",
  "ChartDesignerStringIDs.DragDropDataMembers_Color": "Renk",
  "ChartDesignerStringIDs.DragDropDataMembers_High": "Yüksek",
  "ChartDesignerStringIDs.DragDropDataMembers_Low": "Düşük",
  "ChartDesignerStringIDs.DragDropDataMembers_Open": "Aç",
  "ChartDesignerStringIDs.DragDropDataMembers_Series": "Seriler",
  "ChartDesignerStringIDs.DragDropDataMembers_ToolTipHint": "Araç ipucu ipucu",
  "ChartDesignerStringIDs.DragDropDataMembers_Value": "Değer",
  "ChartDesignerStringIDs.DragDropDataMembers_Value2": "2 Değeri",
  "ChartDesignerStringIDs.DragDropDataMembers_Weight": "Ağırlık",
  "ChartDesignerStringIDs.EmptyDiagramHintBar": "Grafik görselleştirmek için veri yok. Ekle menüsünü genişletin ve görselleştirmek için sağlamanız için yol seçmek için Ekle düğmesini tıklatın.",
  "ChartDesignerStringIDs.EmptyDiagramHintRibbon": "Orada görselleştirmek için hiçbir veridir. Grafik görmek için geçiş yapmak için grafik Şerit sekmesi ve istenen seri türü eklemek yeni serisi galerisinden.",
  "ChartDesignerStringIDs.ErrorBarDirection_Both": "Kapat",
  "ChartDesignerStringIDs.ErrorBarDirection_Minus": "Yüksek",
  "ChartDesignerStringIDs.ErrorBarDirection_Plus": "Düşük",
  "ChartDesignerStringIDs.FibonacciArcs": "Fibonacci kemerler",
  "ChartDesignerStringIDs.FibonacciFans": "Fibonacci hayranları",
  "ChartDesignerStringIDs.Font": "Yazı tipi",
  "ChartDesignerStringIDs.Font_Bold": "Kalın",
  "ChartDesignerStringIDs.Font_Family": "Adı:",
  "ChartDesignerStringIDs.Font_Italic": "İtalik",
  "ChartDesignerStringIDs.Font_Size": "Boyut:",
  "ChartDesignerStringIDs.Indicator_Arg2ValLevel2Header": "Bitiş noktası",
  "ChartDesignerStringIDs.Indicator_AxisY": "Y Ekseni",
  "ChartDesignerStringIDs.Indicator_Color": "Renk",
  "ChartDesignerStringIDs.Indicator_ErrorBarsDirection": "Yön:",
  "ChartDesignerStringIDs.Indicator_GeneralGroupCaption": "Genel",
  "ChartDesignerStringIDs.Indicator_Thickness": "Kalınlık:",
  "ChartDesignerStringIDs.Indicator_TrendLineExtrapolateToInfinity": "Sonsuza kadar tahmin",
  "ChartDesignerStringIDs.Indicator_ValueLevel": "Değer düzeyi:",
  "ChartDesignerStringIDs.Indicator_ValueLevel1": "Değer düzeyi:",
  "ChartDesignerStringIDs.LegendOptionsRibbonCategoryTitle": "Gösterge seçenekleri",
  "ChartDesignerStringIDs.LegendOptions_Layout": "Düzen",
  "ChartDesignerStringIDs.LegendOptions_Orientation": "Yön",
  "ChartDesignerStringIDs.LegendOptions_Orientation_Horizontal": "Yatay",
  "ChartDesignerStringIDs.LegendOptions_Orientation_HorizontalDescription": "Sipariş gösterge öğeleri soldan sağa doğru.",
  "ChartDesignerStringIDs.LegendOptions_Orientation_Vertical": "Dikey",
  "ChartDesignerStringIDs.LegendOptions_ReverseItems": "Öğeleri ters",
  "ChartDesignerStringIDs.LegendOptions_SelectedLegend": "Gösterge",
  "ChartDesignerStringIDs.LegendPosition": "Pozisyon",
  "ChartDesignerStringIDs.Line2DSlideFromLeftAnimation": "Soldan Kaydır",
  "ChartDesignerStringIDs.LineFullStackedSeries2D": "Tam yığılmış çizgi 2D",
  "ChartDesignerStringIDs.LineScatterSeries2D": "Çizgi 2D dağılım",
  "ChartDesignerStringIDs.LineSeries2D": "Çizgi 2D",
  "ChartDesignerStringIDs.LineStackedSeries2D": "Çizgi 2B yığılmış",
  "ChartDesignerStringIDs.LineStepSeries2D": "Adım çizgi 2D",
  "ChartDesignerStringIDs.Marker2DModelCircle": "Daire",
  "ChartDesignerStringIDs.Marker2DModelCross": "Çapraz",
  "ChartDesignerStringIDs.Marker2DModelPlus": "Artı",
  "ChartDesignerStringIDs.Marker2DModelPolygon": "Çokgen",
  "ChartDesignerStringIDs.Marker2DModelSquare": "Kare",
  "ChartDesignerStringIDs.Marker2DModelStar": "Yıldız",
  "ChartDesignerStringIDs.Marker2DModelTriangle": "Üçgen",
  "ChartDesignerStringIDs.NewLegend": "Yeni Gösterge",
  "ChartDesignerStringIDs.NewPieTotalLabel": "Yeni pasta toplam etiket",
  "ChartDesignerStringIDs.NewStackedBarTotalLabel": "Yeni toplam etiket yığılmış",
  "ChartDesignerStringIDs.OKButtonCaption": "Tamam",
  "ChartDesignerStringIDs.OptionsAnnotation_Angle": "Açı",
  "ChartDesignerStringIDs.OptionsAnnotation_Content": "İçerik",
  "ChartDesignerStringIDs.OptionsAnnotation_RuntimeMoving": "Çalışma zamanı taşıma",
  "ChartDesignerStringIDs.OptionsAnnotation_RuntimeResizing": "Çalışma zamanı yeniden boyutlandırma",
  "ChartDesignerStringIDs.OptionsAnnotation_RuntimeRotation": "Çalışma zamanı döndürme",
  "ChartDesignerStringIDs.OptionsAnnotation_Visible": "Görünür",
  "ChartDesignerStringIDs.OptionsAxisRange_Auto": "Otomatik",
  "ChartDesignerStringIDs.OptionsAxisRange_MaxValue": "Max değeri",
  "ChartDesignerStringIDs.OptionsAxisRange_MinValue": "En küçük değer",
  "ChartDesignerStringIDs.OptionsAxis_Alignment": "Hizalama",
  "ChartDesignerStringIDs.OptionsAxis_GridLinesMinorVisible": "Kılavuz çizgileri görünür küçük",
  "ChartDesignerStringIDs.OptionsAxis_GridLinesVisible": "Kılavuz çizgileri görünür",
  "ChartDesignerStringIDs.OptionsAxis_Interlaced": "Titreşimli",
  "ChartDesignerStringIDs.OptionsAxis_Logarithmic": "Logaritmik",
  "ChartDesignerStringIDs.OptionsAxis_LogarithmicBase": "Logaritma tabanını",
  "ChartDesignerStringIDs.OptionsAxis_Reverse": "Ters çevir",
  "ChartDesignerStringIDs.OptionsAxis_TickmarksMinorVisible": "Tickmarks küçük görünür",
  "ChartDesignerStringIDs.OptionsAxis_TickmarksVisible": "Tickmarks görünür",
  "ChartDesignerStringIDs.OptionsAxis_Visible": "Görünür",
  "ChartDesignerStringIDs.OptionsAxis_VisualRange": "Görsel aralığı",
  "ChartDesignerStringIDs.OptionsAxis_WholeRange": "Tüm aralığı",
  "ChartDesignerStringIDs.OptionsChartTitle_Content": "İçerik",
  "ChartDesignerStringIDs.OptionsChartTitle_Dock": "Dok",
  "ChartDesignerStringIDs.OptionsChartTitle_HorizontalAlignment": "Yatay hizalama",
  "ChartDesignerStringIDs.OptionsChartTitle_SeriesTitleTextPattern": "Desen",
  "ChartDesignerStringIDs.OptionsChartTitle_VerticalAlignment": "Dikey hizalama",
  "ChartDesignerStringIDs.OptionsChartTitle_Visible": "Görünür",
  "ChartDesignerStringIDs.OptionsChart_AnimationMode": "Animasyon modunda",
  "ChartDesignerStringIDs.OptionsChart_AutoLayout": "Otomatik Düzen",
  "ChartDesignerStringIDs.OptionsChart_FontFamily": "Yazı tipi ailesi",
  "ChartDesignerStringIDs.OptionsChart_FontStyle": "Yazı tipi stili",
  "ChartDesignerStringIDs.OptionsChart_FontWeight": "Yazı tipi genişliği",
  "ChartDesignerStringIDs.OptionsChart_Palette": "Palet",
  "ChartDesignerStringIDs.OptionsConstantLine_Alignment": "Hizalama",
  "ChartDesignerStringIDs.OptionsConstantLine_Brush": "Fırça",
  "ChartDesignerStringIDs.OptionsConstantLine_Legend": "Gösterge",
  "ChartDesignerStringIDs.OptionsConstantLine_LegendText": "Gösterge metni",
  "ChartDesignerStringIDs.OptionsConstantLine_Value": "Değer",
  "ChartDesignerStringIDs.OptionsConstantLine_Visible": "Görünür",
  "ChartDesignerStringIDs.OptionsDiagram_DependentAxesYRange": "Bağımlı eksenleri Y aralığı",
  "ChartDesignerStringIDs.OptionsDiagram_Dimension": "Boyut",
  "ChartDesignerStringIDs.OptionsDiagram_EnableAxisXNavigation": "Eksen X gezinti etkinleştir",
  "ChartDesignerStringIDs.OptionsDiagram_EnableAxisYNavigation": "Eksen Y gezinti etkinleştir",
  "ChartDesignerStringIDs.OptionsDiagram_LayoutDirection": "Düzen Yönü",
  "ChartDesignerStringIDs.OptionsDiagram_Rotated": "döndürülmüş",
  "ChartDesignerStringIDs.OptionsDiagram_RotationDirection": "Döndürme yönünü",
  "ChartDesignerStringIDs.OptionsDiagram_RuntimeRotation": "Çalışma zamanı döndürme",
  "ChartDesignerStringIDs.OptionsDiagram_RuntimeScrolling": "Çalışma zamanı kaydırma",
  "ChartDesignerStringIDs.OptionsDiagram_RuntimeZooming": "Çalışma zamanı yakınlaştırma",
  "ChartDesignerStringIDs.OptionsDiagram_SeriesPadding": "Doldurma serisi",
  "ChartDesignerStringIDs.OptionsDiagram_ShapeStyle": "Şekil stili",
  "ChartDesignerStringIDs.OptionsDiagram_StartAngle": "Açı başlatmak",
  "ChartDesignerStringIDs.OptionsDockPanelTitle": "Seçenekler",
  "ChartDesignerStringIDs.OptionsIndicators_Argument1": "Bağımsız değişken 1",
  "ChartDesignerStringIDs.OptionsIndicators_Argument2": "Bağımsız değişken 2",
  "ChartDesignerStringIDs.OptionsIndicators_Direction": "Yön",
  "ChartDesignerStringIDs.OptionsIndicators_ExtrapolateToInfinity": "Sonsuza kadar tahmin",
  "ChartDesignerStringIDs.OptionsIndicators_Legend": "Gösterge",
  "ChartDesignerStringIDs.OptionsIndicators_LegendText": "Gösterge metni",
  "ChartDesignerStringIDs.OptionsIndicators_NegativeError": "Negatif hata",
  "ChartDesignerStringIDs.OptionsIndicators_Percent": "Yüzde",
  "ChartDesignerStringIDs.OptionsIndicators_PointsCount": "Puan sayısı",
  "ChartDesignerStringIDs.OptionsIndicators_PositiveError": "Pozitif hata",
  "ChartDesignerStringIDs.OptionsIndicators_ShowAdditionalLevels": "Ek düzeyleri göster",
  "ChartDesignerStringIDs.OptionsIndicators_ShowInLegend": "Göstergede göster",
  "ChartDesignerStringIDs.OptionsIndicators_ShowLevel0": "Düzey 0 göster",
  "ChartDesignerStringIDs.OptionsIndicators_ShowLevel100": "Seviyesi 100 göster",
  "ChartDesignerStringIDs.OptionsIndicators_SignalSmoothingPeriod": "Sinyal dönemi düzgünleştirme",
  "ChartDesignerStringIDs.OptionsIndicators_StandardDeviationMultiplier": "Standart sapma çarpanı",
  "ChartDesignerStringIDs.OptionsIndicators_SumPointsCount": "Toplam puan sayısı",
  "ChartDesignerStringIDs.OptionsIndicators_Visible": "Görünür",
  "ChartDesignerStringIDs.OptionsLegend_DockTarget": "Hedefe Bağla",
  "ChartDesignerStringIDs.OptionsLegend_HorizontalAlignment": "Yatay hizalama",
  "ChartDesignerStringIDs.OptionsLegend_HorizontalPosition": "Yatay konumu",
  "ChartDesignerStringIDs.OptionsLegend_ItemVisibilityMode": "Madde görünürlük modu",
  "ChartDesignerStringIDs.OptionsLegend_Orientation": "Yön",
  "ChartDesignerStringIDs.OptionsLegend_VerticalPosition": "Dikey konumu",
  "ChartDesignerStringIDs.OptionsLegend_Visible": "Görünür",
  "ChartDesignerStringIDs.OptionsPane_EnableAxisXNavigation": "Eksen X gezinti etkinleştir",
  "ChartDesignerStringIDs.OptionsPane_EnableAxisYNavigation": "Eksen Y gezinti etkinleştir",
  "ChartDesignerStringIDs.OptionsPieTotalLabel_Content": "İçerik",
  "ChartDesignerStringIDs.OptionsPieTotalLabel_Margin": "Kenar boşluğu",
  "ChartDesignerStringIDs.OptionsPieTotalLabel_Padding": "Doldurma",
  "ChartDesignerStringIDs.OptionsPieTotalLabel_TextPattern": "Metin desen",
  "ChartDesignerStringIDs.OptionsPieTotalLabel_Visibility": "Görünürlük",
  "ChartDesignerStringIDs.OptionsScaleBreak_Visible": "Görünür",
  "ChartDesignerStringIDs.OptionsSeries_AxisX": "X Ekseni",
  "ChartDesignerStringIDs.OptionsSeries_AxisY": "Y Ekseni",
  "ChartDesignerStringIDs.OptionsSeries_Closed": "Kapalı",
  "ChartDesignerStringIDs.OptionsSeries_ColorEach": "Her renk",
  "ChartDesignerStringIDs.OptionsSeries_DisplayName": "Görünen ad",
  "ChartDesignerStringIDs.OptionsSeries_Group": "Grup",
  "ChartDesignerStringIDs.OptionsSeries_InnerIndent": "İç girinti",
  "ChartDesignerStringIDs.OptionsSeries_InvertedStep": "Ters adım",
  "ChartDesignerStringIDs.OptionsSeries_LabelsVisibility": "Etiket görünürlüğü",
  "ChartDesignerStringIDs.OptionsSeries_Legend": "Gösterge",
  "ChartDesignerStringIDs.OptionsSeries_LevelLineLength": "Düzey satır uzunluğu",
  "ChartDesignerStringIDs.OptionsSeries_LineTension": "Satır gerginlik",
  "ChartDesignerStringIDs.OptionsSeries_Marker1Size": "İşaret 1 boyutu",
  "ChartDesignerStringIDs.OptionsSeries_Marker2Size": "İşaret 2 boyutu",
  "ChartDesignerStringIDs.OptionsSeries_MarkerSize": "İşaretçi boyutu",
  "ChartDesignerStringIDs.OptionsSeries_MaxMarkerSize": "Max işaret boyutu",
  "ChartDesignerStringIDs.OptionsSeries_MaxSize": "En büyük boyutu",
  "ChartDesignerStringIDs.OptionsSeries_Pane": "Bölme",
  "ChartDesignerStringIDs.OptionsSeries_ShowInLegend": "Göstergede göster",
  "ChartDesignerStringIDs.OptionsSeries_ShowOpenClose": "Yakın açık olanı göster",
  "ChartDesignerStringIDs.OptionsSeries_StackedGroup": "Grup yığılmış",
  "ChartDesignerStringIDs.OptionsSeries_Transparency": "Şeffaflık",
  "ChartDesignerStringIDs.OptionsSeries_Visible": "Görünür",
  "ChartDesignerStringIDs.OptionsSeries_Weight": "Ağırlık",
  "ChartDesignerStringIDs.OptionsStrip_Brush": "Fırça",
  "ChartDesignerStringIDs.OptionsStrip_Legend": "Gösterge",
  "ChartDesignerStringIDs.OptionsStrip_LegendText": "Gösterge metni",
  "ChartDesignerStringIDs.OptionsStrip_Visible": "Görünür",
  "ChartDesignerStringIDs.Options_Title": "Başlık",
  "ChartDesignerStringIDs.PanePrefix": "Bölme #",
  "ChartDesignerStringIDs.PatternEditor_CancelButtonText": "İptal",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_Currency": "Para birimi",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_Custom": "Özel",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_DateTime": "Tarih/Saat",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_Default": "Varsayılan",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_Number": "Sayı",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_Percent": "Yüzde",
  "ChartDesignerStringIDs.PatternEditor_FormatComboBox_Special": "Özel",
  "ChartDesignerStringIDs.PatternEditor_FormatLabelText": "Biçim",
  "ChartDesignerStringIDs.PatternEditor_OkButtonText": "Tamam",
  "ChartDesignerStringIDs.PatternEditor_PatternLabelText": "Desen",
  "ChartDesignerStringIDs.Pie2DZoomInAnimation": "Yakınlaştır",
  "ChartDesignerStringIDs.PieSeries2D": "Pasta 2D",
  "ChartDesignerStringIDs.PieSeries3D": "Pasta 3D",
  "ChartDesignerStringIDs.PointSeries2D": "Nokta 2D",
  "ChartDesignerStringIDs.PointSeries3D": "Nokta 3D",
  "ChartDesignerStringIDs.PolarAreaSeries2D": "Kutupsal alan 2D",
  "ChartDesignerStringIDs.PolarLineSeries2D": "2B Kutupsal Çizgi",
  "ChartDesignerStringIDs.PolarPointSeries2D": "Kutupsal nokta 2D",
  "ChartDesignerStringIDs.PrimaryAxisXName": "Birincil eksen X",
  "ChartDesignerStringIDs.PrimaryAxisYName": "Birincil eksen Y",
  "ChartDesignerStringIDs.PropertiesDockPanelTitle": "Özellikler",
  "ChartDesignerStringIDs.RadarAreaSeries2D": "Radar alanında 2D",
  "ChartDesignerStringIDs.RadarLineSeries2D": "Radar çizgi 2D",
  "ChartDesignerStringIDs.RadarPointSeries2D": "Radar nokta 2D",
  "ChartDesignerStringIDs.RangeAreaSeries2D": "Aralık alanında 2D",
  "ChartDesignerStringIDs.RangeBarOverlappedSeries2D": "Aralık çubuk 2D üst üste",
  "ChartDesignerStringIDs.RangeBarSideBySideSeries2D": "Yan yana aralığı Bar 2B",
  "ChartDesignerStringIDs.RangeControlClientAreaView": "Yeni alan görünüm",
  "ChartDesignerStringIDs.RangeControlClientBarView": "Yeni çubuğu göster",
  "ChartDesignerStringIDs.RangeControlClientLineView": "Yeni satır görünümü",
  "ChartDesignerStringIDs.RangeControlOptions": "Yeni Aralık denetimi seçenekleri",
  "ChartDesignerStringIDs.Redo": "Yinele",
  "ChartDesignerStringIDs.ScaleBreak_CategoryCaption": "Ölçek sonu seçenekleri",
  "ChartDesignerStringIDs.ScaleBreak_Edge1": "Kenar 1:",
  "ChartDesignerStringIDs.ScaleBreak_Edge2": "Kenar 2:",
  "ChartDesignerStringIDs.ScaleBreak_GeneralGroupCaption": "Genel",
  "ChartDesignerStringIDs.ScaleBreak_PageCaption": "Ölçek sonu",
  "ChartDesignerStringIDs.ScaleOptionsAutomatic": "Otomatik",
  "ChartDesignerStringIDs.ScaleOptionsContinuous": "Sürekli",
  "ChartDesignerStringIDs.ScaleOptionsManual": "Manuel",
  "ChartDesignerStringIDs.SecondaryAxisXPrefix": "İkincil ekseni X #",
  "ChartDesignerStringIDs.SecondaryAxisYPrefix": "İkincil eksen Y #",
  "ChartDesignerStringIDs.SeriesDataPanelTitle": "Veri dizisi",
  "ChartDesignerStringIDs.SeriesOptionsRibbonCategoryTitle": "Seri seçenekleri",
  "ChartDesignerStringIDs.SeriesOptions_ArgumentAxis": "Bağımsız değişken eksen:",
  "ChartDesignerStringIDs.SeriesOptions_ArgumentDataMember": "Bağımsız değişkeni:",
  "ChartDesignerStringIDs.SeriesOptions_ChartDataSource": "Grafik veri kaynağı",
  "ChartDesignerStringIDs.SeriesOptions_CloseValueDataMember": "Yakın değer:",
  "ChartDesignerStringIDs.SeriesOptions_ColorDataMember": "Renk:",
  "ChartDesignerStringIDs.SeriesOptions_ConnectorThickness": "Bağlayıcı:",
  "ChartDesignerStringIDs.SeriesOptions_DataMembersPageGroup": "Veri üyeleri",
  "ChartDesignerStringIDs.SeriesOptions_DataPage": "Veri",
  "ChartDesignerStringIDs.SeriesOptions_DataSourceNone": "Veri kaynağı yok",
  "ChartDesignerStringIDs.SeriesOptions_DataSourcePageGroup": "Veri kaynağı",
  "ChartDesignerStringIDs.SeriesOptions_FunnelOptionsGroup": "Huni",
  "ChartDesignerStringIDs.SeriesOptions_HighValueDataMember": "Yüksek değer:",
  "ChartDesignerStringIDs.SeriesOptions_Indent": "Girinti:",
  "ChartDesignerStringIDs.SeriesOptions_LabelsGroupTitle": "Etiketler",
  "ChartDesignerStringIDs.SeriesOptions_LabelsVisibility": "Etiket görünürlüğü",
  "ChartDesignerStringIDs.SeriesOptions_Labels_0DegreesCaption": "0 Derece",
  "ChartDesignerStringIDs.SeriesOptions_Labels_0DegreesDescription": "Döndürme olmadan veri etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_135DegreesCaption": "135 Derece",
  "ChartDesignerStringIDs.SeriesOptions_Labels_135DegreesDescription": "135 Derece döndürülebilir veri etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_180DegreesCaption": "180 Derece",
  "ChartDesignerStringIDs.SeriesOptions_Labels_180DegreesDescription": "180 Derece döndürülmüş veri etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_225DegreesCaption": "225 Derece",
  "ChartDesignerStringIDs.SeriesOptions_Labels_225DegreesDescription": "225 Derece döndürülebilir veri etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_270DegreesCaption": "270 Derece",
  "ChartDesignerStringIDs.SeriesOptions_Labels_270DegreesDescription": "270 Derece döndürülebilir veri etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_315DegreesCaption": "315 Derece",
  "ChartDesignerStringIDs.SeriesOptions_Labels_315DegreesDescription": "315 Derece döndürülebilir veri etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_3DTopCaption": "Üst",
  "ChartDesignerStringIDs.SeriesOptions_Labels_3DTopDescription": "Üst noktası işaretleyicilerini veri etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_45DegreesCaption": "45 Derece",
  "ChartDesignerStringIDs.SeriesOptions_Labels_45DegreesDescription": "45 Derece döndürülmüş veri etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_90DegreesCaption": "90 Derece",
  "ChartDesignerStringIDs.SeriesOptions_Labels_90DegreesDescription": "90 Derece döndürülmüş veri etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Area3DEnabledCaption": "Etkin",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Area3DEnabledDescription": "Veri etiketlerini aç.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Bar3DEnabledCaption": "Etkin",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Bar3DEnabledDescription": "Veri etiketlerini aç.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Bubble2DCenterCaption": "Merkezi",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Bubble2DCenterDescription": "Veri etiketlerini kabarcıkların ortasında göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_CenteredInBarsCaption": "Merkezi",
  "ChartDesignerStringIDs.SeriesOptions_Labels_CenteredInBarsDescription": "Veri etiketlerini çubukların ortasında göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_EnabledCaption": "Etkin",
  "ChartDesignerStringIDs.SeriesOptions_Labels_EnabledDescription": "Veri etiketlerini aç.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_FunnelCenterPointCaption": "Merkezi",
  "ChartDesignerStringIDs.SeriesOptions_Labels_FunnelLeftPointCaption": "Sol",
  "ChartDesignerStringIDs.SeriesOptions_Labels_FunnelRightPointCaption": "Sağ",
  "ChartDesignerStringIDs.SeriesOptions_Labels_InsideSlicesCaption": "İçinde",
  "ChartDesignerStringIDs.SeriesOptions_Labels_InsideSlicesDescription": "Pasta dilimi içinde veri etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Marker3DCenterCaption": "Merkezi",
  "ChartDesignerStringIDs.SeriesOptions_Labels_Marker3DCenterDescription": "Veri etiketlerini işaretleyicilerin ortasında göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_NoneCaption": "Hiçbiri",
  "ChartDesignerStringIDs.SeriesOptions_Labels_NoneDescription": "Veri etiketlerini kapat.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_OutsideCaption": "Dışarıda",
  "ChartDesignerStringIDs.SeriesOptions_Labels_OutsideDescription": "Gösteri verileri etiketleyen dış barlar.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_OutsideSlicesCaption": "Dışarıda",
  "ChartDesignerStringIDs.SeriesOptions_Labels_OutsideSlicesDescription": "Dış pasta dilimlerini veri etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_StackedBarCenteredInBarCaption": "Merkezi",
  "ChartDesignerStringIDs.SeriesOptions_Labels_StackedBarCenteredInBarDescription": "Veri etiketlerini çubukların ortasında göster.",
  "ChartDesignerStringIDs.SeriesOptions_Labels_TwoColumnsCaption": "İki sütun",
  "ChartDesignerStringIDs.SeriesOptions_Labels_TwoColumnsDescription": "İki sütun veri etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_LayoutGroup": "Düzen",
  "ChartDesignerStringIDs.SeriesOptions_LowValueDataMember": "Düşük değer:",
  "ChartDesignerStringIDs.SeriesOptions_Main": "Ana",
  "ChartDesignerStringIDs.SeriesOptions_MarkersCaption": "Görünüm",
  "ChartDesignerStringIDs.SeriesOptions_Model": "Model",
  "ChartDesignerStringIDs.SeriesOptions_NestedDonutGroup": "Grup",
  "ChartDesignerStringIDs.SeriesOptions_NestedDonutWeight": "Ağırlık",
  "ChartDesignerStringIDs.SeriesOptions_NoModelString": "Hiçbiri",
  "ChartDesignerStringIDs.SeriesOptions_OpenValueDataMember": "Açık değer:",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DMaxValueLabelPositionCaption": "Max",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DMaxValueLabelPositionDescription": "Yalnızca bir veri noktası değeri etiketi gösterin.",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DMinValueLabelPositionCaption": "Min",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DMinValueLabelPositionDescription": "Yalnızca bir veri noktası en az değer etiketi gösterin.",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DOneLabelPositionCaption": "Merkezi",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DOneLabelPositionDescription": "Minimum ve maksimum değerleri içeren aralığı alanının içinde bir etiketi gösterin.",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DTwoLabelsPositionCaption": "Her iki",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DTwoLabelsPositionDescription": "Her iki minimum ve maksimum değerler bir veri noktası etiketlerini göster.",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DValue1LabelPositionCaption": "Değer",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DValue1LabelPositionDescription": "Yalnızca ilk değeri bir veri noktası etiketini göster:.",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DValue2LabelPositionCaption": "Değer 2",
  "ChartDesignerStringIDs.SeriesOptions_RangeArea2DValue2LabelPositionDescription": "Tek bir veri noktasını ikinci değer etiketi gösterin.",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarMaxValueLabelPositionCaption": "Max",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarMaxValueLabelPositionDescription": "Sadece azami menzili bar değer etiketi gösterin.",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarMinValueLabelPositionCaption": "Min",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarMinValueLabelPositionDescription": "Sadece minimum aralığı çubuk değer etiketi gösterin.",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarOneLabelPositionCaption": "Merkez",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarOneLabelPositionDescription": "Minimum ve maksimum değerleri içeren Aralık çubuğu ortasına bir etiketi gösterin.",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarTwoLabelsLabelPositionCaption": "Her iki",
  "ChartDesignerStringIDs.SeriesOptions_RangeBarTwoLabelsLabelPositionDescription": "Her iki etiketi ile minimum ve maksimum değerleri göster.",
  "ChartDesignerStringIDs.SeriesOptions_SelectedSeries": "Seriler",
  "ChartDesignerStringIDs.SeriesOptions_SelectedSeries_View": "Görünüm",
  "ChartDesignerStringIDs.SeriesOptions_SeriesDataMember": "Serisi:",
  "ChartDesignerStringIDs.SeriesOptions_SeriesDataSource": "Seri veri kaynağı",
  "ChartDesignerStringIDs.SeriesOptions_SeriesLabelsPosition": "Etiketler",
  "ChartDesignerStringIDs.SeriesOptions_SeriesName": "Adı:",
  "ChartDesignerStringIDs.SeriesOptions_SeriesPane": "Bölme:",
  "ChartDesignerStringIDs.SeriesOptions_SeriesVisibility": "Görünürlük",
  "ChartDesignerStringIDs.SeriesOptions_Value2DataMember": "Değer 2:",
  "ChartDesignerStringIDs.SeriesOptions_ValueAxis": "Değer ekseni:",
  "ChartDesignerStringIDs.SeriesOptions_ValueDataMember": "Değer:",
  "ChartDesignerStringIDs.SeriesOptions_WeightDataMember": "Ağırlık:",
  "ChartDesignerStringIDs.SeriesTemplate": "Şablon",
  "ChartDesignerStringIDs.StandardDeviation": "Standart sapma",
  "ChartDesignerStringIDs.Stock2DExpandAnimation": "Genişlet",
  "ChartDesignerStringIDs.StockSeries2D": "Hisse senedi 2D",
  "ChartDesignerStringIDs.Strip_AxisLabelText": "Eksen metni:",
  "ChartDesignerStringIDs.Strip_Brush": "Renk",
  "ChartDesignerStringIDs.Strip_CategoryCaption": "Şerit seçenekleri",
  "ChartDesignerStringIDs.Strip_GeneralGroupCaption": "Genel",
  "ChartDesignerStringIDs.Strip_LegendText": "Gösterge metni:",
  "ChartDesignerStringIDs.Strip_MaxLimit": "Max sınırı:",
  "ChartDesignerStringIDs.Strip_MinLimit": "Dk sınırı:",
  "ChartDesignerStringIDs.Strip_PageCaption": "Şerit",
  "ChartDesignerStringIDs.Strip_TextGroupCaption": "Metin",
  "ChartDesignerStringIDs.ThicknessNone": "Hiçbiri",
  "ChartDesignerStringIDs.TreeAdditionalPanelCollection": "Ek Bölmeler",
  "ChartDesignerStringIDs.TreeAnnotationCollection": "ek açıklamaları",
  "ChartDesignerStringIDs.TreeAxesSubnode": "Eksenler",
  "ChartDesignerStringIDs.TreeAxisCustomLabelCollection": "Özel etiket",
  "ChartDesignerStringIDs.TreeChart": "Grafik",
  "ChartDesignerStringIDs.TreeConstantLineCollection": "Sabit Çizgiler",
  "ChartDesignerStringIDs.TreeDiagramPolarDiagram2D": "Kutup diyagramı",
  "ChartDesignerStringIDs.TreeDiagramRadarDiagram2D": "Radar diyagramı",
  "ChartDesignerStringIDs.TreeDiagramSimpleDiagram2D": "Basit diyagramı",
  "ChartDesignerStringIDs.TreeDiagramSimpleDiagram3D": "3D basit diyagramı",
  "ChartDesignerStringIDs.TreeDiagramXYDiagram2D": "Kartezyen diyagramı",
  "ChartDesignerStringIDs.TreeDiagramXYDiagram3D": "3B Kartezyen diyagramı",
  "ChartDesignerStringIDs.TreeIndicatorCollection": "Göstergeler",
  "ChartDesignerStringIDs.TreeLegend": "Gösterge",
  "ChartDesignerStringIDs.TreePaneTitleModel": "Başlık",
  "ChartDesignerStringIDs.TreePanesSubnode": "bölmeleri",
  "ChartDesignerStringIDs.TreePieTotalLabelModel": "Pasta toplam etiket",
  "ChartDesignerStringIDs.TreePrimaryAxisX": "Birincil eksen X",
  "ChartDesignerStringIDs.TreePrimaryAxisY": "Birincil eksen Y",
  "ChartDesignerStringIDs.TreeSecondaryAxesCollectionX": "İkincil eksenler X",
  "ChartDesignerStringIDs.TreeSecondaryAxesCollectionY": "İkincil eksenleri Y",
  "ChartDesignerStringIDs.TreeSeries": "Seriler",
  "ChartDesignerStringIDs.TreeSeriesCollection": "Seri Koleksiyonu",
  "ChartDesignerStringIDs.TreeStackedBarTotalLabelModel": "Toplam etiket yığılmış",
  "ChartDesignerStringIDs.TreeStripCollectionModel": "Şeritler",
  "ChartDesignerStringIDs.TreeStripModel": "Şerit",
  "ChartDesignerStringIDs.TreeTitle": "Başlık",
  "ChartDesignerStringIDs.TreeTitleCollection": "Başlık Koleksiyonu",
  "ChartDesignerStringIDs.Undo": "Geri Al",
  "ChartDesignerStringIDs.ValueLevel_Close": "Kapat",
  "ChartDesignerStringIDs.ValueLevel_High": "Yüksek",
  "ChartDesignerStringIDs.ValueLevel_Low": "Düşük",
  "ChartDesignerStringIDs.ValueLevel_Open": "Aç",
  "ChartDesignerStringIDs.ValueLevel_Value": "Değer",
  "DevExpress.XtraPrinting.ActionAfterExport.AskUser": "Kullanıcıya Sor",
  "DevExpress.XtraPrinting.ActionAfterExport.None": "Hiçbiri",
  "DevExpress.XtraPrinting.ActionAfterExport.Open": "Aç",
  "DevExpress.XtraPrinting.BarCode.BarCodeGeneratorBase.CalcCheckSum": "Sağlamayı Hesapla",
  "DevExpress.XtraPrinting.BarCode.BarCodeOrientation.Normal": "Normal",
  "DevExpress.XtraPrinting.BarCode.BarCodeOrientation.RotateLeft": "Sola Döndür",
  "DevExpress.XtraPrinting.BarCode.BarCodeOrientation.RotateRight": "Sağa Döndür",
  "DevExpress.XtraPrinting.BarCode.BarCodeOrientation.UpsideDown": "Alt-Üst",
  "DevExpress.XtraPrinting.BarCode.CodabarGenerator.StartStopPair": "Başlat ve Durdur Sembolleri",
  "DevExpress.XtraPrinting.BarCode.CodabarGenerator.WideNarrowRatio": "Geniş Dar Oranı",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopPair.AT": "AT",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopPair.BN": "BN",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopPair.CStar": "CStar",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopPair.DE": "DE",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopPair.None": "Hiçbiri",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopSymbol.A": "A",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopSymbol.B": "B",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopSymbol.C": "C",
  "DevExpress.XtraPrinting.BarCode.CodabarStartStopSymbol.None": "Hiçbiri",
  "DevExpress.XtraPrinting.BarCode.Code128Charset.CharsetA": "A Karakter Seti",
  "DevExpress.XtraPrinting.BarCode.Code128Charset.CharsetAuto": "Otomatik Karakter Seti",
  "DevExpress.XtraPrinting.BarCode.Code128Charset.CharsetB": "B Karakter Seti",
  "DevExpress.XtraPrinting.BarCode.Code128Charset.CharsetC": "C Karakter Seti",
  "DevExpress.XtraPrinting.BarCode.Code128Generator.CharacterSet": "Karakter Seti",
  "DevExpress.XtraPrinting.BarCode.Code39Generator.WideNarrowRatio": "Geniş Dar Oranı",
  "DevExpress.XtraPrinting.BarCode.CodeMSIGenerator.MSICheckSum": "MSI Sağlaması",
  "DevExpress.XtraPrinting.BarCode.DataBarGenerator.FNC1Substitute": "FNC1 işlev karakter",
  "DevExpress.XtraPrinting.BarCode.DataBarGenerator.SegmentsInRow": "Segment satırı",
  "DevExpress.XtraPrinting.BarCode.DataBarGenerator.Type": "Türü",
  "DevExpress.XtraPrinting.BarCode.DataBarType.Expanded": "Genişletilmiş",
  "DevExpress.XtraPrinting.BarCode.DataBarType.ExpandedStacked": "Yığılmış genişletilmiş",
  "DevExpress.XtraPrinting.BarCode.DataBarType.Limited": "Sınırlı",
  "DevExpress.XtraPrinting.BarCode.DataBarType.Omnidirectional": "Çok Yönlü",
  "DevExpress.XtraPrinting.BarCode.DataBarType.Stacked": "Yığılmış",
  "DevExpress.XtraPrinting.BarCode.DataBarType.StackedOmnidirectional": "Çok Yönlü Yığılmış",
  "DevExpress.XtraPrinting.BarCode.DataBarType.Truncated": "Kesilmiş",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.ASCII": "ASCII",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.Binary": "İkili",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.C40": "C40",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.Edifact": "EDIFACT",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.Text": "Metin",
  "DevExpress.XtraPrinting.BarCode.DataMatrixCompactionMode.X12": "X 12",
  "DevExpress.XtraPrinting.BarCode.DataMatrixGS1Generator.FNC1Substitute": "FNC1 işlev karakter",
  "DevExpress.XtraPrinting.BarCode.DataMatrixGS1Generator.HumanReadableText": "Okunabilir metin",
  "DevExpress.XtraPrinting.BarCode.DataMatrixGenerator.CompactionMode": "Sıkışma Oranı",
  "DevExpress.XtraPrinting.BarCode.DataMatrixGenerator.MatrixSize": "Matris Boyu",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix104x104": "104 x 104",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix10x10": "10 x 10",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix120x120": "120 x 120",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix12x12": "12 x 12",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix12x26": "12 x 26",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix12x36": "12 x 36",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix132x132": "132 x 132",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix144x144": "144 x 144",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix14x14": "14 x 14",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix16x16": "16 x 16",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix16x36": "16 x 36",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix16x48": "16 x 48",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix18x18": "18 x 18",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix20x20": "20 x 20",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix22x22": "22 x 22",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix24x24": "24 x 24",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix26x26": "26 x 26",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix32x32": "32 x 32",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix36x36": "36 x 36",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix40x40": "40 x 40",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix44x44": "44 x 44",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix48x48": "48 x 48",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix52x52": "52 x 52",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix64x64": "64 x 64",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix72x72": "72 x 72",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix80x80": "80 x 80",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix88x88": "88 x 88",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix8x18": "8 x 18",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix8x32": "8 x 32",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.Matrix96x96": "96 x 96",
  "DevExpress.XtraPrinting.BarCode.DataMatrixSize.MatrixAuto": "Oto",
  "DevExpress.XtraPrinting.BarCode.EAN128Generator.FNC1Substitute": "FNC1 Fonksiyonel Karakter",
  "DevExpress.XtraPrinting.BarCode.EAN128Generator.HumanReadableText": "Okunabilir Metin",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level0": "Seviye 0",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level1": "Seviye 1",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level2": "Seviye 2",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level3": "Seviye 3",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level4": "Seviye 4",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level5": "Seviye 5",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level6": "Seviye 6",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level7": "Seviye 7",
  "DevExpress.XtraPrinting.BarCode.ErrorCorrectionLevel.Level8": "Seviye 8",
  "DevExpress.XtraPrinting.BarCode.ITF14Generator.WideNarrowRatio": "Geniş Dar Oranı",
  "DevExpress.XtraPrinting.BarCode.Industrial2of5Generator.WideNarrowRatio": "Geniş Dar Oranı",
  "DevExpress.XtraPrinting.BarCode.Interleaved2of5Generator.WideNarrowRatio": "Geniş Dar Oranı",
  "DevExpress.XtraPrinting.BarCode.MSICheckSum.DoubleModulo10": "Mod 10 10",
  "DevExpress.XtraPrinting.BarCode.MSICheckSum.Modulo10": "Mod 10",
  "DevExpress.XtraPrinting.BarCode.MSICheckSum.None": "Hiçbiri",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.Codabar": "Codabar",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.DataBar": "DataBar",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.DataMatrix": "Data Matrix",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.EAN128": "EAN 128",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.EAN13": "EAN 13",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.EAN8": "EAN 8",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.ITF14": "ITF 14",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.PDF417": "PDF 417",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.PostNet": "PostNet",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.UPCA": "UPC A",
  "DevExpress.XtraPrinting.BarCode.Native.BarCodeSymbology.UPCE1": "UPC E1",
  "DevExpress.XtraPrinting.BarCode.PDF417CompactionMode.Binary": "İkili",
  "DevExpress.XtraPrinting.BarCode.PDF417CompactionMode.Text": "Metin",
  "DevExpress.XtraPrinting.BarCode.PDF417Generator.Columns": "Sütunlar",
  "DevExpress.XtraPrinting.BarCode.PDF417Generator.CompactionMode": "Sıkışma Modu",
  "DevExpress.XtraPrinting.BarCode.PDF417Generator.ErrorCorrectionLevel": "Hata Düzeltme Seviyesi",
  "DevExpress.XtraPrinting.BarCode.PDF417Generator.Rows": "Satırlar",
  "DevExpress.XtraPrinting.BarCode.PDF417Generator.TruncateSymbol": "Kesme İşareti",
  "DevExpress.XtraPrinting.BarCode.PDF417Generator.YToXRatio": "Y/X Oranı",
  "DevExpress.XtraPrinting.BarCode.QRCodeCompactionMode.AlphaNumeric": "Alfa Nümerik",
  "DevExpress.XtraPrinting.BarCode.QRCodeCompactionMode.Byte": "Bayt",
  "DevExpress.XtraPrinting.BarCode.QRCodeCompactionMode.Numeric": "Rakamsal",
  "DevExpress.XtraPrinting.BarCode.QRCodeErrorCorrectionLevel.H": "H",
  "DevExpress.XtraPrinting.BarCode.QRCodeErrorCorrectionLevel.L": "L",
  "DevExpress.XtraPrinting.BarCode.QRCodeErrorCorrectionLevel.M": "M",
  "DevExpress.XtraPrinting.BarCode.QRCodeErrorCorrectionLevel.Q": "Q",
  "DevExpress.XtraPrinting.BarCode.QRCodeGenerator.CompactionMode": "Sıkışma Modu",
  "DevExpress.XtraPrinting.BarCode.QRCodeGenerator.ErrorCorrectionLevel": "Hata Düzeltme Seviyesi",
  "DevExpress.XtraPrinting.BarCode.QRCodeGenerator.Version": "Versiyon",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.AutoVersion": "Versiyonu Otomatik Seç",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version1": "Versiyon 1 (21x21)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version10": "Versiyon 10 (57x57)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version11": "Versiyon 11 (61x61)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version12": "Versiyon 12 (65x65)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version13": "Versiyon 13 (69x69)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version14": "Versiyon 14 (73x73)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version15": "Versiyon 15 (77x77)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version16": "Versiyon 16 (81x81)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version17": "Versiyon 17 (85x85)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version18": "Versiyon 18 (89x89)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version19": "Versiyon 19 (93x93)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version2": "Versiyon 2 (25x25)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version20": "Versiyon 20 (97x97)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version21": "Versiyon 21 (101x101)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version22": "Versiyon 22 (105x105)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version23": "Versiyon 23 (109x109)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version24": "Versiyon 24 (113x113)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version25": "Versiyon 25 (117x117)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version26": "Versiyon 26 (121x121)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version27": "Versiyon 27 (125x125)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version28": "Versiyon 28 (129x129)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version29": "Versiyon 29 (133x133)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version3": "Versiyon 3 (29x29)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version30": "Versiyon 30 (137x137)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version31": "Versiyon 31 (141x141)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version32": "Versiyon 32 (145x145)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version33": "Versiyon 33 (149x149)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version34": "Versiyon 34 (153x153)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version35": "Versiyon 35 (157x157)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version36": "Versiyon 36 (161x161)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version37": "Versiyon 37 (165x165)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version38": "Versiyon 38 (169x169)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version39": "Versiyon 39 (173x173)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version4": "Versiyon 4 (33x33)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version40": "Versiyon 40 (177x177)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version5": "Versiyon 5 (37x37)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version6": "Versiyon 6 (41x41)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version7": "Versiyon 7 (45x45)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version8": "Versiyon 8 (49x49)",
  "DevExpress.XtraPrinting.BarCode.QRCodeVersion.Version9": "Versiyon 9 (53x53)",
  "DevExpress.XtraPrinting.BarCode.QRFrameOptions.Padding": "Doldurma",
  "DevExpress.XtraPrinting.BarCode.QRFrameOptions.Text": "Metin",
  "DevExpress.XtraPrinting.BarCode.QRFrameOptions.TextAlignment": "Metin hizalama",
  "DevExpress.XtraPrinting.BarCode.QRFrameOptions.TextColor": "Metin rengi",
  "DevExpress.XtraPrinting.BarCode.QRFrameTextAlignment.Center": "Merkezi",
  "DevExpress.XtraPrinting.BarCode.QRFrameTextPosition.Bottom": "Alt",
  "DevExpress.XtraPrinting.BarCode.QRFrameTextPosition.Left": "Sol",
  "DevExpress.XtraPrinting.BarCode.QRFrameTextPosition.Right": "Sağ",
  "DevExpress.XtraPrinting.BarCode.QRFrameTextPosition.Top": "Üst",
  "DevExpress.XtraPrinting.BarCode.RectangleQRFrameOptions": "Dikdörtgen",
  "DevExpress.XtraPrinting.ChangingPermissions.AnyExceptExtractingPages": "Sayfaları çıkarmak dışında herhangi biri",
  "DevExpress.XtraPrinting.ChangingPermissions.CommentingFillingSigning": "Yorum, Form Doldurma, İmzalama",
  "DevExpress.XtraPrinting.ChangingPermissions.FillingSigning": "Form Doldurma, İmzalama",
  "DevExpress.XtraPrinting.ChangingPermissions.InsertingDeletingRotating": "Ekleme, Çıkarma, Döndürme",
  "DevExpress.XtraPrinting.ChangingPermissions.None": "Hiçbiri",
  "DevExpress.XtraPrinting.ColumnLayout.AcrossThenDown": "Önce Yatay Sonra Aşağı",
  "DevExpress.XtraPrinting.ColumnLayout.DownThenAcross": "Önce Aşağı Sonra Yatay",
  "DevExpress.XtraPrinting.CsvExportOptions": "CSV Aktarım Seçenekleri",
  "DevExpress.XtraPrinting.CsvExportOptions.SkipEmptyColumns": "Boş sütunları geç",
  "DevExpress.XtraPrinting.CsvExportOptions.SkipEmptyRows": "Boş satırları geç",
  "DevExpress.XtraPrinting.DocxDocumentOptions.Author": "Yazar",
  "DevExpress.XtraPrinting.DocxDocumentOptions.Category": "Kategori",
  "DevExpress.XtraPrinting.DocxDocumentOptions.Comments": "Yorumlar",
  "DevExpress.XtraPrinting.DocxDocumentOptions.Subject": "Konu",
  "DevExpress.XtraPrinting.DocxDocumentOptions.Title": "Başlık",
  "DevExpress.XtraPrinting.DocxExportMode.SingleFile": "Tek Dosya",
  "DevExpress.XtraPrinting.DocxExportMode.SingleFilePageByPage": "Tek Dosya (Sayfa Başına)",
  "DevExpress.XtraPrinting.DocxExportOptions.ExportMode": "Mod verme",
  "DevExpress.XtraPrinting.Drawing.DirectionMode.BackwardDiagonal": "Geri Köşegen",
  "DevExpress.XtraPrinting.Drawing.DirectionMode.ForwardDiagonal": "İleri Köşegen",
  "DevExpress.XtraPrinting.Drawing.DirectionMode.Horizontal": "Yatay",
  "DevExpress.XtraPrinting.Drawing.DirectionMode.Vertical": "Dikey",
  "DevExpress.XtraPrinting.Drawing.ImageViewMode.Clip": "Kırp",
  "DevExpress.XtraPrinting.Drawing.ImageViewMode.Stretch": "Uzat",
  "DevExpress.XtraPrinting.Drawing.ImageViewMode.Zoom": "Yakınlaştır",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.Font": "Yazı Tipi",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.ForeColor": "Önplan Rengi",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.ImageTiling": "Resim Döşeme",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.ImageTransparency": "Resim Saydamlığı",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.ImageViewMode": "Resim Görüntüleme Modu",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.ShowBehind": "Arkayı Göster",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.Text": "Yazı",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.TextDirection": "Yazı Yönü",
  "DevExpress.XtraPrinting.Drawing.PageWatermark.TextTransparency": "Yazı Saydamlığı",
  "DevExpress.XtraPrinting.Drawing.Watermark.Id": "Id",
  "DevExpress.XtraPrinting.Drawing.Watermark.PageRange": "Sayfa Aralığı",
  "DevExpress.XtraPrinting.EmailOptions": "E-posta Seçenekleri",
  "DevExpress.XtraPrinting.EmailOptions.Body": "Gövde",
  "DevExpress.XtraPrinting.EmailOptions.RecipientAddress": "Alıcı Adresi",
  "DevExpress.XtraPrinting.EmailOptions.RecipientAddressPrefix": "Alıcı Adresi Önek",
  "DevExpress.XtraPrinting.EmailOptions.RecipientName": "Alıcı Adı",
  "DevExpress.XtraPrinting.EmailOptions.Subject": "Konu",
  "DevExpress.XtraPrinting.ExportOptions": "Dışarı Aktarım Seçenekleri",
  "DevExpress.XtraPrinting.FormattedTextExportOptions.EmptyFirstPageHeaderFooter": "Boş ilk sayfa üstbilgisi/altbilgisi",
  "DevExpress.XtraPrinting.FormattedTextExportOptions.ExportWatermarks": "Filigranları Aktar",
  "DevExpress.XtraPrinting.FormattedTextExportOptions.KeepRowHeight": "Satır Yüksekliğini Koru",
  "DevExpress.XtraPrinting.FormattedTextExportOptions.PageRange": "Sayfa Aralığı",
  "DevExpress.XtraPrinting.GlyphStyle.Star": "Yıldız",
  "DevExpress.XtraPrinting.HtmlExportMode.DifferentFiles": "Farklı Dosyalar",
  "DevExpress.XtraPrinting.HtmlExportMode.SingleFile": "Tek Dosya",
  "DevExpress.XtraPrinting.HtmlExportMode.SingleFilePageByPage": "Tek Dosya (Sayfa Başına)",
  "DevExpress.XtraPrinting.HtmlExportOptions": "HTML Aktarım Seçenekleri",
  "DevExpress.XtraPrinting.HtmlExportOptions.EmbedImagesInHTML": "Resimleri HTML'e Göm",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.CharacterSet": "Karakter Seti",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.ExportMode": "Aktarım Modu",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.InlineCss": "Satır İçi CSS",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.PageBorderColor": "Sayfa Çerçeve Rengi",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.PageBorderWidth": "Sayfa Çerçeve Kalınlığı",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.PageRange": "Sayfa Aralığı",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.RemoveSecondarySymbols": "İkincil Sembolleri Kaldır",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.TableLayout": "Tablo Düzeni",
  "DevExpress.XtraPrinting.HtmlExportOptionsBase.Title": "Başlık",
  "DevExpress.XtraPrinting.ImageExportMode.DifferentFiles": "Farklı Dosyalar",
  "DevExpress.XtraPrinting.ImageExportMode.SingleFile": "Tek Dosya",
  "DevExpress.XtraPrinting.ImageExportMode.SingleFilePageByPage": "Tek Dosya (Sayfa Başına)",
  "DevExpress.XtraPrinting.ImageExportOptions": "Resim Aktarım Seçenekleri",
  "DevExpress.XtraPrinting.ImageExportOptions.ExportMode": "Aktarım Modu",
  "DevExpress.XtraPrinting.ImageExportOptions.Format": "Biçim",
  "DevExpress.XtraPrinting.ImageExportOptions.PageBorderColor": "Sayfa Çerçeve Rengi",
  "DevExpress.XtraPrinting.ImageExportOptions.PageBorderWidth": "Sayfa Çerçeve Kalınlığı",
  "DevExpress.XtraPrinting.ImageExportOptions.PageRange": "Sayfa Aralığı",
  "DevExpress.XtraPrinting.ImageExportOptions.Resolution": "Çözünürlük",
  "DevExpress.XtraPrinting.ImageItem.Id": "Id",
  "DevExpress.XtraPrinting.MailMessageExportOptions": "Posta iletisi dışa aktarma seçenekleri",
  "DevExpress.XtraPrinting.MhtExportOptions": "MHT Aktarım Seçenekleri",
  "DevExpress.XtraPrinting.NativeFormatOptions": "Asıl Biçim Seçenekleri",
  "DevExpress.XtraPrinting.NativeFormatOptions.Compressed": "Sıkıştırılmış",
  "DevExpress.XtraPrinting.NativeFormatOptions.ShowOptionsBeforeSave": "Kaydetmeden Önce Seçenekleri Göster",
  "DevExpress.XtraPrinting.PageByPageExportOptionsBase.PageRange": "Sayfa Aralığı",
  "DevExpress.XtraPrinting.PageByPageExportOptionsBase.RasterizationResolution": "Rasterleştirme çözünürlük",
  "DevExpress.XtraPrinting.PdfACompatibility.None": "Hiçbiri",
  "DevExpress.XtraPrinting.PdfACompatibility.PdfA1b": "PDF/A-1b",
  "DevExpress.XtraPrinting.PdfACompatibility.PdfA2b": "PDF/A-2b",
  "DevExpress.XtraPrinting.PdfACompatibility.PdfA3b": "PDF/A-3b",
  "DevExpress.XtraPrinting.PdfDocumentOptions": "PDF Doküman Seçenekleri",
  "DevExpress.XtraPrinting.PdfDocumentOptions.Application": "Uygulama",
  "DevExpress.XtraPrinting.PdfDocumentOptions.Author": "Yazar",
  "DevExpress.XtraPrinting.PdfDocumentOptions.Keywords": "Anahtar Kelimeler",
  "DevExpress.XtraPrinting.PdfDocumentOptions.Subject": "Konu",
  "DevExpress.XtraPrinting.PdfDocumentOptions.Title": "Başlık",
  "DevExpress.XtraPrinting.PdfExportOptions": "PDF Aktarma Seçenekleri",
  "DevExpress.XtraPrinting.PdfExportOptions.Attachments": "Ekler",
  "DevExpress.XtraPrinting.PdfExportOptions.Compressed": "Sıkıştırılmış",
  "DevExpress.XtraPrinting.PdfExportOptions.ConvertImagesToJpeg": "Resimleri JPEG'e Dönüştür",
  "DevExpress.XtraPrinting.PdfExportOptions.DocumentOptions": "Doküman Seçenekleri",
  "DevExpress.XtraPrinting.PdfExportOptions.ImageQuality": "Resim Kalitesi",
  "DevExpress.XtraPrinting.PdfExportOptions.NeverEmbeddedFonts": "Gömülü Yazı Tipi Kullanma",
  "DevExpress.XtraPrinting.PdfExportOptions.PasswordSecurityOptions": "GüvenlikSeçenekleri",
  "DevExpress.XtraPrinting.PdfExportOptions.ShowPrintDialogOnOpen": "Açılışta yazdırma dialogunu göster",
  "DevExpress.XtraPrinting.PdfExportOptions.SignatureOptions": "İmza seçenekleri",
  "DevExpress.XtraPrinting.PdfJpegImageQuality.High": "Yüksek",
  "DevExpress.XtraPrinting.PdfJpegImageQuality.Highest": "En Yüksek",
  "DevExpress.XtraPrinting.PdfJpegImageQuality.Low": "Düşük",
  "DevExpress.XtraPrinting.PdfJpegImageQuality.Lowest": "En Düşük",
  "DevExpress.XtraPrinting.PdfJpegImageQuality.Medium": "Orta",
  "DevExpress.XtraPrinting.PdfPasswordSecurityOptions": "Pdf Şifre Güvenlik Seçenekleri",
  "DevExpress.XtraPrinting.PdfPasswordSecurityOptions.OpenPassword": "AçmaŞifresi",
  "DevExpress.XtraPrinting.PdfPasswordSecurityOptions.PermissionsOptions": "İzinSeçenekleri",
  "DevExpress.XtraPrinting.PdfPasswordSecurityOptions.PermissionsPassword": "İzinŞifresi",
  "DevExpress.XtraPrinting.PdfPermissionsOptions": "Pdf İzin Seçenekleri",
  "DevExpress.XtraPrinting.PdfPermissionsOptions.ChangingPermissions": "Değişiklikİzinleri",
  "DevExpress.XtraPrinting.PdfPermissionsOptions.EnableCopying": "KopayalamayaİzinVer",
  "DevExpress.XtraPrinting.PdfPermissionsOptions.EnableScreenReaders": "EkranOkuyucularaİzinVer",
  "DevExpress.XtraPrinting.PdfPermissionsOptions.PrintingPermissions": "Yazdırmaİzinleri",
  "DevExpress.XtraPrinting.PdfUACompatibility.None": "Hiçbiri",
  "DevExpress.XtraPrinting.PrintPreviewOptions": "Yazdırma Önizleme Seçenekleri",
  "DevExpress.XtraPrinting.PrintPreviewOptions.ActionAfterExport": "Aktarımdan Sonraki İşlem",
  "DevExpress.XtraPrinting.PrintPreviewOptions.DefaultDirectory": "Varsayılan Dizin",
  "DevExpress.XtraPrinting.PrintPreviewOptions.DefaultExportFormat": "Varsayılan Aktarım Biçimi",
  "DevExpress.XtraPrinting.PrintPreviewOptions.DefaultFileName": "Varsayılan Dosya Adı",
  "DevExpress.XtraPrinting.PrintPreviewOptions.DefaultSendFormat": "Varsayılan Gönderim Biçimi",
  "DevExpress.XtraPrinting.PrintPreviewOptions.SaveMode": "Kaydetme Modu",
  "DevExpress.XtraPrinting.PrintPreviewOptions.ShowOptionsBeforeExport": "Aktarımdan Önce Seçenekleri Göster",
  "DevExpress.XtraPrinting.PrinterSettingsUsing": "Yazıcı Ayarları Kullanımı",
  "DevExpress.XtraPrinting.PrinterSettingsUsing.UseLandscape": "Yatay(Landscape) Kullanımı",
  "DevExpress.XtraPrinting.PrinterSettingsUsing.UsePaperKind": "Kağıt Türü Kullanımı",
  "DevExpress.XtraPrinting.PrintingPermissions.HighResolution": "Yüksek Çözünürlük",
  "DevExpress.XtraPrinting.PrintingPermissions.LowResolution": "Düşük Çözünürlük",
  "DevExpress.XtraPrinting.PrintingPermissions.None": "Hiçbiri",
  "DevExpress.XtraPrinting.Recipient.Address": "Adres",
  "DevExpress.XtraPrinting.Recipient.ContactName": "Kişi Adı",
  "DevExpress.XtraPrinting.Recipient.FieldType": "Alan Türü",
  "DevExpress.XtraPrinting.Recipient.Prefix": "Önek",
  "DevExpress.XtraPrinting.RecipientFieldType.BCC": "BCC",
  "DevExpress.XtraPrinting.RecipientFieldType.CC": "CC",
  "DevExpress.XtraPrinting.RtfExportMode.SingleFile": "Tek Dosya",
  "DevExpress.XtraPrinting.RtfExportMode.SingleFilePageByPage": "Tek Dosya (Sayfa Başına)",
  "DevExpress.XtraPrinting.RtfExportOptions": "RTF Aktarım Seçenekleri",
  "DevExpress.XtraPrinting.RtfExportOptions.ExportMode": "Aktarım Modu",
  "DevExpress.XtraPrinting.SaveMode.UsingDefaultPath": "Varsayılan Adresi Kullanarak",
  "DevExpress.XtraPrinting.SaveMode.UsingSaveFileDialog": "Dosya Kaydet Dialogunu Kullanarak",
  "DevExpress.XtraPrinting.Shape.FilletShapeBase.Fillet": "Şerit",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Arrow": "Ok",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.BackslantLine": "Backslant Çizgisi",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.BottomArrow": "Alt Ok",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Brace": "Çengelli Parantez",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Bracket": "Köşeli Parantez",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Cross": "Çarpı",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.EightPointStar": "8-Nokta Yıldız",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Ellipse": "Elips",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.FivePointStar": "5-Nokta Yıldız",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.FourPointStar": "4-Nokta Yıldız",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Hexagon": "Altıgen",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.HorizontalLine": "Yatay Çizgi",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.LeftArrow": "Sol Ok",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Line": "Çizgi",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Octagon": "Sekizgen",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Pentagon": "Beşgen",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Polygon": "Çokgen",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Rectangle": "Dikdörtgen",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.RightArrow": "Sağ Ok",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.SixPointStar": "6-Nokta Yıldız",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.SlantLine": "Slant Çizgisi",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Square": "Kare",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Star": "Yıldız",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.ThreePointStar": "3-Nokta Yıldız",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.TopArrow": "Üst Ok",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.Triangle": "Üçgen",
  "DevExpress.XtraPrinting.Shape.Native.ShapeId.VerticalLine": "Dikey Çizgi",
  "DevExpress.XtraPrinting.Shape.ShapeArrow.ArrowHeight": "Ok Yüksekliği",
  "DevExpress.XtraPrinting.Shape.ShapeArrow.ArrowWidth": "Ok Genişliği",
  "DevExpress.XtraPrinting.Shape.ShapeBrace.Fillet": "Şerit",
  "DevExpress.XtraPrinting.Shape.ShapeBrace.TailLength": "Kuyruk Uzunluğu",
  "DevExpress.XtraPrinting.Shape.ShapeBracket.TipLength": "Uç Uzunluğu",
  "DevExpress.XtraPrinting.Shape.ShapeCross.HorizontalLineWidth": "Yatay Çizgi Genişliği",
  "DevExpress.XtraPrinting.Shape.ShapeCross.VerticalLineWidth": "Dikey Çizgi Genişliği",
  "DevExpress.XtraPrinting.Shape.ShapePolygon.NumberOfSides": "Taraf Sayısı",
  "DevExpress.XtraPrinting.Shape.ShapeStar.Concavity": "İçbükeylik",
  "DevExpress.XtraPrinting.Shape.ShapeStar.StarPointCount": "Yıldız Nokta Sayısı",
  "DevExpress.XtraPrinting.SignatureImageDisplayMode.Hide": "Gizle",
  "DevExpress.XtraPrinting.SignatureImageDisplayMode.Show": "Göster",
  "DevExpress.XtraPrinting.SizeMode.AutoHeight": "Otomatik yükseklik",
  "DevExpress.XtraPrinting.SizeMode.AutoSize": "Otomatik boyut",
  "DevExpress.XtraPrinting.SizeMode.Custom": "Özel",
  "DevExpress.XtraPrinting.TextExportMode.Text": "Yazı",
  "DevExpress.XtraPrinting.TextExportMode.Value": "Değer",
  "DevExpress.XtraPrinting.TextExportOptions": "Metin Aktarma Seçenekleri",
  "DevExpress.XtraPrinting.TextExportOptionsBase.Encoding": "Dil Kodlaması",
  "DevExpress.XtraPrinting.TextExportOptionsBase.QuoteStringsWithSeparators": "String'leri Ayraçla Alıntıla",
  "DevExpress.XtraPrinting.TextExportOptionsBase.Separator": "Ayraç",
  "DevExpress.XtraPrinting.TextExportOptionsBase.TextExportMode": "Metin Aktarım Modu",
  "DevExpress.XtraPrinting.XlDocumentOptions": "Excel belge seçenekleri",
  "DevExpress.XtraPrinting.XlDocumentOptions.Application": "Uygulama",
  "DevExpress.XtraPrinting.XlDocumentOptions.Author": "Yazar",
  "DevExpress.XtraPrinting.XlDocumentOptions.Category": "Kategori",
  "DevExpress.XtraPrinting.XlDocumentOptions.Comments": "Yorumlar",
  "DevExpress.XtraPrinting.XlDocumentOptions.Company": "Şirket",
  "DevExpress.XtraPrinting.XlDocumentOptions.Subject": "Konu",
  "DevExpress.XtraPrinting.XlDocumentOptions.Tags": "Etiketler",
  "DevExpress.XtraPrinting.XlDocumentOptions.Title": "Başlık",
  "DevExpress.XtraPrinting.XlEncryptionOptions": "Excel şifreleme seçenekleri",
  "DevExpress.XtraPrinting.XlEncryptionOptions.Password": "Şifre",
  "DevExpress.XtraPrinting.XlEncryptionOptions.Type": "Türü",
  "DevExpress.XtraPrinting.XlEncryptionType.Compatible": "Uyumlu",
  "DevExpress.XtraPrinting.XlEncryptionType.Strong": "Güçlü",
  "DevExpress.XtraPrinting.XlExportOptionsBase.IgnoreErrors": "Hataları Yoksay",
  "DevExpress.XtraPrinting.XlIgnoreErrors.None": "Hiçbiri",
  "DevExpress.XtraPrinting.XlsExportMode.DifferentFiles": "Farklı Dosyalar",
  "DevExpress.XtraPrinting.XlsExportMode.SingleFile": "Tek Dosya",
  "DevExpress.XtraPrinting.XlsExportMode.SingleFilePageByPage": "Tek Dosya (Sayfa Başına)",
  "DevExpress.XtraPrinting.XlsExportOptions": "XLS Aktarma Seçenekleri",
  "DevExpress.XtraPrinting.XlsExportOptions.DocumentOptions": "Belge Seçenekleri",
  "DevExpress.XtraPrinting.XlsExportOptions.ExportHyperlinks": "Hyperlink'leri Aktar",
  "DevExpress.XtraPrinting.XlsExportOptions.ExportMode": "Aktarım Modu",
  "DevExpress.XtraPrinting.XlsExportOptions.PageRange": "Sayfa Aralığı",
  "DevExpress.XtraPrinting.XlsExportOptions.RawDataMode": "Ham veri modu",
  "DevExpress.XtraPrinting.XlsExportOptions.SheetName": "Sayfa Adı",
  "DevExpress.XtraPrinting.XlsExportOptions.ShowGridLines": "Grid Çizgilerini Göster",
  "DevExpress.XtraPrinting.XlsExportOptions.Suppress256ColumnsWarning": "256 Sütun Uyarısını Gözardı Et",
  "DevExpress.XtraPrinting.XlsExportOptions.Suppress65536RowsWarning": "65536 Satır Uyarısını Gözardı Et",
  "DevExpress.XtraPrinting.XlsExportOptions.WorkbookColorPaletteCompliance": "Çalışma kitabındaki renk paleti uyumu",
  "DevExpress.XtraPrinting.XlsxExportMode.DifferentFiles": "Farklı Dosyalar",
  "DevExpress.XtraPrinting.XlsxExportMode.SingleFile": "Tek Dosya",
  "DevExpress.XtraPrinting.XlsxExportMode.SingleFilePageByPage": "Tek Dosya (Sayfa Başına)",
  "DevExpress.XtraPrinting.XlsxExportOptions": "XLSx Aktarma Seçenekleri",
  "DevExpress.XtraPrinting.XlsxExportOptions.ExportMode": "Aktarım Modu",
  "DevExpress.XtraPrinting.XlsxExportOptions.PageRange": "Sayfa Aralığı",
  "DevExpress.XtraPrinting.XpsDocumentOptions": "XPS Doküman Seçenekleri",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Category": "Kategori",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Creator": "Yaratıcı",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Description": "Açıklama",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Keywords": "Anahtar Kelimeler",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Subject": "Konu",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Title": "Başlık",
  "DevExpress.XtraPrinting.XpsDocumentOptions.Version": "Versiyon",
  "DevExpress.XtraPrinting.XpsExportOptions.Compression": "Sıkıştırma",
  "DevExpress.XtraPrinting.XpsExportOptions.DocumentOptions": "Doküman Seçenekleri",
  "DevExpress.XtraReports.Design.DataBinding.Binding": "İlişki",
  "DevExpress.XtraReports.Design.DataBinding.FormatString": "Biçim Kalıbı",
  "DevExpress.XtraReports.Design.GroupSort.GroupSortReflectItem.ShowFooter": "Altlık Göster",
  "DevExpress.XtraReports.Design.GroupSort.GroupSortReflectItem.ShowHeader": "Başlık Göster",
  "DevExpress.XtraReports.Parameters.DynamicListLookUpSettings": "Dinamik Liste",
  "DevExpress.XtraReports.Parameters.DynamicListLookUpSettings.DisplayMember": "Ekran üye",
  "DevExpress.XtraReports.Parameters.DynamicListLookUpSettings.SortOrder": "Sıralama düzeni",
  "DevExpress.XtraReports.Parameters.DynamicListLookUpSettings.ValueMember": "Değer Üyesi",
  "DevExpress.XtraReports.Parameters.LookUpSettings.DataAdapter": "Veri Bağdaştırıcısı",
  "DevExpress.XtraReports.Parameters.LookUpSettings.DataMember": "Veri Öğesi",
  "DevExpress.XtraReports.Parameters.LookUpSettings.DataSource": "Veri Kaynağı",
  "DevExpress.XtraReports.Parameters.Orientation.Horizontal": "Yatay",
  "DevExpress.XtraReports.Parameters.Orientation.Vertical": "Dikey",
  "DevExpress.XtraReports.Parameters.Parameter": "Parametre",
  "DevExpress.XtraReports.Parameters.Parameter.Description": "Açıklama",
  "DevExpress.XtraReports.Parameters.Parameter.Enabled": "Etkin",
  "DevExpress.XtraReports.Parameters.Parameter.Tag": "Etiket",
  "DevExpress.XtraReports.Parameters.Parameter.Type": "Türü",
  "DevExpress.XtraReports.Parameters.Parameter.Value": "Değer",
  "DevExpress.XtraReports.Parameters.Parameter.Visible": "Görünür",
  "DevExpress.XtraReports.Parameters.ParameterType.Boolean": "Mantıksal",
  "DevExpress.XtraReports.Parameters.ParameterType.DateTime": "Tarih/Saat",
  "DevExpress.XtraReports.Parameters.ParameterType.Decimal": "Ondalık",
  "DevExpress.XtraReports.Parameters.ParameterType.Double": "Çift",
  "DevExpress.XtraReports.Parameters.ParameterType.Float": "Kayan nokta",
  "DevExpress.XtraReports.Parameters.ParameterType.Int32": "Int32",
  "DevExpress.XtraReports.Parameters.ParameterType.String": "Dize",
  "DevExpress.XtraReports.Parameters.StaticListLookUpSettings": "Statik liste",
  "DevExpress.XtraReports.Parameters.StaticListLookUpSettings.LookUpValues": "Arama değerleri",
  "DevExpress.XtraReports.ScriptLanguage.CSharp": "C#",
  "DevExpress.XtraReports.ScriptLanguage.JScript": "JScript .NET",
  "DevExpress.XtraReports.ScriptLanguage.VisualBasic": "Visual Basic",
  "DevExpress.XtraReports.UI.AutoSizeMode.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.Band.Height": "Yükseklik",
  "DevExpress.XtraReports.UI.Band.PageBreak": "Sayfa Bitimi",
  "DevExpress.XtraReports.UI.Band.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.BandScripts": "Şerit Betikleri",
  "DevExpress.XtraReports.UI.BottomMarginBand": "Taban Margin'i",
  "DevExpress.XtraReports.UI.CalculatedField": "Hesap Alanı",
  "DevExpress.XtraReports.UI.CalculatedField.DataMember": "Veri Öğesi",
  "DevExpress.XtraReports.UI.CalculatedField.DataSource": "Veri Kaynağı",
  "DevExpress.XtraReports.UI.CalculatedField.DisplayName": "Gösterim Adı",
  "DevExpress.XtraReports.UI.CalculatedField.Expression": "İfade",
  "DevExpress.XtraReports.UI.CalculatedField.FieldType": "Alan Tipi",
  "DevExpress.XtraReports.UI.CalculatedField.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.CalculatedFieldScripts": "Hesap Alanı Betikleri",
  "DevExpress.XtraReports.UI.CalculatedFieldScripts.OnGetValue": "Değer Al",
  "DevExpress.XtraReports.UI.ChartImageType.Bitmap": "Bit eşlem",
  "DevExpress.XtraReports.UI.ChartImageType.Metafile": "Meta dosyası",
  "DevExpress.XtraReports.UI.CheckBoxGlyphOptions.Alignment": "Hizalama",
  "DevExpress.XtraReports.UI.CheckBoxGlyphOptions.Size": "Boyut",
  "DevExpress.XtraReports.UI.CheckBoxGlyphOptions.Style": "Stil",
  "DevExpress.XtraReports.UI.CheckBoxGlyphs.Checked": "İşaretli",
  "DevExpress.XtraReports.UI.CheckBoxGlyphs.Unchecked": "Denetlenmeyen",
  "DevExpress.XtraReports.UI.ColumnDirection.AcrossThenDown": "Önce Boyunca, Sonra Aşağıya",
  "DevExpress.XtraReports.UI.ColumnDirection.DownThenAcross": "Önce Aşağıya, Sonra Boyunca",
  "DevExpress.XtraReports.UI.ConditionFormatting.Style": "Stil",
  "DevExpress.XtraReports.UI.ConditionFormatting.Visible": "Görünür",
  "DevExpress.XtraReports.UI.CrossTab.CornerHeaderDisplayMode.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabColumnField": "Sütun alanı",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabDataField": "Veri Alanı",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabDataField.SummaryType": "Özet yazın",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabFieldBase.FieldName": "Alan Adı",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabFieldSortBySummaryInfo.FieldName": "Alan Adı",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabFieldSortBySummaryInfo.SummaryType": "Özet yazın",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabGroupFieldBase.GroupInterval": "Grup sıklığı",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabGroupFieldBase.GroupIntervalNumericRange": "Grup aralığı sayısal aralığı",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabGroupFieldBase.SortOrder": "Sıralama düzeni",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabLayoutOptions": "Sekme Düzeni Seçenekleri",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabLayoutOptions.CornerHeaderDisplayMode": "Köşe Üstbilgi Ekran Modu",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabLayoutOptions.HierarchicalRowLayout": "Hiyerarşik Satır Düzeni",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabLayoutOptions.RowTotalsPosition": "Satır toplamları konumu",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabPrintOptions.AcrossThenDownOffset": "Ofsetten Sonra Aşağı Ofset",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabPrintOptions.PrintLayout": "Baskı Düzeni",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabPrintOptions.PrintTotalsForSingleValues": "Tek Değerler Için Toplamları Yazdır",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabStyles.DataAreaStyle": "Veri Alanı Stili",
  "DevExpress.XtraReports.UI.CrossTab.CrossTabStyles.HeaderAreaStyle": "Üstbilgi Alan Stili",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Alphabetical": "Alfabetik",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Date": "Tarih",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateDay": "Gün",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateDayOfWeek": "Haftanın günü",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateDayOfYear": "Yılın günü",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateHour": "Tarih-Saat",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateHourMinuteSecond": "Tarih-saat-dakika-saniye",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateMonth": "Ay",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateQuarter": "Üç aylık dönem",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateQuarterYear": "Çeyrek yıl",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.DateYear": "Yıl",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Default": "Varsayılan",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Hour": "Saat",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Minute": "Dakika",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Numeric": "Sayısal",
  "DevExpress.XtraReports.UI.CrossTab.GroupInterval.Second": "İkinci",
  "DevExpress.XtraReports.UI.CrossTab.SummaryDisplayType.AbsoluteVariation": "Mutlak varyasyon",
  "DevExpress.XtraReports.UI.CrossTab.SummaryDisplayType.Default": "Varsayılan",
  "DevExpress.XtraReports.UI.CrossTab.SummaryDisplayType.Index": "Dizin",
  "DevExpress.XtraReports.UI.CrossTab.SummaryDisplayType.PercentOfColumn": "Sütun yüzdesi",
  "DevExpress.XtraReports.UI.CrossTab.SummaryDisplayType.PercentOfRow": "Satır yüzdesi",
  "DevExpress.XtraReports.UI.CrossTab.SummaryDisplayType.PercentVariation": "Yüzde değişim",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Average": "Ortalama",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Count": "Adet",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Max": "Max",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Min": "Min",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.StdDev": "Standart sapma",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Sum": "Toplam",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Var": "Varyasyon",
  "DevExpress.XtraReports.UI.CrossTab.SummaryType.Varp": "Tüm bir popülasyon için varyasyon",
  "DevExpress.XtraReports.UI.CrossTab.TotalHeaderPosition.Inner": "İç",
  "DevExpress.XtraReports.UI.CrossTab.TotalHeaderPosition.Outer": "Dış",
  "DevExpress.XtraReports.UI.CrossTab.XRCrossTabCell.Angle": "Açı",
  "DevExpress.XtraReports.UI.CrossTab.XRCrossTabCell.ColumnAutoWidthMode": "Otomatik Genişlik Modu",
  "DevExpress.XtraReports.UI.CrossTab.XRCrossTabCellCollection.ColumnCount": "Sütun sayısı",
  "DevExpress.XtraReports.UI.CrossTab.XRCrossTabCellCollection.RowCount": "Satır sayısı",
  "DevExpress.XtraReports.UI.DetailBand": "Detay",
  "DevExpress.XtraReports.UI.DetailBand.KeepTogetherWithDetailReports": "Detay Raporlarıyla Birlikte Tut",
  "DevExpress.XtraReports.UI.DetailBand.MultiColumn": "Çoklu Sütun Seçenekleri",
  "DevExpress.XtraReports.UI.DetailBand.SortFields": "Sıralama Alanları",
  "DevExpress.XtraReports.UI.DetailReportBand": "Detay Raporu",
  "DevExpress.XtraReports.UI.DetailReportBand.Level": "Seviye",
  "DevExpress.XtraReports.UI.DocumentExportMode.Auto": "Otomatik",
  "DevExpress.XtraReports.UI.EditOptions.Enabled": "Etkin",
  "DevExpress.XtraReports.UI.FormattingRule": "Biçimlendirme Kuralı",
  "DevExpress.XtraReports.UI.FormattingRule.Condition": "Şart",
  "DevExpress.XtraReports.UI.FormattingRule.DataMember": "Veri Öğesi",
  "DevExpress.XtraReports.UI.FormattingRule.DataSource": "Veri Kaynağı",
  "DevExpress.XtraReports.UI.FormattingRule.Formatting": "Biçimlendirme",
  "DevExpress.XtraReports.UI.GaugeImageType.Bitmap": "Bit eşlem",
  "DevExpress.XtraReports.UI.GaugeImageType.Metafile": "Meta dosyası",
  "DevExpress.XtraReports.UI.GroupBand.Level": "Seviye",
  "DevExpress.XtraReports.UI.GroupBand.RepeatEveryPage": "Her Sayfada Tekrarla",
  "DevExpress.XtraReports.UI.GroupBand.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.GroupBandScripts.OnBandLevelChanged": "Şerit Seviyesi Değişti",
  "DevExpress.XtraReports.UI.GroupField": "Grup Alanı",
  "DevExpress.XtraReports.UI.GroupField.FieldName": "Alan Adı",
  "DevExpress.XtraReports.UI.GroupField.SortOrder": "Sıralama Düzeni",
  "DevExpress.XtraReports.UI.GroupFooterBand": "Grup Altlığı",
  "DevExpress.XtraReports.UI.GroupFooterBand.GroupUnion": "Grup Birleşimi",
  "DevExpress.XtraReports.UI.GroupFooterBand.PrintAtBottom": "En Altta Yaz",
  "DevExpress.XtraReports.UI.GroupFooterUnion.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.GroupFooterUnion.WithLastDetail": "Son Detayla Birlikte",
  "DevExpress.XtraReports.UI.GroupHeaderBand": "Grup Başlığı",
  "DevExpress.XtraReports.UI.GroupHeaderBand.GroupFields": "Grup Alanları",
  "DevExpress.XtraReports.UI.GroupHeaderBand.GroupUnion": "Grup Birleşimi",
  "DevExpress.XtraReports.UI.GroupHeaderBand.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.GroupHeaderBand.SortingSummary": "Sıralama Özeti",
  "DevExpress.XtraReports.UI.GroupHeaderBandScripts": "Grup Başlık Şeridi Betikleri",
  "DevExpress.XtraReports.UI.GroupHeaderBandScripts.OnSortingSummaryGetResult": "Sıralama Özeti Sonuç Al",
  "DevExpress.XtraReports.UI.GroupHeaderBandScripts.OnSortingSummaryReset": "Sıralama Özeti Sıfırla",
  "DevExpress.XtraReports.UI.GroupHeaderBandScripts.OnSortingSummaryRowChanged": "Sıralama Özeti Satır Değişti",
  "DevExpress.XtraReports.UI.GroupUnion.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.GroupUnion.WholePage": "Tüm Sayfa",
  "DevExpress.XtraReports.UI.GroupUnion.WithFirstDetail": "İlk Detayla Birlikte",
  "DevExpress.XtraReports.UI.HierarchyPrintOptions.ChildListFieldName": "Alt liste alanı adı",
  "DevExpress.XtraReports.UI.HierarchyPrintOptions.Indent": "Girinti",
  "DevExpress.XtraReports.UI.HierarchyPrintOptions.KeepTogetherWithFirstChild": "Ilk çocuk Ile birlikte tutun",
  "DevExpress.XtraReports.UI.HorizontalAnchorStyles.Both": "Her iki",
  "DevExpress.XtraReports.UI.HorizontalAnchorStyles.Left": "Sol",
  "DevExpress.XtraReports.UI.HorizontalAnchorStyles.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.HorizontalAnchorStyles.Right": "Sağ",
  "DevExpress.XtraReports.UI.LineDirection.BackSlant": "Eğik sırt",
  "DevExpress.XtraReports.UI.LineDirection.Horizontal": "Yatay",
  "DevExpress.XtraReports.UI.LineDirection.Slant": "Eğim",
  "DevExpress.XtraReports.UI.LineDirection.Vertical": "Dikey",
  "DevExpress.XtraReports.UI.MultiColumn": "Çoklu Sütun Seçenekleri",
  "DevExpress.XtraReports.UI.MultiColumn.ColumnCount": "Sütun Sayısı",
  "DevExpress.XtraReports.UI.MultiColumn.ColumnSpacing": "Sütun Aralığı",
  "DevExpress.XtraReports.UI.MultiColumn.ColumnWidth": "Sütun Genişliği",
  "DevExpress.XtraReports.UI.MultiColumn.Direction": "Yön",
  "DevExpress.XtraReports.UI.MultiColumn.Layout": "Yerleşim",
  "DevExpress.XtraReports.UI.MultiColumn.Mode": "Mod",
  "DevExpress.XtraReports.UI.MultiColumnMode.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.MultiColumnMode.UseColumnCount": "Sütun Sayısını Kullan",
  "DevExpress.XtraReports.UI.MultiColumnMode.UseColumnWidth": "Sütun Genişliğini Kullan",
  "DevExpress.XtraReports.UI.PageBand.PrintOn": "Üstüne Yazdır",
  "DevExpress.XtraReports.UI.PageBreak.AfterBand": "Şeritten Sonra",
  "DevExpress.XtraReports.UI.PageBreak.BeforeBand": "Şeritten Önce",
  "DevExpress.XtraReports.UI.PageBreak.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.PageFooterBand": "Sayfa Altlığı",
  "DevExpress.XtraReports.UI.PageHeaderBand": "Sayfa Başlığı",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.Cell": "Hücre",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.CustomTotalCell": "Kişisel Toplam Hücresi",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.FieldHeader": "Alan Başlığı",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.FieldValue": "Alan Değeri",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.FieldValueGrandTotal": "AlanDeğeriGenelToplam",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.FieldValueTotal": "Alan Değeri Toplam",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.FilterSeparator": "Süzgeç Ayracı",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.GrandTotalCell": "Genel Toplam Hücresi",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.HeaderGroupLine": "Başlık Grup Satırı",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.Lines": "Satırlar",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridAppearances.TotalCell": "Toplam Hücresi",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.CellStyle": "Hücre Stili",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.CustomTotalCellStyle": "Kişisel Toplam Hücre Stili",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.FieldHeaderStyle": "Alan Başlık Stili",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.FieldValueGrandTotalStyle": "Alan Değeri Genel Toplam Stili",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.FieldValueStyle": "Alan Değeri Stili",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.FieldValueTotalStyle": "Alan Değeri Toplam Stili",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.FilterSeparatorStyle": "Süzgeç Ayraç Stili",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.GrandTotalCellStyle": "Genel Toplam Hücre Stili",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.HeaderGroupLineStyle": "Başlık Grup Satırı Stili",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.LinesStyle": "Satırlar Stili",
  "DevExpress.XtraReports.UI.PivotGrid.XRPivotGridStyles.TotalCellStyle": "Toplam Hücre Stili",
  "DevExpress.XtraReports.UI.PivotGrid.XRPrefilter": "Prefilter",
  "DevExpress.XtraReports.UI.PrintLayout.AcrossOnly": "Yalnızca",
  "DevExpress.XtraReports.UI.PrintOnPages.AllPages": "Tüm Sayfalar",
  "DevExpress.XtraReports.UI.PrintOnPages.NotWithReportFooter": "Rapor Altlığı Olmadan",
  "DevExpress.XtraReports.UI.PrintOnPages.NotWithReportHeader": "Rapor Başlığı Olmadan",
  "DevExpress.XtraReports.UI.PrintOnPages.NotWithReportHeaderAndReportFooter": "Rapor Başlığı ve Altlığı Olmadan",
  "DevExpress.XtraReports.UI.PrintableComponentContainer": "Yazdırılabilir bileşen kapsayıcı",
  "DevExpress.XtraReports.UI.PrintableComponentContainer.ClipContent": "İçeriği Kırp",
  "DevExpress.XtraReports.UI.PrintableComponentContainer.WindowControlOptions": "Pencere denetim seçenekleri",
  "DevExpress.XtraReports.UI.ProcessDuplicatesMode.Leave": "Bırak",
  "DevExpress.XtraReports.UI.ProcessDuplicatesMode.Merge": "Birleştirme",
  "DevExpress.XtraReports.UI.ProcessDuplicatesMode.Suppress": "Bastır",
  "DevExpress.XtraReports.UI.ProcessDuplicatesMode.SuppressAndShrink": "Bastırmak ve küçültmek",
  "DevExpress.XtraReports.UI.ProcessDuplicatesTarget.Tag": "Etiket",
  "DevExpress.XtraReports.UI.ProcessDuplicatesTarget.Value": "Değer",
  "DevExpress.XtraReports.UI.ReportFooterBand": "Rapor Altlığı",
  "DevExpress.XtraReports.UI.ReportFooterBand.PrintAtBottom": "En Sonda Yazdır",
  "DevExpress.XtraReports.UI.ReportHeaderBand": "Rapor Başlığı",
  "DevExpress.XtraReports.UI.ReportPrintOptions": "Rapor Yazdırma Seçenekleri",
  "DevExpress.XtraReports.UI.ReportPrintOptions.BlankDetailCount": "Boş Detay Sayısı",
  "DevExpress.XtraReports.UI.ReportPrintOptions.DetailCount": "Detay Sayısı",
  "DevExpress.XtraReports.UI.ReportPrintOptions.DetailCountAtDesignTime": "Tasarım Aşamasında Detay Sayısı",
  "DevExpress.XtraReports.UI.ReportPrintOptions.DetailCountOnEmptyDataSource": "Veri Kaynağı Boşken Detay Sayısı",
  "DevExpress.XtraReports.UI.ReportPrintOptions.PrintOnEmptyDataSource": "Veri Kaynağı Boşken Yazdır",
  "DevExpress.XtraReports.UI.ReportUnit.HundredthsOfAnInch": "1 İnç(2.54 cm)'in yüzde biri",
  "DevExpress.XtraReports.UI.ReportUnit.Pixels": "Piksel",
  "DevExpress.XtraReports.UI.ReportUnit.TenthsOfAMillimeter": "Milimetrenin onda biri",
  "DevExpress.XtraReports.UI.RightToLeft.Inherit": "Miras",
  "DevExpress.XtraReports.UI.RightToLeft.No": "Hayır",
  "DevExpress.XtraReports.UI.RightToLeft.Yes": "Evet",
  "DevExpress.XtraReports.UI.RightToLeftLayout.No": "Hayır",
  "DevExpress.XtraReports.UI.RightToLeftLayout.Yes": "Evet",
  "DevExpress.XtraReports.UI.SnappingMode.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.SnappingMode.SnapLines": "Uydurma Çizgileri",
  "DevExpress.XtraReports.UI.SnappingMode.SnapToGrid": "Grid'e Uydur",
  "DevExpress.XtraReports.UI.SortingOptions.FieldName": "Alan Adı",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Avg": "Ortalama",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Count": "Sayı",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Custom": "Kişisel",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DAvg": "Ortalama(Farklı)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DCount": "Sayı(Farklı)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DStdDev": "Standart Sapma(Farklı)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DStdDevP": "Nüfus Standart Sapma(Farklı)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DSum": "Toplam(Farklı)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DVar": "Varyans(Farklı)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.DVarP": "Nüfus Varyansı(Farklı)",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Max": "En Çok",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Median": "Ortanca",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Min": "En Az",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.StdDev": "Standart Sapma",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.StdDevP": "Nüfus Standart Sapma",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Sum": "Toplam",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.Var": "Varyans",
  "DevExpress.XtraReports.UI.SortingSummaryFunction.VarP": "Nüfus Varyansı",
  "DevExpress.XtraReports.UI.SparklineImageType.Bitmap": "Bit eşlem",
  "DevExpress.XtraReports.UI.SparklineImageType.Metafile": "Meta dosyası",
  "DevExpress.XtraReports.UI.StylePriority": "Stil Önceliği",
  "DevExpress.XtraReports.UI.StylePriority.UseBackColor": "Arkaplan Rengi Kullan",
  "DevExpress.XtraReports.UI.StylePriority.UseBorderColor": "Sınır Rengi Kullan",
  "DevExpress.XtraReports.UI.StylePriority.UseBorderDashStyle": "Sınır Vurgu Stili Kullan",
  "DevExpress.XtraReports.UI.StylePriority.UseBorderWidth": "Sınır Genişliği Kullan",
  "DevExpress.XtraReports.UI.StylePriority.UseBorders": "Sınırları Kullan",
  "DevExpress.XtraReports.UI.StylePriority.UseFont": "Yazı Tipi Kullan",
  "DevExpress.XtraReports.UI.StylePriority.UseForeColor": "Önplan Rengi Kullan",
  "DevExpress.XtraReports.UI.StylePriority.UsePadding": "Dolgu Kullan",
  "DevExpress.XtraReports.UI.StylePriority.UseTextAlignment": "Yazı Hizalama Kullan",
  "DevExpress.XtraReports.UI.StyleUsing": "Stil Kullan",
  "DevExpress.XtraReports.UI.StyleUsing.UseBackColor": "Arkaplan Rengi Kullan",
  "DevExpress.XtraReports.UI.StyleUsing.UseBorderColor": "Sınır Rengi Kullan",
  "DevExpress.XtraReports.UI.StyleUsing.UseBorderWidth": "Sınır Genişliği Kullan",
  "DevExpress.XtraReports.UI.StyleUsing.UseBorders": "Sınırları Kullan",
  "DevExpress.XtraReports.UI.StyleUsing.UseFont": "Yazı Tipi Kullan",
  "DevExpress.XtraReports.UI.StyleUsing.UseForeColor": "Önplan Rengi Kullan",
  "DevExpress.XtraReports.UI.StyleUsing.UsePadding": "Dolgu Kullan",
  "DevExpress.XtraReports.UI.StyleUsing.UseTextAlignment": "Yazı Hizalama Kullan",
  "DevExpress.XtraReports.UI.SubreportBase.ReportSource": "Rapor Kaynağı",
  "DevExpress.XtraReports.UI.SubreportBase.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.SubreportBaseScripts.OnEvaluateBinding": "İlişkiyi Değerle",
  "DevExpress.XtraReports.UI.SubreportBaseScripts.OnSizeChanged": "Boyut Değişti",
  "DevExpress.XtraReports.UI.SummaryFunc.Avg": "Ortalama",
  "DevExpress.XtraReports.UI.SummaryFunc.Count": "Sayı",
  "DevExpress.XtraReports.UI.SummaryFunc.Custom": "Kişisel",
  "DevExpress.XtraReports.UI.SummaryFunc.DAvg": "Ortalama(Farklı)",
  "DevExpress.XtraReports.UI.SummaryFunc.DCount": "Sayı(Farklı)",
  "DevExpress.XtraReports.UI.SummaryFunc.DStdDev": "Standart Sapma(Farklı)",
  "DevExpress.XtraReports.UI.SummaryFunc.DStdDevP": "Nüfus Standart Sapma(Farklı)",
  "DevExpress.XtraReports.UI.SummaryFunc.DSum": "Toplam(Farklı)",
  "DevExpress.XtraReports.UI.SummaryFunc.DVar": "Varyans(Farklı)",
  "DevExpress.XtraReports.UI.SummaryFunc.DVarP": "Nüfus Varyansı(Farklı)",
  "DevExpress.XtraReports.UI.SummaryFunc.Max": "En Çok",
  "DevExpress.XtraReports.UI.SummaryFunc.Median": "Ortanca",
  "DevExpress.XtraReports.UI.SummaryFunc.Min": "En Az",
  "DevExpress.XtraReports.UI.SummaryFunc.Percentage": "Yüzde",
  "DevExpress.XtraReports.UI.SummaryFunc.RecordNumber": "Kayıt Numarası",
  "DevExpress.XtraReports.UI.SummaryFunc.RunningSum": "Çalışan Toplam",
  "DevExpress.XtraReports.UI.SummaryFunc.StdDev": "Standart Sapma",
  "DevExpress.XtraReports.UI.SummaryFunc.StdDevP": "Nüfus Standart Sapma",
  "DevExpress.XtraReports.UI.SummaryFunc.Sum": "Toplam",
  "DevExpress.XtraReports.UI.SummaryFunc.Var": "Varyans",
  "DevExpress.XtraReports.UI.SummaryFunc.VarP": "Nüfus Varyansı",
  "DevExpress.XtraReports.UI.SummaryRunning.Group": "Grup",
  "DevExpress.XtraReports.UI.SummaryRunning.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.SummaryRunning.Page": "Sayfa",
  "DevExpress.XtraReports.UI.SummaryRunning.Report": "Rapor",
  "DevExpress.XtraReports.UI.TextFitMode.GrowOnly": "Sadece büyümek",
  "DevExpress.XtraReports.UI.TextFitMode.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.TopMarginBand": "Üst Margin",
  "DevExpress.XtraReports.UI.ValueSuppressType.Leave": "Bırak",
  "DevExpress.XtraReports.UI.ValueSuppressType.MergeByTag": "Birleştirme sırasında etiket tabanlı",
  "DevExpress.XtraReports.UI.ValueSuppressType.MergeByValue": "Birleştirme değerine göre",
  "DevExpress.XtraReports.UI.ValueSuppressType.Suppress": "Bastır",
  "DevExpress.XtraReports.UI.ValueSuppressType.SuppressAndShrink": "Bastır ve Daralt",
  "DevExpress.XtraReports.UI.VerticalAnchorStyles.Both": "İkisi de",
  "DevExpress.XtraReports.UI.VerticalAnchorStyles.Bottom": "Alt",
  "DevExpress.XtraReports.UI.VerticalAnchorStyles.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.VerticalAnchorStyles.Top": "Üst",
  "DevExpress.XtraReports.UI.VerticalHeaderBand.RepeatEveryPage": "Her sayfada yineleme",
  "DevExpress.XtraReports.UI.WinControlContainer": "Windows Forms Kontrolü",
  "DevExpress.XtraReports.UI.WinControlContainer.DrawMethod": "Çizme Metodu",
  "DevExpress.XtraReports.UI.WinControlContainer.ImageType": "Resim Tipi",
  "DevExpress.XtraReports.UI.WinControlContainer.PrintMode": "Yazdırma Modu",
  "DevExpress.XtraReports.UI.WinControlContainer.SyncBounds": "Sınırları Eşitle",
  "DevExpress.XtraReports.UI.WinControlDrawMethod.UseWMPaint": "WMPaint Metodunu Kullan",
  "DevExpress.XtraReports.UI.WinControlDrawMethod.UseWMPaintRecursive": "WMPaint'i Özyinelemeli Kullan",
  "DevExpress.XtraReports.UI.WinControlDrawMethod.UseWMPrint": "WMPrint Metodunu Kullan",
  "DevExpress.XtraReports.UI.WinControlDrawMethod.UseWMPrintRecursive": "WMPrint'i Özyinelemeli Kullan",
  "DevExpress.XtraReports.UI.WinControlImageType.Bitmap": "Bit eşlem",
  "DevExpress.XtraReports.UI.WinControlImageType.Metafile": "Meta dosyası",
  "DevExpress.XtraReports.UI.WinControlPrintMode.AsBricks": "Tuğla Olarak",
  "DevExpress.XtraReports.UI.WinControlPrintMode.AsImage": "Görüntü Olarak",
  "DevExpress.XtraReports.UI.WinControlPrintMode.Default": "Varsayılan",
  "DevExpress.XtraReports.UI.WindowControlOptions": "Pencere denetim seçenekleri",
  "DevExpress.XtraReports.UI.XRAccessibleRole.Default": "Varsayılan",
  "DevExpress.XtraReports.UI.XRAccessibleRole.Table": "Tablo",
  "DevExpress.XtraReports.UI.XRAppearanceObject.TextHorizontalAlignment": "Metnin yatay hizalamasını",
  "DevExpress.XtraReports.UI.XRAppearanceObject.TextVerticalAlignment": "Dikey metin hizalama",
  "DevExpress.XtraReports.UI.XRAppearanceObject.Trimming": "Kırpma",
  "DevExpress.XtraReports.UI.XRAppearanceObject.WordWrap": "Sözcük kaydır",
  "DevExpress.XtraReports.UI.XRBarCode": "Barkod",
  "DevExpress.XtraReports.UI.XRBarCode.Alignment": "Hizalama",
  "DevExpress.XtraReports.UI.XRBarCode.AutoModule": "Oto-Modül",
  "DevExpress.XtraReports.UI.XRBarCode.BarCodeOrientation": "Yön",
  "DevExpress.XtraReports.UI.XRBarCode.BinaryData": "İkili Veri",
  "DevExpress.XtraReports.UI.XRBarCode.Module": "Modül",
  "DevExpress.XtraReports.UI.XRBarCode.PaddingInfo": "Dolgu",
  "DevExpress.XtraReports.UI.XRBarCode.ShowText": "Metni Göster",
  "DevExpress.XtraReports.UI.XRBarCode.Symbology": "Semboloji",
  "DevExpress.XtraReports.UI.XRBinding.DataMember": "Veri Öğesi",
  "DevExpress.XtraReports.UI.XRBinding.FormatString": "Biçimlendirme Kalıbı",
  "DevExpress.XtraReports.UI.XRBinding.PropertyName": "Özellik Adı",
  "DevExpress.XtraReports.UI.XRCharacterComb.CellHeight": "Hücre Yüksekliği",
  "DevExpress.XtraReports.UI.XRCharacterComb.CellHorizontalSpacing": "Hücre Yatay Aralık",
  "DevExpress.XtraReports.UI.XRCharacterComb.CellVerticalSpacing": "Hücre Dikey Aralık",
  "DevExpress.XtraReports.UI.XRCharacterComb.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.XRChart": "Grafik",
  "DevExpress.XtraReports.UI.XRChart.AnnotationRepository": "Dipnot Deposu",
  "DevExpress.XtraReports.UI.XRChart.Annotations": "Dipnotlar",
  "DevExpress.XtraReports.UI.XRChart.AppearanceName": "Görünüm Adı",
  "DevExpress.XtraReports.UI.XRChart.BackColor": "Arkaplan Rengi",
  "DevExpress.XtraReports.UI.XRChart.BackImage": "Arkaplan Resmi",
  "DevExpress.XtraReports.UI.XRChart.DataAdapter": "Veri Bağdaştırıcısı",
  "DevExpress.XtraReports.UI.XRChart.DataMember": "Veri Öğesi",
  "DevExpress.XtraReports.UI.XRChart.DataSource": "Veri Kaynağı",
  "DevExpress.XtraReports.UI.XRChart.Diagram": "Diyagram",
  "DevExpress.XtraReports.UI.XRChart.EmptyChartText": "Boş Çizelge Metni",
  "DevExpress.XtraReports.UI.XRChart.FillStyle": "Doldurma Stili",
  "DevExpress.XtraReports.UI.XRChart.ImageType": "Resim Tipi",
  "DevExpress.XtraReports.UI.XRChart.IndicatorsPaletteName": "Belirteç Palet Adı",
  "DevExpress.XtraReports.UI.XRChart.Legend": "Lejant",
  "DevExpress.XtraReports.UI.XRChart.Legends": "Efsaneler",
  "DevExpress.XtraReports.UI.XRChart.Padding": "Dolgu",
  "DevExpress.XtraReports.UI.XRChart.PaletteBaseColorNumber": "Palet Temel Renk Numarası",
  "DevExpress.XtraReports.UI.XRChart.PaletteName": "Palet Adı",
  "DevExpress.XtraReports.UI.XRChart.Parameters": "Değişkenler",
  "DevExpress.XtraReports.UI.XRChart.PivotGridDataSourceOptions": "Pivot Çizelgesi Veri Kaynağı Seçenekleri",
  "DevExpress.XtraReports.UI.XRChart.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.XRChart.Series": "Seriler",
  "DevExpress.XtraReports.UI.XRChart.SeriesDataMember": "Seri Veri Öğesi",
  "DevExpress.XtraReports.UI.XRChart.SeriesNameTemplate": "Seri Adı Şablonu",
  "DevExpress.XtraReports.UI.XRChart.SeriesSorting": "Seri Sıralaması",
  "DevExpress.XtraReports.UI.XRChart.SeriesTemplate": "Seri Şablonu",
  "DevExpress.XtraReports.UI.XRChart.SmallChartText": "Küçük Grafik Metni",
  "DevExpress.XtraReports.UI.XRChart.Titles": "Başlıklar",
  "DevExpress.XtraReports.UI.XRChartScripts": "Grafik Betikleri",
  "DevExpress.XtraReports.UI.XRChartScripts.OnAxisScaleChanged": "Eksen Ölçeği Değişti",
  "DevExpress.XtraReports.UI.XRChartScripts.OnAxisVisualRangeChanged": "Eksen Görsel Aralığı Değişti",
  "DevExpress.XtraReports.UI.XRChartScripts.OnAxisWholeRangeChanged": "Eksen Tüm Aralığı Değişti",
  "DevExpress.XtraReports.UI.XRChartScripts.OnBoundDataChanged": "İlişkili Veri Değişti",
  "DevExpress.XtraReports.UI.XRChartScripts.OnCustomDrawAxisLabel": "Eksen Etikeri Kişisel Çizimi",
  "DevExpress.XtraReports.UI.XRChartScripts.OnCustomDrawCrosshair": "Özel Crosshair çekmek",
  "DevExpress.XtraReports.UI.XRChartScripts.OnCustomDrawSeries": "Seri Kişisel Çizimi",
  "DevExpress.XtraReports.UI.XRChartScripts.OnCustomDrawSeriesPoint": "Seri Noktası Kişisel Çizimi",
  "DevExpress.XtraReports.UI.XRChartScripts.OnCustomPaint": "Kişisel Boyama",
  "DevExpress.XtraReports.UI.XRChartScripts.OnCustomizeStackedBarTotalLabel": "Yığılmış Çubuk Toplam Etiketi Özelleştir",
  "DevExpress.XtraReports.UI.XRChartScripts.OnPieSeriesPointExploded": "Dilim Serisi Noktası Ayrılması",
  "DevExpress.XtraReports.UI.XRChartScripts.OnSmallChartTextShowing": "Gösterilen küçük grafik metni",
  "DevExpress.XtraReports.UI.XRCheckBox": "İşaret Kutucuğu",
  "DevExpress.XtraReports.UI.XRCheckBox.Checked": "İşaretli",
  "DevExpress.XtraReports.UI.XRColumnSortOrder.Ascending": "Küçükten Büyüğe",
  "DevExpress.XtraReports.UI.XRColumnSortOrder.Descending": "Büyükten Küçüğe",
  "DevExpress.XtraReports.UI.XRColumnSortOrder.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.XRControl.AnchorVertical": "Dikey Sabitle",
  "DevExpress.XtraReports.UI.XRControl.BackColor": "Arkaplan Rengi",
  "DevExpress.XtraReports.UI.XRControl.Bookmark": "Yer İmi",
  "DevExpress.XtraReports.UI.XRControl.BookmarkParent": "Üst yer İmi",
  "DevExpress.XtraReports.UI.XRControl.BorderColor": "Sınır Rengi",
  "DevExpress.XtraReports.UI.XRControl.BorderDashStyle": "Sınır Vurgu Stili",
  "DevExpress.XtraReports.UI.XRControl.BorderWidth": "Sınır Genişliği",
  "DevExpress.XtraReports.UI.XRControl.Borders": "Sınırlar",
  "DevExpress.XtraReports.UI.XRControl.CanGrow": "Genişleyebilir",
  "DevExpress.XtraReports.UI.XRControl.CanShrink": "Daralabilir",
  "DevExpress.XtraReports.UI.XRControl.DataBindings": "Veri İlişkileri",
  "DevExpress.XtraReports.UI.XRControl.Font": "Yazı Tipi",
  "DevExpress.XtraReports.UI.XRControl.ForeColor": "Önplan Rengi",
  "DevExpress.XtraReports.UI.XRControl.FormattingRules": "Biçimlendirme Kuralları",
  "DevExpress.XtraReports.UI.XRControl.Height": "Yükseklik",
  "DevExpress.XtraReports.UI.XRControl.KeepTogether": "Birlikte Tut",
  "DevExpress.XtraReports.UI.XRControl.Left": "Sol",
  "DevExpress.XtraReports.UI.XRControl.Location": "Konum",
  "DevExpress.XtraReports.UI.XRControl.LockedInUserDesigner": "Son Kullanıcı Tasarımcısında Sabit",
  "DevExpress.XtraReports.UI.XRControl.Name": "Ad",
  "DevExpress.XtraReports.UI.XRControl.NavigateUrl": "Gezinme URL'i",
  "DevExpress.XtraReports.UI.XRControl.NullValueText": "NULL Değer Metni",
  "DevExpress.XtraReports.UI.XRControl.Padding": "Dolgu",
  "DevExpress.XtraReports.UI.XRControl.ParentStyleUsing": "Üst Stili Kullan",
  "DevExpress.XtraReports.UI.XRControl.RightToLeft": "Sağdan sola",
  "DevExpress.XtraReports.UI.XRControl.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.XRControl.Size": "Boyut",
  "DevExpress.XtraReports.UI.XRControl.SnapLineMargin": "Çizgi Kenar Boşluğuna Oturt",
  "DevExpress.XtraReports.UI.XRControl.SnapLinePadding": "Oturtma Çizgisi Dolgusu",
  "DevExpress.XtraReports.UI.XRControl.StylePriority": "Stil Önceliği",
  "DevExpress.XtraReports.UI.XRControl.Styles": "Stiller",
  "DevExpress.XtraReports.UI.XRControl.Tag": "Künye",
  "DevExpress.XtraReports.UI.XRControl.Target": "Gezinme Hedefi",
  "DevExpress.XtraReports.UI.XRControl.Text": "Yazı",
  "DevExpress.XtraReports.UI.XRControl.TextAlignment": "Yazı Hizalama",
  "DevExpress.XtraReports.UI.XRControl.Top": "Üst",
  "DevExpress.XtraReports.UI.XRControl.Visible": "Görünür",
  "DevExpress.XtraReports.UI.XRControl.Width": "Genişlik",
  "DevExpress.XtraReports.UI.XRControl.WordWrap": "Kelime Kaydır",
  "DevExpress.XtraReports.UI.XRControl.XRControlStyles.EvenStyle": "Çift Stili",
  "DevExpress.XtraReports.UI.XRControl.XRControlStyles.OddStyle": "Tek Stili",
  "DevExpress.XtraReports.UI.XRControl.XRControlStyles.Style": "Stil",
  "DevExpress.XtraReports.UI.XRControl.XlsxFormatString": "Xlsx Biçimlendirme Kalıbı",
  "DevExpress.XtraReports.UI.XRControlEvents.OnAfterPrint": "Yazdırmadan Sonra",
  "DevExpress.XtraReports.UI.XRControlEvents.OnBeforePrint": "Yazdırmadan Önce",
  "DevExpress.XtraReports.UI.XRControlEvents.OnDraw": "Çizim",
  "DevExpress.XtraReports.UI.XRControlEvents.OnEvaluateBinding": "İlişki Değerlendirildiğinde",
  "DevExpress.XtraReports.UI.XRControlEvents.OnHtmlItemCreated": "HTML Nesnesi Oluşturulduğunda",
  "DevExpress.XtraReports.UI.XRControlEvents.OnLocationChanged": "Konum Değiştiğinde",
  "DevExpress.XtraReports.UI.XRControlEvents.OnParentChanged": "Üst Öğe Değiştiğinde",
  "DevExpress.XtraReports.UI.XRControlEvents.OnPreviewClick": "Önizleme'de Tıklandığında",
  "DevExpress.XtraReports.UI.XRControlEvents.OnPreviewDoubleClick": "Önizleme'de Çift Tıklandığında",
  "DevExpress.XtraReports.UI.XRControlEvents.OnPreviewMouseDown": "Önizleme'de Fare Butonu Tıklıyken",
  "DevExpress.XtraReports.UI.XRControlEvents.OnPreviewMouseMove": "Önizleme'de İmleç Hareket Edince",
  "DevExpress.XtraReports.UI.XRControlEvents.OnPreviewMouseUp": "Önizleme'de Fare Butonu Tıklı Değilken",
  "DevExpress.XtraReports.UI.XRControlEvents.OnPrintOnPage": "Sayfa Yazdırıldığında",
  "DevExpress.XtraReports.UI.XRControlEvents.OnSizeChanged": "Boyut Değiştiğinde",
  "DevExpress.XtraReports.UI.XRControlEvents.OnTextChanged": "Yazı Değiştiğinde",
  "DevExpress.XtraReports.UI.XRControlParameter.Name": "Adı",
  "DevExpress.XtraReports.UI.XRControlScripts": "Kontrol Betikleri",
  "DevExpress.XtraReports.UI.XRControlStyle": "Kontrol Stili",
  "DevExpress.XtraReports.UI.XRControlStyle.BackColor": "Arkaplan Rengi",
  "DevExpress.XtraReports.UI.XRControlStyle.BorderColor": "Sınır Rengi",
  "DevExpress.XtraReports.UI.XRControlStyle.BorderDashStyle": "Sınır Vurgu Stili",
  "DevExpress.XtraReports.UI.XRControlStyle.BorderWidth": "Sınır Genişliği",
  "DevExpress.XtraReports.UI.XRControlStyle.Borders": "Sınırlar",
  "DevExpress.XtraReports.UI.XRControlStyle.Font": "Yazı Tipi",
  "DevExpress.XtraReports.UI.XRControlStyle.ForeColor": "Önplan Rengi",
  "DevExpress.XtraReports.UI.XRControlStyle.Padding": "Dolgu",
  "DevExpress.XtraReports.UI.XRControlStyle.StyleUsing": "Stil Kullan",
  "DevExpress.XtraReports.UI.XRControlStyle.TextAlignment": "Yazı Hizalama",
  "DevExpress.XtraReports.UI.XRCrossBandBox": "Şerit-Kesen Kutucuk",
  "DevExpress.XtraReports.UI.XRCrossBandControl.EndBand": "Bitim Şeirid",
  "DevExpress.XtraReports.UI.XRCrossBandControl.EndPoint": "Bitim Noktası",
  "DevExpress.XtraReports.UI.XRCrossBandControl.StartBand": "Başlangıç Şeridi",
  "DevExpress.XtraReports.UI.XRCrossBandControl.StartPoint": "Başlangıç Noktası",
  "DevExpress.XtraReports.UI.XRCrossBandLine": "Şerit-Kesen Çizgi",
  "DevExpress.XtraReports.UI.XRCrossBandLine.LineStyle": "Çizgi Stili",
  "DevExpress.XtraReports.UI.XRCrossTab.CrossTabStyles": "Stiller",
  "DevExpress.XtraReports.UI.XRCrossTab.DataAdapter": "Veri Bağdaştırıcısı",
  "DevExpress.XtraReports.UI.XRCrossTab.DataMember": "Veri Öğesi",
  "DevExpress.XtraReports.UI.XRCrossTab.DataSource": "Veri Kaynağı",
  "DevExpress.XtraReports.UI.XRCrossTab.Parameters": "Değişkenler",
  "DevExpress.XtraReports.UI.XRCrossTab.PrintOptions": "Yazdırma Seçenekleri",
  "DevExpress.XtraReports.UI.XRDockStyle.Bottom": "Alt",
  "DevExpress.XtraReports.UI.XRDockStyle.Fill": "Doldur",
  "DevExpress.XtraReports.UI.XRDockStyle.None": "Hiçbiri",
  "DevExpress.XtraReports.UI.XRDockStyle.Top": "Üst",
  "DevExpress.XtraReports.UI.XRGauge": "ölçer",
  "DevExpress.XtraReports.UI.XRGauge.ActualValue": "Gerçek değer",
  "DevExpress.XtraReports.UI.XRGauge.ImageType": "Resim Tipi",
  "DevExpress.XtraReports.UI.XRGauge.Maximum": "Maksimum",
  "DevExpress.XtraReports.UI.XRGauge.Minimum": "En az",
  "DevExpress.XtraReports.UI.XRGauge.TargetValue": "Hedef değer",
  "DevExpress.XtraReports.UI.XRGauge.ViewStyle": "Görünüm Stili",
  "DevExpress.XtraReports.UI.XRGauge.ViewType": "Görünüm Türü",
  "DevExpress.XtraReports.UI.XRGroupSortingSummary": "Grup Sıralama Özeti",
  "DevExpress.XtraReports.UI.XRGroupSortingSummary.Enabled": "Etkin",
  "DevExpress.XtraReports.UI.XRGroupSortingSummary.FieldName": "Alan Adı",
  "DevExpress.XtraReports.UI.XRGroupSortingSummary.Function": "Fonksiyon",
  "DevExpress.XtraReports.UI.XRGroupSortingSummary.IgnoreNullValues": "NULL Değerleri Gözardı Et",
  "DevExpress.XtraReports.UI.XRGroupSortingSummary.SortOrder": "Sıralama Düzeni",
  "DevExpress.XtraReports.UI.XRLabel": "Etiket",
  "DevExpress.XtraReports.UI.XRLabel.Angle": "Açı",
  "DevExpress.XtraReports.UI.XRLabel.AutoWidth": "Otomatik Genişlik",
  "DevExpress.XtraReports.UI.XRLabel.KeepTogether": "Birlikte Tut",
  "DevExpress.XtraReports.UI.XRLabel.Lines": "Satırlar",
  "DevExpress.XtraReports.UI.XRLabel.Multiline": "Çoklu Satır",
  "DevExpress.XtraReports.UI.XRLabel.ProcessDuplicates": "Tekrarlayanları İşle",
  "DevExpress.XtraReports.UI.XRLabel.ProcessNullValues": "NULL Değerleri İşle",
  "DevExpress.XtraReports.UI.XRLabel.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.XRLabel.Summary": "Özet",
  "DevExpress.XtraReports.UI.XRLabel.TextFitMode": "Metin Sığdırma Modu",
  "DevExpress.XtraReports.UI.XRLabelScripts": "Etiket Betikleri",
  "DevExpress.XtraReports.UI.XRLabelScripts.OnSummaryCalculated": "Özet Hesaplandığında",
  "DevExpress.XtraReports.UI.XRLabelScripts.OnSummaryGetResult": "Özet Sonucu Alındığında",
  "DevExpress.XtraReports.UI.XRLabelScripts.OnSummaryReset": "Özet Sıfırlandığında",
  "DevExpress.XtraReports.UI.XRLabelScripts.OnSummaryRowChanged": "Özet Satırı Değiştiğinde",
  "DevExpress.XtraReports.UI.XRLine": "Satır",
  "DevExpress.XtraReports.UI.XRLine.LineDirection": "Satır Yönü",
  "DevExpress.XtraReports.UI.XRLine.LineStyle": "Satır Stili",
  "DevExpress.XtraReports.UI.XRLine.LineWidth": "Satır Genişliği",
  "DevExpress.XtraReports.UI.XRLine.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.XRLineScripts": "Satır Betikleri",
  "DevExpress.XtraReports.UI.XRPageBreak": "Sayfa Bitimi",
  "DevExpress.XtraReports.UI.XRPageBreak.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.XRPageBreakScripts.OnEvaluateBinding": "İlişkileri Değerlendir",
  "DevExpress.XtraReports.UI.XRPageInfo": "Sayfa Bilgisi",
  "DevExpress.XtraReports.UI.XRPageInfo.Format": "Biçim",
  "DevExpress.XtraReports.UI.XRPageInfo.PageInfo": "Sayfa Bilgisi",
  "DevExpress.XtraReports.UI.XRPageInfo.RunningBand": "Devamlı Şerit",
  "DevExpress.XtraReports.UI.XRPageInfo.StartPageNumber": "İlk Sayfa Numarası",
  "DevExpress.XtraReports.UI.XRPanel": "Panel",
  "DevExpress.XtraReports.UI.XRPdfContent.PageRange": "Sayfa Aralığı",
  "DevExpress.XtraReports.UI.XRPdfSignature.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.XRPictureBox": "Resim Kutusu",
  "DevExpress.XtraReports.UI.XRPictureBox.Image": "Resim",
  "DevExpress.XtraReports.UI.XRPictureBox.ImageUrl": "Resim URL'i",
  "DevExpress.XtraReports.UI.XRPictureBox.Sizing": "Ölçülendirme",
  "DevExpress.XtraReports.UI.XRPivotGrid": "Pivot Çizelgesi",
  "DevExpress.XtraReports.UI.XRPivotGrid.Appearance": "Görünüm",
  "DevExpress.XtraReports.UI.XRPivotGrid.DataAdapter": "Veri Bağdaştırıcısı",
  "DevExpress.XtraReports.UI.XRPivotGrid.DataMember": "Veri Öğesi",
  "DevExpress.XtraReports.UI.XRPivotGrid.DataSource": "Veri Kaynağı",
  "DevExpress.XtraReports.UI.XRPivotGrid.Fields": "Alanlar",
  "DevExpress.XtraReports.UI.XRPivotGrid.OLAPConnectionString": "OLAP Bağlantı Adresi",
  "DevExpress.XtraReports.UI.XRPivotGrid.OLAPDataProvider": "OLAP veri sağlayıcısı",
  "DevExpress.XtraReports.UI.XRPivotGrid.OptionsChartDataSource": "Seçenekler Grafiği Veri Kaynağı",
  "DevExpress.XtraReports.UI.XRPivotGrid.OptionsData": "Veri Seçenekleri",
  "DevExpress.XtraReports.UI.XRPivotGrid.OptionsDataField": "Veri Alanı Seçenekleri",
  "DevExpress.XtraReports.UI.XRPivotGrid.OptionsPrint": "Yazdırma Seçenekleri",
  "DevExpress.XtraReports.UI.XRPivotGrid.OptionsView": "Görünüm Seçenekleri",
  "DevExpress.XtraReports.UI.XRPivotGrid.Prefilter": "ÖnSüzgeç",
  "DevExpress.XtraReports.UI.XRPivotGrid.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.XRPivotGrid.Styles": "Stiller",
  "DevExpress.XtraReports.UI.XRPivotGridScripts": "PivotGrid Betikleri",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomCellDisplayText": "Kişisel Hücre Gösterim Metni",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomCellValue": "Kişisel Hücre Değeri",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomColumnWidth": "Kişisel Sütun Genişliği",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomFieldSort": "Kişisel Alan Sırası",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomFieldValueCells": "Kişisel Alan Değeri Hücreleri",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomGroupInterval": "Kişisel Grup Aralığı",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomRowHeight": "Kişisel Satır Yüksekliği",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomSummary": "Kişisel Özet",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnCustomUnboundFieldData": "Kişisel İlişkisiz Alan Verisi",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnFieldValueDisplayText": "Alan Değeri Gösterim Metni",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnPrefilterCriteriaChanged": "ÖnSüzgeç Kriteri Değiştiğinde",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnPrintCell": "Hücre Yazdırıldığında",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnPrintFieldValue": "Alan Değeri Yazdırıldığında",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnPrintHeader": "Başlık Yazdırıldığında",
  "DevExpress.XtraReports.UI.XRPivotGridScripts.OnSizeChanged": "Boyut Değiştiğinde",
  "DevExpress.XtraReports.UI.XRRichText": "Zengin Metin",
  "DevExpress.XtraReports.UI.XRRichText.Lines": "Satırlar",
  "DevExpress.XtraReports.UI.XRRichTextBase.RtfText": "Zengin Metin",
  "DevExpress.XtraReports.UI.XRRichTextBoxBase.BackColor": "Arkaplan Rengi",
  "DevExpress.XtraReports.UI.XRRichTextBoxBase.DetectUrls": "URL'leri Algıla",
  "DevExpress.XtraReports.UI.XRRichTextBoxBase.Font": "Yazı Tipi",
  "DevExpress.XtraReports.UI.XRRichTextBoxBase.Lines": "Satırlar",
  "DevExpress.XtraReports.UI.XRRichTextBoxBase.Multiline": "Çoklu Satır",
  "DevExpress.XtraReports.UI.XRShape": "Şekil",
  "DevExpress.XtraReports.UI.XRShape.Angle": "Açı",
  "DevExpress.XtraReports.UI.XRShape.FillColor": "Doldurma Rengi",
  "DevExpress.XtraReports.UI.XRShape.LineStyle": "Çizgi stili",
  "DevExpress.XtraReports.UI.XRShape.LineWidth": "Çizgi Genişliği",
  "DevExpress.XtraReports.UI.XRShape.Shape": "Şekil",
  "DevExpress.XtraReports.UI.XRShape.Stretch": "Uzat",
  "DevExpress.XtraReports.UI.XRSparkline": "Mini grafik",
  "DevExpress.XtraReports.UI.XRSparkline.DataAdapter": "Veri bağdaştırıcısı",
  "DevExpress.XtraReports.UI.XRSparkline.DataMember": "Veri üyesi",
  "DevExpress.XtraReports.UI.XRSparkline.DataSource": "Veri kaynağı",
  "DevExpress.XtraReports.UI.XRSparkline.ImageType": "Resim Tipi",
  "DevExpress.XtraReports.UI.XRSparkline.ValueMember": "Değer Üyesi",
  "DevExpress.XtraReports.UI.XRSparkline.View": "Görünüm",
  "DevExpress.XtraReports.UI.XRSubreport": "Alt Rapor",
  "DevExpress.XtraReports.UI.XRSubreport.ReportSourceUrl": "Rpor Kaynak URL'i",
  "DevExpress.XtraReports.UI.XRSummary.FormatString": "Biçimlendirme Kalıbı",
  "DevExpress.XtraReports.UI.XRSummary.Func": "Fonksiyon",
  "DevExpress.XtraReports.UI.XRSummary.IgnoreNullValues": "NULL Değerleri Gözardı Et",
  "DevExpress.XtraReports.UI.XRSummary.Running": "Çalışan",
  "DevExpress.XtraReports.UI.XRSummaryEvents.OnGetResult": "Sonuç Alındığında",
  "DevExpress.XtraReports.UI.XRSummaryEvents.OnReset": "Sıfırlandığında",
  "DevExpress.XtraReports.UI.XRSummaryEvents.OnRowChanged": "Satır Değiştiğinde",
  "DevExpress.XtraReports.UI.XRTable": "Tablo",
  "DevExpress.XtraReports.UI.XRTableCell": "Tablo Hücresi",
  "DevExpress.XtraReports.UI.XRTableCell.RowSpan": "Satır aralığı",
  "DevExpress.XtraReports.UI.XRTableOfContents": "İçindekiler tablosu",
  "DevExpress.XtraReports.UI.XRTableOfContents.LevelDefault": "Düzey varsayılan",
  "DevExpress.XtraReports.UI.XRTableOfContents.LevelTitle": "Düzey adı",
  "DevExpress.XtraReports.UI.XRTableOfContents.MaxNestingLevel": "Max iç içe geçme",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevel": "İçindekiler tablosu düzeyini",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevel.Indent": "Girinti",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevel.LeaderSymbol": "Lider sembol",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevelBase.BackColor": "Arka plan rengi",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevelBase.Font": "Yazı tipi",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevelBase.ForeColor": "Ön plan rengi",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevelBase.Height": "Yükseklik",
  "DevExpress.XtraReports.UI.XRTableOfContentsLevelBase.Padding": "Doldurma",
  "DevExpress.XtraReports.UI.XRTableOfContentsTitle": "İçindekiler başlığı tablosu",
  "DevExpress.XtraReports.UI.XRTableOfContentsTitle.Text": "Metin",
  "DevExpress.XtraReports.UI.XRTableOfContentsTitle.TextAlignment": "Metin hizalama",
  "DevExpress.XtraReports.UI.XRTableRow": "Tablo Satırı",
  "DevExpress.XtraReports.UI.XRZipCode": "Alan Kodu",
  "DevExpress.XtraReports.UI.XRZipCode.SegmentWidth": "Kısım Genişliği",
  "DevExpress.XtraReports.UI.XtraReport": "Rapor",
  "DevExpress.XtraReports.UI.XtraReport.Bookmark": "Yer İmi",
  "DevExpress.XtraReports.UI.XtraReport.CalculatedFields": "Hesap Alanları",
  "DevExpress.XtraReports.UI.XtraReport.DataSourceSchema": "Veri Kaynağı Şeması",
  "DevExpress.XtraReports.UI.XtraReport.DefaultPrinterSettingsUsing": "Varsayılan Yazıcı Ayarları Kullanılarak",
  "DevExpress.XtraReports.UI.XtraReport.DesignerOptions": "Tasarımcı Seçenekleri",
  "DevExpress.XtraReports.UI.XtraReport.DisplayName": "Gösterim Adı",
  "DevExpress.XtraReports.UI.XtraReport.DrawGrid": "Grid Çiz",
  "DevExpress.XtraReports.UI.XtraReport.DrawWatermark": "Filigran Çiz",
  "DevExpress.XtraReports.UI.XtraReport.ExportOptions": "Dışarı Aktarma Seçenekleri",
  "DevExpress.XtraReports.UI.XtraReport.FormattingRuleSheet": "Biçimlendirme Kural Sayfası",
  "DevExpress.XtraReports.UI.XtraReport.Landscape": "Yatay",
  "DevExpress.XtraReports.UI.XtraReport.Margins": "Kenar Boşlukları",
  "DevExpress.XtraReports.UI.XtraReport.PageColor": "Sayfa Rengi",
  "DevExpress.XtraReports.UI.XtraReport.PageHeight": "Sayfa Yüksekliği",
  "DevExpress.XtraReports.UI.XtraReport.PageWidth": "Sayfa Genişliği",
  "DevExpress.XtraReports.UI.XtraReport.PaperKind": "Kağıt Türü",
  "DevExpress.XtraReports.UI.XtraReport.PaperName": "Kağıt Adı",
  "DevExpress.XtraReports.UI.XtraReport.Parameters": "Değişkenler",
  "DevExpress.XtraReports.UI.XtraReport.PreviewRowCount": "Önizleme İçin Satır Sayısı",
  "DevExpress.XtraReports.UI.XtraReport.PrinterName": "Yazıcı Adı",
  "DevExpress.XtraReports.UI.XtraReport.ReportPrintOptions": "Rapor Yazdırma Seçenekleri",
  "DevExpress.XtraReports.UI.XtraReport.ReportUnit": "Ölçme Birimleri",
  "DevExpress.XtraReports.UI.XtraReport.RequestParameters": "İstek Değişkenleri",
  "DevExpress.XtraReports.UI.XtraReport.RightToLeftLayout": "Şu sol düzenine",
  "DevExpress.XtraReports.UI.XtraReport.ScriptLanguage": "Betik Dili",
  "DevExpress.XtraReports.UI.XtraReport.ScriptReferences": "Betik Referansları",
  "DevExpress.XtraReports.UI.XtraReport.ScriptSecurityPermissions": "Betik Güvenlik İzinleri",
  "DevExpress.XtraReports.UI.XtraReport.Scripts": "Betikler",
  "DevExpress.XtraReports.UI.XtraReport.ShowDesignerHints": "Tasarıcı İpuçlarını Göster",
  "DevExpress.XtraReports.UI.XtraReport.ShowExportWarnings": "Dışa Aktarım Uyarılarını Göster",
  "DevExpress.XtraReports.UI.XtraReport.ShowPreviewMarginLines": "Kenar Boşluk Çizgilerini Önizlemede Göster",
  "DevExpress.XtraReports.UI.XtraReport.ShowPrintMarginsWarning": "Yazdırma Kenar Boşluk Uyarılarını Göster",
  "DevExpress.XtraReports.UI.XtraReport.ShowPrintStatusDialog": "Yazdırma Durum Diyalogunu Göster",
  "DevExpress.XtraReports.UI.XtraReport.ShowPrintingWarnings": "Yazdırma Uyarılarını Göster",
  "DevExpress.XtraReports.UI.XtraReport.SnapGridSize": "Kılavuz Çizgisi Boyutuna Oturt",
  "DevExpress.XtraReports.UI.XtraReport.SnappingMode": "Oturtma Modu",
  "DevExpress.XtraReports.UI.XtraReport.StyleSheet": "Stil Sayfası",
  "DevExpress.XtraReports.UI.XtraReport.StyleSheetPath": "Stil Sayfası Adresi",
  "DevExpress.XtraReports.UI.XtraReport.VerticalContentSplitting": "Dikey İçerik Bölme",
  "DevExpress.XtraReports.UI.XtraReport.Watermark": "Filigran",
  "DevExpress.XtraReports.UI.XtraReport.XRLanguage": "Dil",
  "DevExpress.XtraReports.UI.XtraReportBase.Bands": "Şeritler",
  "DevExpress.XtraReports.UI.XtraReportBase.DataAdapter": "Veri Bağdaştırıcısı",
  "DevExpress.XtraReports.UI.XtraReportBase.DataMember": "Veri Öğesi",
  "DevExpress.XtraReports.UI.XtraReportBase.DataSource": "Veri Kaynağı",
  "DevExpress.XtraReports.UI.XtraReportBase.FilterString": "Süzgeç Kalıbı",
  "DevExpress.XtraReports.UI.XtraReportBase.SortFields": "Sıralama Alanları",
  "DevExpress.XtraReports.UI.XtraReportBase.XmlDataPath": "XML Veri Adresi",
  "DevExpress.XtraReports.UI.XtraReportScripts": "Rapor Betikleri",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnBandHeightChanged": "Şerit Yükseklği Değiştiğinde",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnDataSourceDemanded": "Veri Kaynağı İstendiğinde",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnDataSourceRowChanged": "Veri Kaynağı Satırı Değiştiğinde",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnFillEmptySpace": "Boş Alan Doldurulduğunda",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnParametersRequestBeforeShow": "Gösterimden Önce Değişkenler İstendiğinde",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnParametersRequestSubmit": "Değişkenler Gönderildiğinde",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnParametersRequestValueChanged": "Değişkenler Değiştiğinde",
  "DevExpress.XtraReports.UI.XtraReportScripts.OnPrintProgress": "Yazdırma İlerlediğinde",
  "DevExpress.XtraReports.Wizards.TemplateFieldKind.Comments": "Yorumlar",
  "DevExpress.XtraReports.Wizards.TemplateFieldKind.Note": "Not",
  "DevExpress.XtraReports.Wizards.TemplateFieldKind.UnitVAT": "Birim KDV",
  "DevExpress.XtraReports.Wizards.TemplateFieldKind.VendorContactName": "Satıcı ilgili kişi adı",
  "GaugesPresetsStringId.ShapeFull": "Tam",
  "GaugesPresetsStringId.ShapeHalf": "Yarım",
  "GaugesPresetsStringId.ShapeHorizontal": "Yatay",
  "GaugesPresetsStringId.ShapeQuarterLeft": "Sol Çeyrek",
  "GaugesPresetsStringId.ShapeQuarterRight": "Sağ Çeyrek",
  "GaugesPresetsStringId.ShapeThreeFourth": "Üçüncü Çeyrek",
  "GaugesPresetsStringId.ShapeVertical": "Dikey",
  "GaugesPresetsStringId.ShapeWide": "Geniş",
  "GaugesPresetsStringId.StyleChooserFilterShape": "Şekil",
  "GaugesPresetsStringId.StyleChooserFilterTheme": "Tema",
  "GaugesPresetsStringId.ThemeAfricaSunset": "Afrika günbatımı",
  "GaugesPresetsStringId.ThemeClassic": "Klasik",
  "GaugesPresetsStringId.ThemeCleanWhite": "Temiz beyaz",
  "GaugesPresetsStringId.ThemeClever": "Zeki",
  "GaugesPresetsStringId.ThemeCosmic": "Kozmik",
  "GaugesPresetsStringId.ThemeDarkNight": "Karanlık gece",
  "GaugesPresetsStringId.ThemeDeepFire": "Derin yangın",
  "GaugesPresetsStringId.ThemeDefault": "Varsayılan",
  "GaugesPresetsStringId.ThemeDisco": "Disko",
  "GaugesPresetsStringId.ThemeEco": "Eko",
  "GaugesPresetsStringId.ThemeFlatDark": "Düz koyu",
  "GaugesPresetsStringId.ThemeFlatLight": "Düz ışık",
  "GaugesPresetsStringId.ThemeFuture": "Gelecek",
  "GaugesPresetsStringId.ThemeGothicMat": "Gotik Mat",
  "GaugesPresetsStringId.ThemeIceColdZone": "Buz gibi soğuk bölge",
  "GaugesPresetsStringId.ThemeMagicLight": "Büyülü ışık",
  "GaugesPresetsStringId.ThemeMechanical": "Mekanik",
  "GaugesPresetsStringId.ThemeMilitary": "Askeri",
  "GaugesPresetsStringId.ThemeProgressive": "Progresif",
  "GaugesPresetsStringId.ThemePureDark": "Saf karanlık",
  "GaugesPresetsStringId.ThemeRed": "Kırmızı",
  "GaugesPresetsStringId.ThemeRetro": "Retro",
  "GaugesPresetsStringId.ThemeShiningDark": "Karanlıkta Parlayan",
  "GaugesPresetsStringId.ThemeSilverBlur": "Gümüş bulanıklık",
  "GaugesPresetsStringId.ThemeSmart": "Akıllı",
  "GaugesPresetsStringId.ThemeSportCar": "Spor araba",
  "GaugesPresetsStringId.ThemeWhite": "Beyaz",
  "GaugesPresetsStringId.ThemeYellowSubmarine": "Sarı Denizaltı",
  "GaugesPresetsStringId.ThemeiStyle": "iStyle",
  "ReportStringId.BCForm_Lbl_Binding": "İlişkilendirme",
  "ReportStringId.BCForm_Lbl_Property": "Özellik",
  "ReportStringId.BandCollectionEditor_UnboundDetailReport": "İlişkisiz",
  "ReportStringId.BandDsg_QuantityPerPage": "Sayfa başına bir şerit",
  "ReportStringId.BandDsg_QuantityPerReport": "Rapor başına bir şerit",
  "ReportStringId.BindingMapperForm_InvalidBindingWarning": "Geçersiz ilişkilendirme",
  "ReportStringId.BindingMapperForm_ShowOnlyInvalidBindings": "Sadece geçersiz ilişkilendirmeleri göster",
  "ReportStringId.CatAppearance": "Görünüm",
  "ReportStringId.CatBehavior": "Davranış",
  "ReportStringId.CatData": "Veri",
  "ReportStringId.CatDesign": "Tasarım",
  "ReportStringId.CatElements": "Öğeleri",
  "ReportStringId.CatLayout": "Düzen",
  "ReportStringId.CatNavigation": "Gezinme",
  "ReportStringId.CatOptions": "Seçenekler",
  "ReportStringId.CatPageSettings": "Sayfa Ayarları",
  "ReportStringId.CatParameters": "Değişkenler",
  "ReportStringId.CatPrinting": "Yazdırma",
  "ReportStringId.CatReportData": "Rapor",
  "ReportStringId.CatStructure": "Yapı",
  "ReportStringId.CatUserDesigner": "Kullanıcı Tasarımcısı",
  "ReportStringId.Cmd_AlignToGrid": "Grid'e Hizala",
  "ReportStringId.Cmd_AssignEvenStyleToXRControl": "XRControl için Çift Stili Ata",
  "ReportStringId.Cmd_AssignOddStyleToXRControl": "XRControl için Tek Stili Ata",
  "ReportStringId.Cmd_AssignStyleToXRControl": "XRControl için Stil Ata",
  "ReportStringId.Cmd_BandExpandAll": "Bantları Genişlet",
  "ReportStringId.Cmd_BandMoveDown": "Aşağı Taşı",
  "ReportStringId.Cmd_BandMoveUp": "Yukarı Taşı",
  "ReportStringId.Cmd_BottomMargin": "AltKenarBoşluğu",
  "ReportStringId.Cmd_BringToFront": "&Öne Getir",
  "ReportStringId.Cmd_CloneStyle": "Klon Stili",
  "ReportStringId.Cmd_Commands": "Komutlar",
  "ReportStringId.Cmd_Copy": "&Kopyala",
  "ReportStringId.Cmd_CopyGalleryItem": "Kopyala",
  "ReportStringId.Cmd_Cut": "&Yapıştır",
  "ReportStringId.Cmd_CutGalleryItem": "Kes",
  "ReportStringId.Cmd_Delete": "&Sil",
  "ReportStringId.Cmd_DeleteFormattingRule": "Sil",
  "ReportStringId.Cmd_DeleteGalleryItem": "Sil",
  "ReportStringId.Cmd_DeleteStyle": "Sil",
  "ReportStringId.Cmd_Detail": "Detay",
  "ReportStringId.Cmd_DetailReport": "DetayRaporu",
  "ReportStringId.Cmd_EditStyles": "Stilleri Düzenle...",
  "ReportStringId.Cmd_GroupFooter": "GrupAltlığı",
  "ReportStringId.Cmd_GroupHeader": "GrupBaşlığı",
  "ReportStringId.Cmd_InsertBand": "&Şerit Ekle",
  "ReportStringId.Cmd_InsertDetailReport": "Detay Raporu Ekle",
  "ReportStringId.Cmd_InsertUnboundDetailReport": "İlişkisiz",
  "ReportStringId.Cmd_NavigateToControl": "Denetime Gidin",
  "ReportStringId.Cmd_PageFooter": "SayfaAltlığı",
  "ReportStringId.Cmd_PageHeader": "SayfaBaşlığı",
  "ReportStringId.Cmd_Paste": "Ya&pıştır",
  "ReportStringId.Cmd_PasteGalleryItem": "Yapıştır",
  "ReportStringId.Cmd_Properties": "Ö&zellikler",
  "ReportStringId.Cmd_PurgeStyles": "Kullanılmayan stilleri sil",
  "ReportStringId.Cmd_RefreshGallery": "Yenile",
  "ReportStringId.Cmd_RenameGalleryItem": "Yeniden adlandırma",
  "ReportStringId.Cmd_ReportFooter": "RaporAltlığı",
  "ReportStringId.Cmd_ReportHeader": "RaporBaşlığı",
  "ReportStringId.Cmd_RtfClear": "Temizle",
  "ReportStringId.Cmd_RtfLoad": "Dosya Yükle...",
  "ReportStringId.Cmd_SendToBack": "&Arkaya At",
  "ReportStringId.Cmd_TableConvertToLabels": "& etiketlerine dönüştürmek",
  "ReportStringId.Cmd_TableDelete": "&Sil",
  "ReportStringId.Cmd_TableDeleteCell": "&Hücre",
  "ReportStringId.Cmd_TableDeleteColumn": "Sü&tun",
  "ReportStringId.Cmd_TableDeleteRow": "Sat&ır",
  "ReportStringId.Cmd_TableInsert": "Ek&le",
  "ReportStringId.Cmd_TableInsertCell": "Hüc&re",
  "ReportStringId.Cmd_TableInsertColumnToLeft": "S&ola Sütun",
  "ReportStringId.Cmd_TableInsertColumnToRight": "Sa&ğa Sütun",
  "ReportStringId.Cmd_TableInsertRowAbove": "&Üste Satır",
  "ReportStringId.Cmd_TableInsertRowBelow": "&Alta Satır",
  "ReportStringId.Cmd_TopMargin": "ÜstKenarBoşluğu",
  "ReportStringId.Cmd_ViewCode": "Ko&du Göster",
  "ReportStringId.CrossTab_ColumnAreaName": "Sütunlar",
  "ReportStringId.CrossTab_DataAreaName": "Veri",
  "ReportStringId.CrossTab_DropFieldFromAnotherDataMember_ToolTip": "Çapraz Sekme hücreleri yalnızca atanan veri üyesinden alanlara bağlanabilir.",
  "ReportStringId.CrossTab_DropFieldFromAnotherDataSource_ToolTip": "Çapraz Sekme hücreleri yalnızca atanan veri kaynağından alanlara bağlanabilir.",
  "ReportStringId.CrossTab_DropOntoReservedCell_ToolTip": "Bu Çapraz Sekme hücresi ayrılmıştır.",
  "ReportStringId.CrossTab_DropReportParameter_ToolTip": "Çapraz Sekme hücreleri rapor parametrelerine bağlı olamaz.",
  "ReportStringId.CrossTab_RowAreaName": "Satırlar",
  "ReportStringId.DesignerStatus_Height": "Yükseklik",
  "ReportStringId.DesignerStatus_Location": "Yer",
  "ReportStringId.DesignerStatus_Size": "Boyut",
  "ReportStringId.DesignerStatus_Width": "Genişlik",
  "ReportStringId.Dlg_SaveFile_Title": "Kaydet '{0}'",
  "ReportStringId.ExpressionEditor_ConditionCaption": "Koşul Düzenleyici",
  "ReportStringId.ExpressionEditor_Description_Arguments_PageCount": "Rapor belgede sayfa sayısı verir.",
  "ReportStringId.ExpressionEditor_Description_FieldsPrefix": "Bu alanın tipi:",
  "ReportStringId.ExpressionEditor_Description_Function_Argb": "Argb (Alfa, kırmızı, yeşil, mavi)\n\nAlfa, kırmızı, yeşil ve mavi renk kanal değerlerini kullanarak bir renk tanımlayan bir dize döndürür.",
  "ReportStringId.ExpressionEditor_Description_Function_Rgb": "Rgb (kırmızı, yeşil, mavi)\n\nKırmızı, yeşil ve mavi renk kanal değerlerini kullanarak bir renk tanımlayan bir dize döndürür.",
  "ReportStringId.ExpressionEditor_Description_Function_SummaryPercentage": "sumPercentage(Expression)\n\nGeçerli veri satır'ın değeri için belirtilen Özet bölgesi (grup, sayfa veya rapor) içindeki tüm değerlerin toplamını yüzde oranını hesaplar.",
  "ReportStringId.ExpressionEditor_Description_Function_SummaryRecordNumber": "sumRecordNumber(Expression)\n\nBölgede belirtilen Özet (grup, sayfa veya rapor) veri kaynağındaki geçerli kayıt sayısını döndürür. Bu örneğin, bir grup için Özet hesaplanması durumunda, o zaman kayıt sayısı yalnızca bu grup içinde hesaplanır ve yeni bir grup her başlatıldığında sıfırlanır anlamına gelir.",
  "ReportStringId.ExpressionEditor_Description_Function_SummaryRunningSum": "sumRunningSum(Expression)\n\nGeçerli veri satırı önce basıldı, tüm değerlerini, geçerli veri satır'ın değeri ile özetler.",
  "ReportStringId.ExpressionEditor_Description_Function_SummaryStdDev": "sumStdDev(Expression)\n\nBelirtilen Özet bölgesi (grup, sayfa veya rapor) içindeki tüm değerleri standart sapmasını hesaplar.",
  "ReportStringId.ExpressionEditor_Description_Function_SummaryWAvg": "Sumwavg (ifade, ifade)\n\nBelirtilen Özet bölge içindeki tüm değerlerin ağırlıklı ortalamasını (Grup, sayfa veya rapor) hesaplar.\nBu Özet türü aşağıdaki işlemin sonucunu verir: Sum (expression1 * expression2)/SUM (expression2).",
  "ReportStringId.ExpressionEditor_FieldDescription": "Açıklama:",
  "ReportStringId.ExpressionEditor_ItemInfo_Fields": "Alanlar",
  "ReportStringId.ExpressionEditor_ItemInfo_FunctionSummary": "Özet",
  "ReportStringId.ExpressionEditor_ItemInfo_Values": "Değerleri",
  "ReportStringId.ExpressionEditor_ItemInfo_Variables": "Değişkenler",
  "ReportStringId.ExpressionEditor_ItemInfo_Variables_CurrentRowIndex_Description": "Geçerli veri satırının veri kaynağındaki sırasını döner. Sıra 0'dan başlar.",
  "ReportStringId.ExpressionEditor_ItemInfo_Variables_RowCount_Description": "Veri kaynağındaki toplam veri satırı sayısını döner.",
  "ReportStringId.FRSForm_Msg_MoreThanOneRule": "Birden fazla biçimlendirme kuralı seçtiniz",
  "ReportStringId.FRSForm_Msg_NoRuleSelected": "Biçimlendirme kuralı seçmediniz",
  "ReportStringId.Gallery_Msg_ImportError": "Belirtilen dosyadan Galeri öğeleri",
  "ReportStringId.Gallery_Msg_ImportFromFile": "Tüm Galeri öğeleri üzerine yazılır. Devam etmek istiyor musunuz?",
  "ReportStringId.GroupSort_AddGroup": "Grup Ekle",
  "ReportStringId.GroupSort_AddSort": "Sıralama Ekle",
  "ReportStringId.GroupSort_Delete": "Sil",
  "ReportStringId.GroupSort_MoveDown": "Aşağı Taşı",
  "ReportStringId.GroupSort_MoveUp": "Yukarı Taşı",
  "ReportStringId.Msg_Caption": "XtraRaporlar",
  "ReportStringId.Msg_CreateReportInstance": "Düzenlemeye çalıştığınız rapor ile açmak istediğiniz raporun türleri farklı. Yine de açmak istiyor musunuz?",
  "ReportStringId.Msg_CreateSomeInstance": "Bir formda bir sınıftan 2 nesne yaratamazsınız.",
  "ReportStringId.Msg_CyclicBookmarks": "Raporda döngüsel yer imleri bulunuyor.",
  "ReportStringId.Msg_DontSupportMulticolumn": "Detay raporları çoklu sütunu desteklemez.",
  "ReportStringId.Msg_DuplicatedNameUsage": "Raporu bu ada sahip bir öğe içeriyor. Başka bir ad belirtin.",
  "ReportStringId.Msg_ErrorTitle": "Hata",
  "ReportStringId.Msg_FileContentCorrupted": "Rapor Şablonu yüklenemedi. Dosya bozuk veya hatalı bilgi içeriyor olabilir.",
  "ReportStringId.Msg_FileCorrupted": "Rapor Şablonu yüklenemedi. Dosya bozuk veya raporun assembly'si eksik olabilir.",
  "ReportStringId.Msg_FileNotFound": "Dosya bulunamadı.",
  "ReportStringId.Msg_FillDataError": "Veri kaynağı doldurulurken hata oluştu. Oluşan hata:",
  "ReportStringId.Msg_GroupSortNoDataSource": "Yeni bir gruplandırma yada sıralama seviyesi eklemek için önce rapora bir veri kaynağı sağlamalısınız.",
  "ReportStringId.Msg_GroupSortWarning": "Silmek istediğiniz grup başlık veya altlığı boş değil. Bu şeridi içerdiği kontrollerle birlikte silmek istiyor musunuz?",
  "ReportStringId.Msg_HierarchyPrintOptions_InvalidFields": "Rapor verileri hiyerarşik modda yazdırılamıyor. Geçersiz alanlar ayrıntı bandının HierarchyPrintOptions için atanır.",
  "ReportStringId.Msg_HierarchyPrintOptions_SameKeyAndParentFields": "Rapor verileri hiyerarşik modda yazdırılamıyor. Aynı anahtar ve üst alanlar ayrıntı bandının HierarchyPrintOptions için atanır.",
  "ReportStringId.Msg_IncorrectArgument": "Yanlış argüman değeri",
  "ReportStringId.Msg_IncorrectBandType": "Yanlış şerit tipi",
  "ReportStringId.Msg_IncorrectPadding": "Dolgu 0'dan küçük olamaz",
  "ReportStringId.Msg_InvalidCondition": "Koşul Boolean tipinde olmalı!",
  "ReportStringId.Msg_InvalidDrillDownControl": "DrillDownControl özelliği '{0}' grubu geçerli değil.",
  "ReportStringId.Msg_InvalidExpression": "Belirtilen ifade geçersiz semboller içeriyor(satır {0}, karakter {1}).",
  "ReportStringId.Msg_InvalidExpressionEx": "Belirtilen ifade geçersiz.",
  "ReportStringId.Msg_InvalidInsertControlOperation": "{0} denetimi {1} kapsayıcıya yerleştirilemez.",
  "ReportStringId.Msg_InvalidLeaderSymbolForXrTocLevel": "Geçersiz lideri simgesi.",
  "ReportStringId.Msg_InvalidMethodCall": "Nesnenin mevcut durumu için bu metod çağrısı geçersiz",
  "ReportStringId.Msg_InvalidNameUsage": "Bu adı geçersiz karakterler içeriyor. Adı bir harf ile başlamalı ve harfler içeren, numaraları ve '_' simgesi yalnızca.",
  "ReportStringId.Msg_InvalidReportSource": "Geçerli rapor soyundan ayarlanmış olamaz",
  "ReportStringId.Msg_InvalidXrTocInstance": "XRTableOfContents daha fazla hiçbir örnek rapora eklenebilir.",
  "ReportStringId.Msg_InvalidXrTocInstanceInBand": "Hayır daha örnek-in XRTableOfContents gruba eklenebilir.",
  "ReportStringId.Msg_LargeText": "Yazı çok uzun.",
  "ReportStringId.Msg_NoBookmarksWereFoundInReportForXrToc": "Raporda yer imi yok bulundu. İçindekiler tablosu oluşturmak için en az bir rapor öğe için yer işareti belirtin.",
  "ReportStringId.Msg_NoCustomFunction": "Özel işlev '{0}' bulunamadı.",
  "ReportStringId.Msg_NoEmptySummaryArgumentSupported": "Bir Özet işlevinin bağımsız değişkeni ifadesi boş olamaz.",
  "ReportStringId.Msg_NoNestedAggregateSupported": "Özet işlevin bağımsız değişkeni ifadesi bir toplama işlevi içeremez.",
  "ReportStringId.Msg_NoNestedSummarySupported": "Özet işlevin bağımsız değişkeni ifadesi bir özet işlevi içeremez.",
  "ReportStringId.Msg_NotEnoughMemoryToPaint": "Boyama için yeterli hafıza yok. Yakınlaştırma seviyesi sıfırlanacak.",
  "ReportStringId.Msg_ParameterBindingValueTypeMismatch": "Bir parametre bağlama için alt rapor parametresi \"{0}\" uyumlu olmayan bir türde bir değer atar.",
  "ReportStringId.Msg_PlacingXrTocIntoIncorrectContainer": "XRTableOfContents denetimi yalnızca rapor üstbilgisi ve altbilgisi raporun grup yerleştirilebilir.",
  "ReportStringId.Msg_ReportImporting": "Rapor şablonu alınıyor. Lütfen bekleyiniz...",
  "ReportStringId.Msg_ReservedNameUsage": "Bu adı ayrılmış. Başka bir ad belirtin.",
  "ReportStringId.Msg_ScriptCodeIsNotCorrect": "Girilen kod doğru değil",
  "ReportStringId.Msg_ScriptCompilationError": "Komut dosyası derleme bilinmeyen bir hata nedeniyle başarısız",
  "ReportStringId.Msg_ScriptError": "Betiklerde belirtilen hatalar bulunuyor:{0}",
  "ReportStringId.Msg_ScriptExecutionError": " {0} Yürütmesindeki betikte belirtilen hata oluştu:\n{1}",
  "ReportStringId.Msg_ScriptLoadingError": "Komut dosyalarını derlenir ama yürütülemiyor",
  "ReportStringId.Msg_ScriptingPermissionErrorMessage": "Bu betiği raporunuzda çalıştırmak için gerekli yetkiniz yok.\n\nDetaylar:\n\n{0}",
  "ReportStringId.Msg_SerializationErrorTitle": "Serialization Hatası",
  "ReportStringId.Msg_ShapeRotationToolTip": "Şekli döndürmek için CTRL ile birlikte farenizin sol tuşunu kullanın",
  "ReportStringId.Msg_WarningControlsAreOutOfMargin": "Yazdırma Uyarısı: Belirtilen kontroller sayfa margin'i dışarısında, bu yüzden fazladan sayfa(lar) yazdırılacak - {0}.",
  "ReportStringId.Msg_WarningControlsAreOverlapped": "Dışarı Aktarma Uyarısı: Belirtilen kontroller çakışıyor ve HTML, RTF, XLS, XLSX, CSV ve Text çıktıları düzgün olmayabilir - {0}.",
  "ReportStringId.Msg_WarningFontNameCantBeEmpty": "Yazı Tipi adı boş bırakılamaz.",
  "ReportStringId.Msg_WarningRemoveBand": "Bu işlem {0} grubu ve içerdiği tüm denetimleri kaldırır. Devam etmek istiyor musunuz?",
  "ReportStringId.Msg_WarningRemoveCalculatedFields": "Bu işlem bütün veri tablolarından bütün hesap alanlarını kaldıracak. Devam etmek istiyor musunuz?",
  "ReportStringId.Msg_WarningRemoveFormattingRules": "Bu işlem tüm biçimlendirme kurallarını kaldırır. Devam etmek istiyor musunuz?",
  "ReportStringId.Msg_WarningRemoveParameters": "Bu işlem bütün değişkenleri kaldıracak. Devam etmek istiyor musunuz?",
  "ReportStringId.Msg_WarningUnsavedReports": "Yazdırma Uyarısı: Yapılan son değişikliklerle birlikte alt raporları önizlemek için belirtilen raporları kaydet - {0}.",
  "ReportStringId.Msg_WrongReportClassName": "Deserialization işlemi sırasında bir hata oluştu - rapor sınıfı adı yanlış olabilir",
  "ReportStringId.NewParameterEditorForm_AddNewParameter": "Yeni bir parametre ekleyin",
  "ReportStringId.NewParameterEditorForm_DataAdapter": "Veri Bağdaştırıcısı:",
  "ReportStringId.NewParameterEditorForm_DataMember": "Veri Üyesi:",
  "ReportStringId.NewParameterEditorForm_DataSource": "Veri Kaynağı:",
  "ReportStringId.NewParameterEditorForm_DisplayMember": "Görüntü Öğesi:",
  "ReportStringId.NewParameterEditorForm_ValueMember": "Değer Öğesi:",
  "ReportStringId.PanelDesignMsg": "Kontrolleri bir arada tutmak için buraya yerleştirin",
  "ReportStringId.ParameterEditor_ParameterListPlaceholder": "Görüntülenecek parametre yok.",
  "ReportStringId.ParameterEditor_ParameterSettingsPlaceholder": "Bir parametre oluşturmak için Ekle düğmesini tıklatın.",
  "ReportStringId.PivotGridForm_GroupMain_Caption": "Ana",
  "ReportStringId.PivotGridForm_GroupMain_Description": "Ana Ayarlar(Alanlar, Biçimler).",
  "ReportStringId.PivotGridForm_GroupPrinting_Caption": "Yazdırma",
  "ReportStringId.PivotGridForm_GroupPrinting_Description": "Geçerli XRPivotGrid için yazdırma seçeneği yönetimi",
  "ReportStringId.PivotGridForm_ItemAppearances_Caption": "Görünümler",
  "ReportStringId.PivotGridForm_ItemAppearances_Description": "Geçerli XRPivotGrid için yazdırma görünümlerini ayarla",
  "ReportStringId.PivotGridForm_ItemFields_Caption": "Alanlar",
  "ReportStringId.PivotGridForm_ItemFields_Description": "Alanları yönet.",
  "ReportStringId.PivotGridForm_ItemLayout_Caption": "Biçim",
  "ReportStringId.PivotGridForm_ItemLayout_Description": "Geçerli XRPivotGrid'in biçimini kişiselleştir ve içeriğini önizle.",
  "ReportStringId.PivotGridForm_ItemSettings_Caption": "Yazdırma Ayarları",
  "ReportStringId.PivotGridForm_ItemSettings_Description": "Geçerli XRPivotGrid için yazdırma ayarlarını ayarla",
  "ReportStringId.PivotGridFrame_Appearances_DescriptionText": "İlgili görsel öğelerin yazdırma görünümlerini ayarlamak için en az bir tane Görünüm nesnesi seçin",
  "ReportStringId.PivotGridFrame_Fields_ColumnsText": "XRPivotGrid Alanları",
  "ReportStringId.PivotGridFrame_Fields_DescriptionText1": "XRPivotGrid alanları ekleyebilir, silebilir ve alanların ayarlarını değiştirebilirsiniz.",
  "ReportStringId.PivotGridFrame_Fields_DescriptionText2": "PivotGrid alanı oluşturmak için alanı sürükleyerek PivotGrid alan paneline bırakınız.",
  "ReportStringId.PivotGridFrame_Layouts_DescriptionText": "XRPivotGrid'in biçimini(sıralama alanları, alan düzenlemesi) değiştirin ve geçerli değişiklikleri XRPivotGrid'e uygulamak için Uygula butonunu tıklayın. Biçimi XML dosyasına kaydedebilirsiniz(Bu dosya tasarım veya çalışma anında yüklenip kullanılabilir.).",
  "ReportStringId.PivotGridFrame_Layouts_SelectorCaption1": "Alan seçicisini sakla",
  "ReportStringId.PivotGridFrame_Layouts_SelectorCaption2": "Alan seçicisini göster",
  "ReportStringId.RepTabCtl_Designer": "Tasarımcı",
  "ReportStringId.RepTabCtl_HtmlView": "HTML Görünümü",
  "ReportStringId.RepTabCtl_NoReportStatus": "Hiçbir şey",
  "ReportStringId.RepTabCtl_Preview": "Önizleme",
  "ReportStringId.RepTabCtl_ReportStatus": "{0} {{ Kağıt Türü: {1} }}",
  "ReportStringId.RepTabCtl_Scripts": "Betikler",
  "ReportStringId.RibbonXRDesign_AddParameter_Caption": "Parametre Ekle",
  "ReportStringId.RibbonXRDesign_AddParameter_STipContent": ", Raporunuza dinamik değerleri geçirmek için yeni bir parametre oluşturmak.",
  "ReportStringId.RibbonXRDesign_AddParameter_STipTitle": "Parametre Ekle",
  "ReportStringId.RibbonXRDesign_AlignBottom_Caption": "Butonları Hizala",
  "ReportStringId.RibbonXRDesign_AlignBottom_STipContent": "Seçili kontrollerin alt sınırlarını hizala",
  "ReportStringId.RibbonXRDesign_AlignBottom_STipTitle": "Alt Sınırları Hizala",
  "ReportStringId.RibbonXRDesign_AlignHorizontalCenters_Caption": "Orta Noktaları Hizala",
  "ReportStringId.RibbonXRDesign_AlignHorizontalCenters_STipContent": "Seçili kontrollerin merkezlerini yatay olarak hizala",
  "ReportStringId.RibbonXRDesign_AlignHorizontalCenters_STipTitle": "Orta Noktaları Hizala",
  "ReportStringId.RibbonXRDesign_AlignLeft_Caption": "Sol Sınırları Hizala",
  "ReportStringId.RibbonXRDesign_AlignLeft_STipContent": "Seçili kontrolleri sola hizala",
  "ReportStringId.RibbonXRDesign_AlignLeft_STipTitle": "Sol Sınırları Hizala",
  "ReportStringId.RibbonXRDesign_AlignRight_Caption": "Sağ Sınırları Hizala",
  "ReportStringId.RibbonXRDesign_AlignRight_STipContent": "Seçili kontrolleri sağa hizala",
  "ReportStringId.RibbonXRDesign_AlignRight_STipTitle": "Sağ Sınırları Hizala",
  "ReportStringId.RibbonXRDesign_AlignToGrid_Caption": "Grid'e Hizala",
  "ReportStringId.RibbonXRDesign_AlignToGrid_STipContent": "Seçili kontrollerin yerleşimini grid' göre hizala",
  "ReportStringId.RibbonXRDesign_AlignToGrid_STipTitle": "Grid'e Hizala",
  "ReportStringId.RibbonXRDesign_AlignTop_Caption": "Üst Sınırları Hizala",
  "ReportStringId.RibbonXRDesign_AlignTop_STipContent": "Seçili kontrollerin üst sınırlarını hizala",
  "ReportStringId.RibbonXRDesign_AlignTop_STipTitle": "Üst Sınırları Hizala",
  "ReportStringId.RibbonXRDesign_AlignVerticalCenters_Caption": "Merkezleri Hizala",
  "ReportStringId.RibbonXRDesign_AlignVerticalCenters_STipContent": "Seçili kontrollerin merkezlerini dikey olarak hizala",
  "ReportStringId.RibbonXRDesign_AlignVerticalCenters_STipTitle": "Merkezleri Hizala",
  "ReportStringId.RibbonXRDesign_BackColor_Caption": "Arka plan rengi",
  "ReportStringId.RibbonXRDesign_BackColor_STipContent": "Yazı arka plan rengini değiştir",
  "ReportStringId.RibbonXRDesign_BackColor_STipTitle": "Arka plan rengi",
  "ReportStringId.RibbonXRDesign_BandCollapseAll_Caption": "Tümünü Daralt",
  "ReportStringId.RibbonXRDesign_BandExpandAll_Caption": "Tümünü Genişlet",
  "ReportStringId.RibbonXRDesign_BarCodeShowText_STipContent": "Eşlik eden metin bir bar kodunu görüntülemek.",
  "ReportStringId.RibbonXRDesign_BarCodeSymbology_Caption": "Semboloji",
  "ReportStringId.RibbonXRDesign_BarCodeSymbology_STipContent": "Semboloji",
  "ReportStringId.RibbonXRDesign_BarCodeSymbology_STipTitle": "Semboloji",
  "ReportStringId.RibbonXRDesign_BorderBottom_Caption": "Alt Kenarlık",
  "ReportStringId.RibbonXRDesign_BorderBottom_STipTitle": "Alt Kenarlık",
  "ReportStringId.RibbonXRDesign_BorderColor_Caption": "Kenarlık rengi",
  "ReportStringId.RibbonXRDesign_BorderColor_STipContent": "Kenarlık rengini değiştir",
  "ReportStringId.RibbonXRDesign_BorderColor_STipTitle": "Kenarlık rengi",
  "ReportStringId.RibbonXRDesign_BorderLeft_Caption": "Sol Kenarlık",
  "ReportStringId.RibbonXRDesign_BorderLeft_STipTitle": "Sol Kenarlık",
  "ReportStringId.RibbonXRDesign_BordersAll_Caption": "Tüm Kenarlıklar",
  "ReportStringId.RibbonXRDesign_BordersAll_STipTitle": "Tüm Kenarlıklar",
  "ReportStringId.RibbonXRDesign_BordersNone_Caption": "Kenarlık yok",
  "ReportStringId.RibbonXRDesign_BordersNone_STipContent": "Seçili denetimler kenarlıkları kaldırmak.",
  "ReportStringId.RibbonXRDesign_BordersNone_STipTitle": "Kenarlık yok",
  "ReportStringId.RibbonXRDesign_BringToFront_Caption": "Öne Getir",
  "ReportStringId.RibbonXRDesign_BringToFront_STipContent": "Seçili kontrolleri öne getir",
  "ReportStringId.RibbonXRDesign_BringToFront_STipTitle": "Öne Getir",
  "ReportStringId.RibbonXRDesign_CenterHorizontally_Caption": "Yatay Ortala",
  "ReportStringId.RibbonXRDesign_CenterHorizontally_STipContent": "Seçili alanları şerit içerisinde yatay ortala",
  "ReportStringId.RibbonXRDesign_CenterHorizontally_STipTitle": "Yatay Ortala",
  "ReportStringId.RibbonXRDesign_CenterVertically_Caption": "Dikey Ortala",
  "ReportStringId.RibbonXRDesign_CenterVertically_STipContent": "Seçili alanları şerit içerisinde dikey ortala",
  "ReportStringId.RibbonXRDesign_CenterVertically_STipTitle": "Dikey Ortala",
  "ReportStringId.RibbonXRDesign_CharacterCombCellAutoWidth_STipContent": "Otomatik olarak geçerli yazı tipi boyutuna bağlı olarak hücre genişliğini ayarla.",
  "ReportStringId.RibbonXRDesign_CharacterCombCellHeight_STipTitle": "Hücre Yüksekliği",
  "ReportStringId.RibbonXRDesign_CharacterCombCellHorizontalSpacing_Caption": "Yatay Aralık:",
  "ReportStringId.RibbonXRDesign_CharacterCombCellHorizontalSpacing_STipTitle": "Hücre Yatay Aralık",
  "ReportStringId.RibbonXRDesign_CharacterCombCellVerticalSpacing_Caption": "Dikey Aralık:",
  "ReportStringId.RibbonXRDesign_ChartAddDataSource_STipContent": "Bir grafik için bir veri kaynağı kurmak.",
  "ReportStringId.RibbonXRDesign_ChartAddImageAnnotation_Caption": "Resim ek açıklama ekleme",
  "ReportStringId.RibbonXRDesign_ChartAddSeriesViewArea_Caption": "Alan",
  "ReportStringId.RibbonXRDesign_ChartAddSeriesViewArea_STipTitle": "Alan dizi",
  "ReportStringId.RibbonXRDesign_ChartAddSeriesViewBar_Caption": "Çubuk",
  "ReportStringId.RibbonXRDesign_ChartAddSeriesViewBar_STipTitle": "Bar serisi",
  "ReportStringId.RibbonXRDesign_ChartAddSeriesViewLine_Caption": "Çizgi",
  "ReportStringId.RibbonXRDesign_ChartAddSeriesViewRange_Caption": "Aralık",
  "ReportStringId.RibbonXRDesign_ChartAppearanceName_Caption": "Görünüş",
  "ReportStringId.RibbonXRDesign_ChartImageType_Caption": "Resim Tipi",
  "ReportStringId.RibbonXRDesign_ChartLoad_STipTitle": "Yükle",
  "ReportStringId.RibbonXRDesign_ChartPaletteName_Caption": "Palet",
  "ReportStringId.RibbonXRDesign_ChartPaletteName_STipContent": "Bir grafiğin serisini boyamak için bir palet seçin.",
  "ReportStringId.RibbonXRDesign_ChartPaletteName_STipTitle": "Palet",
  "ReportStringId.RibbonXRDesign_ChartSave_Caption": "Kaydet...",
  "ReportStringId.RibbonXRDesign_ChartSave_STipContent": "Bir grafik bir XML dosyası olarak kaydet.",
  "ReportStringId.RibbonXRDesign_ChartSave_STipTitle": "Kaydet",
  "ReportStringId.RibbonXRDesign_Close_Caption": "Kapat",
  "ReportStringId.RibbonXRDesign_Close_STipContent": "Geçerli Raporu Kapat",
  "ReportStringId.RibbonXRDesign_Close_STipTitle": "Kapat",
  "ReportStringId.RibbonXRDesign_ContextPage_Design": "Tasarım",
  "ReportStringId.RibbonXRDesign_ContextPage_Format": "Biçim",
  "ReportStringId.RibbonXRDesign_ContextPage_Layout": "Düzen",
  "ReportStringId.RibbonXRDesign_ContextPage_Text": "Metin",
  "ReportStringId.RibbonXRDesign_ContextPage_View": "Görünüm",
  "ReportStringId.RibbonXRDesign_Copy_Caption": "Kopyala",
  "ReportStringId.RibbonXRDesign_Copy_STipContent": "Seçili kontrolleri panoya kopyala",
  "ReportStringId.RibbonXRDesign_Copy_STipTitle": "Kopyala",
  "ReportStringId.RibbonXRDesign_Cut_Caption": "Kes",
  "ReportStringId.RibbonXRDesign_Cut_STipContent": "Seçili kontrolleri kes ve panoya kopyala",
  "ReportStringId.RibbonXRDesign_Cut_STipTitle": "Kes",
  "ReportStringId.RibbonXRDesign_DrawGridLines_Caption": "Kılavuz çizgileri",
  "ReportStringId.RibbonXRDesign_DrawGridLines_STipContent": "Mükemmel kontrol yerleşimi için rapor yüzeyinde kılavuz çizgileri gösterin.",
  "ReportStringId.RibbonXRDesign_DrawWatermark_Caption": "Filigran",
  "ReportStringId.RibbonXRDesign_DrawWatermark_STipContent": "Daha iyi tasarım deneyimi için belgenin filigranını tasarım yüzeyinde görüntüleyin. Sayfa sekmesinde filigran ayarlarını belirtin.",
  "ReportStringId.RibbonXRDesign_Exit_Caption": "Çıkış",
  "ReportStringId.RibbonXRDesign_Exit_STipContent": "Rapor Tasarımcısı'nı Kapat",
  "ReportStringId.RibbonXRDesign_Exit_STipTitle": "Çıkış",
  "ReportStringId.RibbonXRDesign_FitBoundsToContainer_STipContent": "Tüm kullanılabilir kapsayıcı alanı kaplaması için denetim boyutunu ayarlamak.",
  "ReportStringId.RibbonXRDesign_FitBoundsToText_STipContent": "Onların metni sığdırmak için seçili denetimlerin boyutunu ayarlamak.",
  "ReportStringId.RibbonXRDesign_FitTextToBounds_STipContent": "Seçilen alanların yazı tipi boyutunu tüm alanlarına uyacak şekilde ayarlayın.",
  "ReportStringId.RibbonXRDesign_FontBold_Caption": "Kalın",
  "ReportStringId.RibbonXRDesign_FontBold_STipContent": "Seçili yazıyı kalınlaştır.",
  "ReportStringId.RibbonXRDesign_FontBold_STipTitle": "Kalın",
  "ReportStringId.RibbonXRDesign_FontItalic_Caption": "İtalik",
  "ReportStringId.RibbonXRDesign_FontItalic_STipContent": "Yazıyı itelikleştir",
  "ReportStringId.RibbonXRDesign_FontItalic_STipTitle": "İtalik",
  "ReportStringId.RibbonXRDesign_FontName_STipContent": "Yazı tipi yüzünü değiştir",
  "ReportStringId.RibbonXRDesign_FontName_STipTitle": "Yazı Tipi",
  "ReportStringId.RibbonXRDesign_FontSize_STipContent": "Yazı tipi boyutunu değiştir.",
  "ReportStringId.RibbonXRDesign_FontSize_STipTitle": "Yazı Tipi Boyutu",
  "ReportStringId.RibbonXRDesign_FontStrikeout_Caption": "Üstü çizili",
  "ReportStringId.RibbonXRDesign_FontStrikeout_STipContent": "Bunu üzerinden bir çizgi çekerek tarafından seçilen metin çapraz",
  "ReportStringId.RibbonXRDesign_FontStrikeout_STipTitle": "Üstü çizili",
  "ReportStringId.RibbonXRDesign_FontUnderline_Caption": "Alt Çizgi",
  "ReportStringId.RibbonXRDesign_FontUnderline_STipContent": "Seçili yazının altını çiz.",
  "ReportStringId.RibbonXRDesign_FontUnderline_STipTitle": "Alt Çizgi",
  "ReportStringId.RibbonXRDesign_ForeColor_Caption": "Ön Plan Rengi",
  "ReportStringId.RibbonXRDesign_ForeColor_STipContent": "Metnin ön plan rengini değiştir",
  "ReportStringId.RibbonXRDesign_ForeColor_STipTitle": "Ön Plan Rengi",
  "ReportStringId.RibbonXRDesign_GaugeImageType_Caption": "Resim Tipi",
  "ReportStringId.RibbonXRDesign_HorizSpaceConcatenate_Caption": "Yatay Boşluğu Kaldır",
  "ReportStringId.RibbonXRDesign_HorizSpaceConcatenate_STipContent": "Seçili kontroller arasındaki yatay boşluğu kaldır",
  "ReportStringId.RibbonXRDesign_HorizSpaceConcatenate_STipTitle": "Yatay Boşluğu Kaldır",
  "ReportStringId.RibbonXRDesign_HorizSpaceDecrease_Caption": "Yatay Boşluğu Azalt",
  "ReportStringId.RibbonXRDesign_HorizSpaceDecrease_STipContent": "Seçili kontroller arasındaki yatay boşluğu azalt",
  "ReportStringId.RibbonXRDesign_HorizSpaceDecrease_STipTitle": "Yatay Boşluğu Azalt",
  "ReportStringId.RibbonXRDesign_HorizSpaceIncrease_Caption": "Yatay Boşluğu Arttır",
  "ReportStringId.RibbonXRDesign_HorizSpaceIncrease_STipContent": "Seçili kontroller arasındaki yatay boşluğu arttır",
  "ReportStringId.RibbonXRDesign_HorizSpaceIncrease_STipTitle": "Yatay Boşluğu Arttır",
  "ReportStringId.RibbonXRDesign_HorizSpaceMakeEqual_Caption": "Yatay Boşluğu Eşitle",
  "ReportStringId.RibbonXRDesign_HorizSpaceMakeEqual_STipContent": "Seçili kontroller arasındaki yatay boşluğu eşitle",
  "ReportStringId.RibbonXRDesign_HorizSpaceMakeEqual_STipTitle": "Yatay Boşluğu Eşitle",
  "ReportStringId.RibbonXRDesign_HtmlBackward_Caption": "Geri",
  "ReportStringId.RibbonXRDesign_HtmlBackward_STipContent": "Bir önceki syfaya dön",
  "ReportStringId.RibbonXRDesign_HtmlBackward_STipTitle": "Geri",
  "ReportStringId.RibbonXRDesign_HtmlFind_Caption": "Ara",
  "ReportStringId.RibbonXRDesign_HtmlFind_STipContent": "Bu sayfada ara",
  "ReportStringId.RibbonXRDesign_HtmlFind_STipTitle": "Ara",
  "ReportStringId.RibbonXRDesign_HtmlForward_Caption": "İleri",
  "ReportStringId.RibbonXRDesign_HtmlForward_STipContent": "Bir sonraki sayfaya ilerle",
  "ReportStringId.RibbonXRDesign_HtmlForward_STipTitle": "İleri",
  "ReportStringId.RibbonXRDesign_HtmlHome_Caption": "Ana Sayfa",
  "ReportStringId.RibbonXRDesign_HtmlHome_STipContent": "Ana sayfayı göster",
  "ReportStringId.RibbonXRDesign_HtmlHome_STipTitle": "Ana Sayfa",
  "ReportStringId.RibbonXRDesign_HtmlPageText": "HTML Görünüm",
  "ReportStringId.RibbonXRDesign_HtmlRefresh_Caption": "Yenile",
  "ReportStringId.RibbonXRDesign_HtmlRefresh_STipContent": "Sayfayı Yenile",
  "ReportStringId.RibbonXRDesign_HtmlRefresh_STipTitle": "Yenile",
  "ReportStringId.RibbonXRDesign_JustifyCenter_Caption": "Yazıyı Ortala",
  "ReportStringId.RibbonXRDesign_JustifyCenter_STipContent": "Yazıyı ortala.",
  "ReportStringId.RibbonXRDesign_JustifyCenter_STipTitle": "Yazıyı Ortala",
  "ReportStringId.RibbonXRDesign_JustifyJustify_Caption": "İki Yana Yasla",
  "ReportStringId.RibbonXRDesign_JustifyJustify_STipContent": "Yazıyı gerekirse kelimeler arasına boşluk ekleyerek sağa ve sola yasla.",
  "ReportStringId.RibbonXRDesign_JustifyJustify_STipTitle": "İki Yana Yasla",
  "ReportStringId.RibbonXRDesign_JustifyLeft_Caption": "Yazıyı Sola Yasla",
  "ReportStringId.RibbonXRDesign_JustifyLeft_STipContent": "Yazıyı sola yasla",
  "ReportStringId.RibbonXRDesign_JustifyLeft_STipTitle": "Yazıyı Sola Yasla",
  "ReportStringId.RibbonXRDesign_JustifyRight_Caption": "Yazıyı Sağa Yasla",
  "ReportStringId.RibbonXRDesign_JustifyRight_STipContent": "Yazıyı sağa yasla",
  "ReportStringId.RibbonXRDesign_JustifyRight_STipTitle": "Yazıyı Sola Yasla",
  "ReportStringId.RibbonXRDesign_LabelAutoWidth_STipContent": "Genişliklerini içeriklerine uyacak şekilde ayarlamak için seçilen kontrolleri etkinleştirin.",
  "ReportStringId.RibbonXRDesign_LabelCanGrow_STipContent": "İçeriğini sığdırmak için yüksekliğini artırmak için seçilen kontrolleri etkinleştirin.",
  "ReportStringId.RibbonXRDesign_LabelCanShrink_Caption": "Küçülebilir",
  "ReportStringId.RibbonXRDesign_LabelCanShrink_STipContent": "İçeriğini sığdırmak için yüksekliğini azaltmak için seçilen kontrolleri etkinleştirin.",
  "ReportStringId.RibbonXRDesign_LabelCanShrink_STipTitle": "Küçülebilir",
  "ReportStringId.RibbonXRDesign_LabelWordWrap_Caption": "Sözcük kaydır",
  "ReportStringId.RibbonXRDesign_LabelWordWrap_STipContent": "Bir çizgiye uymuyorsa metinlerini kaydırmak için seçilen kontrolleri etkinleştirin.",
  "ReportStringId.RibbonXRDesign_LabelWordWrap_STipTitle": "Sözcük kaydır",
  "ReportStringId.RibbonXRDesign_Language_Caption": "Dil",
  "ReportStringId.RibbonXRDesign_Language_STipTitle": "Dil",
  "ReportStringId.RibbonXRDesign_NewReportWizard_Caption": "Sihirbaz kullanarak rapor yarat...",
  "ReportStringId.RibbonXRDesign_NewReportWizard_Description": "Yeni rapor oluşturmak için sihirbazı çalıştır",
  "ReportStringId.RibbonXRDesign_NewReportWizard_STipContent": "Yeni rapor oluşturmak için sihirbazı çalıştır",
  "ReportStringId.RibbonXRDesign_NewReportWizard_STipTitle": "Sihirbaz kullanarak rapor yarat",
  "ReportStringId.RibbonXRDesign_NewReport_Caption": "Yeni Rapor",
  "ReportStringId.RibbonXRDesign_NewReport_Description": "Boş bir rapor yarat",
  "ReportStringId.RibbonXRDesign_NewReport_STipContent": "Boş bir rapor yarat",
  "ReportStringId.RibbonXRDesign_NewReport_STipTitle": "Boş Rapor",
  "ReportStringId.RibbonXRDesign_OpenFile_Caption": "Aç...",
  "ReportStringId.RibbonXRDesign_OpenFile_STipContent": "Rapor aç.",
  "ReportStringId.RibbonXRDesign_OpenFile_STipTitle": "Rapor Aç",
  "ReportStringId.RibbonXRDesign_PageColor_Caption": "Sayfa Rengi",
  "ReportStringId.RibbonXRDesign_PageGroup_Alignment": "Hizalama",
  "ReportStringId.RibbonXRDesign_PageGroup_Annotations": "ek açıklamaları",
  "ReportStringId.RibbonXRDesign_PageGroup_Appearance": "Görünüş",
  "ReportStringId.RibbonXRDesign_PageGroup_Arrange": "Yerleştir",
  "ReportStringId.RibbonXRDesign_PageGroup_Bands": "Bantlar",
  "ReportStringId.RibbonXRDesign_PageGroup_Behavior": "Davranış",
  "ReportStringId.RibbonXRDesign_PageGroup_Borders": "Kenarlıklar",
  "ReportStringId.RibbonXRDesign_PageGroup_Chart": "Grafik",
  "ReportStringId.RibbonXRDesign_PageGroup_Clipboard": "Pano",
  "ReportStringId.RibbonXRDesign_PageGroup_Data": "Veri",
  "ReportStringId.RibbonXRDesign_PageGroup_Delete": "Sil",
  "ReportStringId.RibbonXRDesign_PageGroup_Design": "Tasarım",
  "ReportStringId.RibbonXRDesign_PageGroup_Edit": "Düzenle",
  "ReportStringId.RibbonXRDesign_PageGroup_Font": "Yazı Tipi",
  "ReportStringId.RibbonXRDesign_PageGroup_HtmlNavigation": "Gezinme",
  "ReportStringId.RibbonXRDesign_PageGroup_Insert": "Ekle",
  "ReportStringId.RibbonXRDesign_PageGroup_Layout": "Düzen",
  "ReportStringId.RibbonXRDesign_PageGroup_Merge": "Birleştirme",
  "ReportStringId.RibbonXRDesign_PageGroup_PageSetup": "Sayfa yapısı",
  "ReportStringId.RibbonXRDesign_PageGroup_PivotFields": "Alanlar",
  "ReportStringId.RibbonXRDesign_PageGroup_PivotGrid": "Özet Kılavuz",
  "ReportStringId.RibbonXRDesign_PageGroup_PivotPrintOptions": "Yazdırma Seçenekleri",
  "ReportStringId.RibbonXRDesign_PageGroup_Report": "Rapor",
  "ReportStringId.RibbonXRDesign_PageGroup_Scripts": "Betikler",
  "ReportStringId.RibbonXRDesign_PageGroup_Select": "Seç",
  "ReportStringId.RibbonXRDesign_PageGroup_Series": "Seriler",
  "ReportStringId.RibbonXRDesign_PageGroup_Show": "Göster",
  "ReportStringId.RibbonXRDesign_PageGroup_SizeAndLayout": "Biçim",
  "ReportStringId.RibbonXRDesign_PageGroup_Snapping": "Yapışma",
  "ReportStringId.RibbonXRDesign_PageGroup_Sparkline": "Mini grafik",
  "ReportStringId.RibbonXRDesign_PageGroup_Styles": "Stiller",
  "ReportStringId.RibbonXRDesign_PageGroup_Symbology": "Semboloji",
  "ReportStringId.RibbonXRDesign_PageGroup_TextAlignment": "Hizalama",
  "ReportStringId.RibbonXRDesign_PageGroup_Theme": "Tema",
  "ReportStringId.RibbonXRDesign_PageGroup_View": "Görünüm",
  "ReportStringId.RibbonXRDesign_PageGroup_Zoom": "Yakınlaştır",
  "ReportStringId.RibbonXRDesign_PageMargins_Caption": "Kenar boşlukları",
  "ReportStringId.RibbonXRDesign_PageMargins_STipContent": "Bir rapor için kenar boşluğu boyutları ayarlayın. Yaygın olarak kullanılan çeşitli biçimlerden birini seçin veya kendi biçimini tanımlamak için Özel Kenar Boşlukları'nı tıklayın.",
  "ReportStringId.RibbonXRDesign_PageMargins_STipTitle": "Kenar Boşluklarını Ayarla",
  "ReportStringId.RibbonXRDesign_PageOrientation_Caption": "Yön",
  "ReportStringId.RibbonXRDesign_PageSize_Caption": "Boyut",
  "ReportStringId.RibbonXRDesign_PageText": "Rapor Tasarımcısı",
  "ReportStringId.RibbonXRDesign_PageWatermark_Caption": "Filigran",
  "ReportStringId.RibbonXRDesign_Page_Home": "Ana Sayfa",
  "ReportStringId.RibbonXRDesign_Page_Layout": "Düzen",
  "ReportStringId.RibbonXRDesign_Page_Page": "Sayfa",
  "ReportStringId.RibbonXRDesign_Page_Scripts": "Betikler",
  "ReportStringId.RibbonXRDesign_Page_View": "Görünüm",
  "ReportStringId.RibbonXRDesign_PaperKind_Caption": "Boyut",
  "ReportStringId.RibbonXRDesign_Paste_Caption": "Yapıştır",
  "ReportStringId.RibbonXRDesign_Paste_STipContent": "Pano içeriğini yapıştır",
  "ReportStringId.RibbonXRDesign_Paste_STipTitle": "Yapıştır",
  "ReportStringId.RibbonXRDesign_PivotGridAddField_Caption": "Alan Ekle",
  "ReportStringId.RibbonXRDesign_PivotGridAddField_STipTitle": "Alan Ekle",
  "ReportStringId.RibbonXRDesign_PivotGridColumnAreaOnEveryPage_Caption": "Her Sayfada Sütun Alanı",
  "ReportStringId.RibbonXRDesign_PivotGridColumnHeaders_STipContent": "Sütun alan başlıklarını yazdırın.",
  "ReportStringId.RibbonXRDesign_PivotGridHorizontalLines_Caption": "Yatay çizgiler",
  "ReportStringId.RibbonXRDesign_PivotGridRowAreaOnEveryPage_Caption": "Her Sayfada Satır Alanı",
  "ReportStringId.RibbonXRDesign_PivotGridRowAreaOnEveryPage_STipContent": "Satır alanına her sayfada yazdırmak.",
  "ReportStringId.RibbonXRDesign_PivotGridRowAreaOnEveryPage_STipTitle": "Her Sayfada Satır Alanını Yazdır",
  "ReportStringId.RibbonXRDesign_PivotGridRunDesigner_Caption": "Tasarımcısı çalıştırmak",
  "ReportStringId.RibbonXRDesign_PivotGridRunDesigner_STipTitle": "Tasarımcısı çalıştırmak",
  "ReportStringId.RibbonXRDesign_PivotGridVerticalLines_Caption": "Dikey çizgiler",
  "ReportStringId.RibbonXRDesign_PivotGridVerticalLines_STipContent": "Dikey kılavuz çizgilerini yazdırmak.",
  "ReportStringId.RibbonXRDesign_PivotGridVerticalLines_STipTitle": "Dikey çizgiler yazdır",
  "ReportStringId.RibbonXRDesign_Redo_Caption": "Yinele",
  "ReportStringId.RibbonXRDesign_Redo_STipContent": "Son işlemi yinele",
  "ReportStringId.RibbonXRDesign_Redo_STipTitle": "Yinele",
  "ReportStringId.RibbonXRDesign_SaveAll_Caption": "Hepsini Kaydet",
  "ReportStringId.RibbonXRDesign_SaveAll_STipContent": "Değiştirilen raporları kaydet",
  "ReportStringId.RibbonXRDesign_SaveAll_STipTitle": "Tüm Raporları Kaydet",
  "ReportStringId.RibbonXRDesign_SaveFileAs_Caption": "Farklı Kaydet...",
  "ReportStringId.RibbonXRDesign_SaveFileAs_Description": "Geçerli raporu başka bir isimle kaydet.",
  "ReportStringId.RibbonXRDesign_SaveFileAs_STipContent": "Geçerli raporu başka bir isimle kaydet.",
  "ReportStringId.RibbonXRDesign_SaveFileAs_STipTitle": "Raporu Farklı Kaydet...",
  "ReportStringId.RibbonXRDesign_SaveFile_Caption": "Kaydet",
  "ReportStringId.RibbonXRDesign_SaveFile_Description": "Geçerli raporu kaydet.",
  "ReportStringId.RibbonXRDesign_SaveFile_STipContent": "Geçerli raporu kaydet.",
  "ReportStringId.RibbonXRDesign_SaveFile_STipTitle": "Raporu Kaydet",
  "ReportStringId.RibbonXRDesign_ScriptsCopy_Caption": "Kopyala",
  "ReportStringId.RibbonXRDesign_ScriptsCut_Caption": "Kes",
  "ReportStringId.RibbonXRDesign_ScriptsPaste_Caption": "Yapıştır",
  "ReportStringId.RibbonXRDesign_ScriptsSelectEvent_STipContent": "Kullanılabilir olayları seçin.",
  "ReportStringId.RibbonXRDesign_ScriptsValidate_Caption": "Doğrulama",
  "ReportStringId.RibbonXRDesign_ScriptsValidate_STipContent": "Onay ister hataları rapor komut dosyaları içerir. Hata bulunmazsa, komut dosyası hataları panelinde listelendikleri.",
  "ReportStringId.RibbonXRDesign_ScriptsValidate_STipTitle": "Komut dosyaları doğrula",
  "ReportStringId.RibbonXRDesign_Scripts_Caption": "Betikler",
  "ReportStringId.RibbonXRDesign_Scripts_STipContent": "Betik Düzenleyici'yi Göster/Sakla",
  "ReportStringId.RibbonXRDesign_Scripts_STipTitle": "Betikleri Göster/Sakla",
  "ReportStringId.RibbonXRDesign_SendToBack_Caption": "Geri At",
  "ReportStringId.RibbonXRDesign_SendToBack_STipContent": "Seçili kontrolleri geri at",
  "ReportStringId.RibbonXRDesign_SendToBack_STipTitle": "Geri At",
  "ReportStringId.RibbonXRDesign_ShapeStretch_Caption": "Streç",
  "ReportStringId.RibbonXRDesign_ShapeStretch_STipContent": "Döndürülürken tüm alanını doldurmak için bir şekil uzatın.",
  "ReportStringId.RibbonXRDesign_ShapeStretch_STipTitle": "Streç",
  "ReportStringId.RibbonXRDesign_ShowDesignerTab_STipContent": "Rapor düzenini özelleştirebilir veya yeni bir düzen zengin özelliklere sahip rapor Tasarımcısı'nda oluşturduğunuz.",
  "ReportStringId.RibbonXRDesign_ShowDesignerTab_STipTitle": "Rapor Tasarımcısı",
  "ReportStringId.RibbonXRDesign_ShowExportWarnings_Caption": "Uyarı verme",
  "ReportStringId.RibbonXRDesign_ShowExportWarnings_STipContent": "Belgeyi belirli biçimlere verirken belge düzenini bozma olasılığı konusunda sizi uyarmak için kesişen rapor denetimlerini vurgulayın.",
  "ReportStringId.RibbonXRDesign_ShowPreviewTab_Caption": "Önizleme",
  "ReportStringId.RibbonXRDesign_ShowPreviewTab_STipTitle": "Baskı Önizleme",
  "ReportStringId.RibbonXRDesign_ShowPrintingWarnings_STipContent": "Belgeyi yazdırırken ekstra sayfalar hakkında sizi uyarmak için doğru sayfa kenar boşluğunu aşan rapor denetimlerini vurgulayın.",
  "ReportStringId.RibbonXRDesign_ShowPrintingWarnings_STipTitle": "Yazdırma uyarıları göster",
  "ReportStringId.RibbonXRDesign_ShowScriptsTab_Caption": "Betikler",
  "ReportStringId.RibbonXRDesign_ShowScriptsTab_STipContent": "Komut dosyası olaylarını ele alarak özel hesaplamalar yapın.",
  "ReportStringId.RibbonXRDesign_ShowScriptsTab_STipTitle": "Betikler",
  "ReportStringId.RibbonXRDesign_SizeToControlHeight_Caption": "Boylarını Eşitle",
  "ReportStringId.RibbonXRDesign_SizeToControlHeight_STipContent": "Seçili kontrollerin boylarını eşitle",
  "ReportStringId.RibbonXRDesign_SizeToControlHeight_STipTitle": "Boylarını Eşitle",
  "ReportStringId.RibbonXRDesign_SizeToControlWidth_Caption": "Enlerini Eşitle",
  "ReportStringId.RibbonXRDesign_SizeToControlWidth_STipContent": "Seçili kontrollerin enlerini eşitle",
  "ReportStringId.RibbonXRDesign_SizeToControlWidth_STipTitle": "Enlerini Eşitle",
  "ReportStringId.RibbonXRDesign_SizeToControl_Caption": "Boyutlarını Eşitle",
  "ReportStringId.RibbonXRDesign_SizeToControl_STipContent": "Seçili kontrollerin boyutlarını eşitle",
  "ReportStringId.RibbonXRDesign_SizeToControl_STipTitle": "Boyutlarını Eşitle",
  "ReportStringId.RibbonXRDesign_SizeToGrid_Caption": "Grid'e göre boyutlandır",
  "ReportStringId.RibbonXRDesign_SizeToGrid_STipContent": "Seçili kontrolleri grid'e göre boyutlandır",
  "ReportStringId.RibbonXRDesign_SizeToGrid_STipTitle": "Grid'e göre boyutlandır",
  "ReportStringId.RibbonXRDesign_SnapLines_Caption": "Satırları Yasla",
  "ReportStringId.RibbonXRDesign_SnapLines_STipTitle": "Satırları Yasla",
  "ReportStringId.RibbonXRDesign_SnapToGrid_Caption": "Kılavuza uydur",
  "ReportStringId.RibbonXRDesign_SparklineAddDataSource_STipContent": "Mini grafik için veri kaynağı kurmanıza.",
  "ReportStringId.RibbonXRDesign_SparklineImageType_Caption": "Resim Tipi",
  "ReportStringId.RibbonXRDesign_StatusBar_HtmlDone": "Bitti",
  "ReportStringId.RibbonXRDesign_StatusBar_HtmlProcessing": "İşleniyor...",
  "ReportStringId.RibbonXRDesign_TableDeleteCell_Caption": "Hücre",
  "ReportStringId.RibbonXRDesign_TableDeleteCell_STipContent": "Geçerli hücreyi silmek.",
  "ReportStringId.RibbonXRDesign_TableDeleteColumn_Caption": "Sütun",
  "ReportStringId.RibbonXRDesign_TableDeleteColumn_STipContent": "Geçerli sütunu sil.",
  "ReportStringId.RibbonXRDesign_TableDeleteColumn_STipTitle": "Sütun Sil",
  "ReportStringId.RibbonXRDesign_TableDeleteRow_Caption": "Satır",
  "ReportStringId.RibbonXRDesign_TableDeleteRow_STipContent": "Geçerli satırı sil.",
  "ReportStringId.RibbonXRDesign_TableDeleteRow_STipTitle": "Satır Sil",
  "ReportStringId.RibbonXRDesign_TableDeleteTable_Caption": "Tablo",
  "ReportStringId.RibbonXRDesign_TableDeleteTable_STipContent": "Tüm tabloyu silmek.",
  "ReportStringId.RibbonXRDesign_TableDistributeColumnsEvenly_Caption": "Sütunlar",
  "ReportStringId.RibbonXRDesign_TableDistributeColumnsEvenly_STipContent": "Onları arasında eşit olarak seçili sütunların genişliğini dağıtmak.",
  "ReportStringId.RibbonXRDesign_TableDistributeColumnsEvenly_STipTitle": "Sütunları düzgün Dağıt",
  "ReportStringId.RibbonXRDesign_TableDistributeRowsEvenly_Caption": "Satırlar",
  "ReportStringId.RibbonXRDesign_TableDistributeRowsEvenly_STipContent": "Onları arasında eşit olarak seçili satırların yüksekliğini dağıtmak.",
  "ReportStringId.RibbonXRDesign_TableDistributeRowsEvenly_STipTitle": "Satırları düzgün Dağıt",
  "ReportStringId.RibbonXRDesign_TableInsertColumnToLeft_STipContent": "Doğrudan geçerli sütunun soluna yeni bir sütun eklemek.",
  "ReportStringId.RibbonXRDesign_TableInsertColumnToLeft_STipTitle": "Sola Sütun Ekle",
  "ReportStringId.RibbonXRDesign_TableInsertColumnToRight_STipContent": "Doğrudan geçerli sütunun sağına yeni bir sütun eklemek.",
  "ReportStringId.RibbonXRDesign_TableInsertRowAbove_Caption": "Satır yukarıdaki",
  "ReportStringId.RibbonXRDesign_TableInsertRowAbove_STipTitle": "Yukarıdaki Satır Ekle",
  "ReportStringId.RibbonXRDesign_TableInsertRowBelow_Caption": "Altındaki satırı",
  "ReportStringId.RibbonXRDesign_TableInsertRowBelow_STipTitle": "Aşağıya Satır Ekle",
  "ReportStringId.RibbonXRDesign_TableMergeCells_Caption": "Hücreleri Birleştir",
  "ReportStringId.RibbonXRDesign_TableMergeCells_STipContent": "Seçili hücreleri tek bir hücrede birleştirmek.",
  "ReportStringId.RibbonXRDesign_TableMergeCells_STipTitle": "Hücreleri Birleştir",
  "ReportStringId.RibbonXRDesign_TableSelectColumn_Caption": "Sütun",
  "ReportStringId.RibbonXRDesign_TableSelectColumn_STipTitle": "Sütunu seç",
  "ReportStringId.RibbonXRDesign_TableSelectRow_Caption": "Satır",
  "ReportStringId.RibbonXRDesign_TableSelectRow_STipContent": "Geçerli satırı seç.",
  "ReportStringId.RibbonXRDesign_TableSelectRow_STipTitle": "Satır Seç",
  "ReportStringId.RibbonXRDesign_TableSelectTable_Caption": "Tablo",
  "ReportStringId.RibbonXRDesign_TableSelectTable_STipContent": "Tüm tabloyu seç",
  "ReportStringId.RibbonXRDesign_TableSelectTable_STipTitle": "Tablo seç",
  "ReportStringId.RibbonXRDesign_TableSplitCells_Caption": "Hücreleri Böl",
  "ReportStringId.RibbonXRDesign_TableSplitCells_STipTitle": "Hücreleri Böl",
  "ReportStringId.RibbonXRDesign_ToolboxControlsPage": "Araç Kutusu",
  "ReportStringId.RibbonXRDesign_Undo_Caption": "Geri Al",
  "ReportStringId.RibbonXRDesign_Undo_STipContent": "Son işlemi geri al",
  "ReportStringId.RibbonXRDesign_Undo_STipTitle": "Geri Al",
  "ReportStringId.RibbonXRDesign_ValidateScripts_Caption": "Doğrula",
  "ReportStringId.RibbonXRDesign_VertAlignBottom_Caption": "Metni Alta Hizala",
  "ReportStringId.RibbonXRDesign_VertAlignBottom_STipContent": "Alt metni hizalayın.",
  "ReportStringId.RibbonXRDesign_VertAlignBottom_STipTitle": "Metni Alta Hizala",
  "ReportStringId.RibbonXRDesign_VertAlignMiddle_Caption": "Metin Hizala",
  "ReportStringId.RibbonXRDesign_VertAlignMiddle_STipTitle": "Metin Hizala",
  "ReportStringId.RibbonXRDesign_VertSpaceConcatenate_Caption": "Dikey Boşluğu Kaldır",
  "ReportStringId.RibbonXRDesign_VertSpaceConcatenate_STipContent": "Seçili kontroller arasındaki dikey boşluğu kaldır.",
  "ReportStringId.RibbonXRDesign_VertSpaceConcatenate_STipTitle": "Dikey Boşluğu Kaldır",
  "ReportStringId.RibbonXRDesign_VertSpaceDecrease_Caption": "Dikey Boşluğu Azalt",
  "ReportStringId.RibbonXRDesign_VertSpaceDecrease_STipContent": "Seçili kontroller arasındaki dikey boşluğu azalt.",
  "ReportStringId.RibbonXRDesign_VertSpaceDecrease_STipTitle": "Dikey Boşluğu Azalt",
  "ReportStringId.RibbonXRDesign_VertSpaceIncrease_Caption": "Dikey Boşluğu Arttır",
  "ReportStringId.RibbonXRDesign_VertSpaceIncrease_STipContent": "Seçili kontroller arasındaki dikey boşluğu arttır.",
  "ReportStringId.RibbonXRDesign_VertSpaceIncrease_STipTitle": "Dikey Boşluğu Arttır",
  "ReportStringId.RibbonXRDesign_VertSpaceMakeEqual_Caption": "Dikey Boşluğu Eşitle",
  "ReportStringId.RibbonXRDesign_VertSpaceMakeEqual_STipContent": "Seçili kontroller arasındaki dikey boşluğu eşitle.",
  "ReportStringId.RibbonXRDesign_VertSpaceMakeEqual_STipTitle": "Dikey Boşluğu Eşitle",
  "ReportStringId.RibbonXRDesign_Windows_Caption": "Pencereler",
  "ReportStringId.RibbonXRDesign_Windows_STipContent": "Araç Kutusu, Rapor Gezgini Alan Listesi ve Özellik Kılavuzu pencerelerini göster/sakla",
  "ReportStringId.RibbonXRDesign_Windows_STipTitle": "pencereleri Göster/Sakla",
  "ReportStringId.RibbonXRDesign_ZoomExact_Caption": "Tam:",
  "ReportStringId.RibbonXRDesign_ZoomIn_Caption": "Yakınlaştır",
  "ReportStringId.RibbonXRDesign_ZoomIn_STipContent": "Raporun detaylı görünümü için yakınlaştır",
  "ReportStringId.RibbonXRDesign_ZoomIn_STipTitle": "Yakınlaştır",
  "ReportStringId.RibbonXRDesign_ZoomOut_Caption": "Uzaklaştır",
  "ReportStringId.RibbonXRDesign_ZoomOut_STipContent": "Raporu daha küçük görmek için uzaklaştır",
  "ReportStringId.RibbonXRDesign_ZoomOut_STipTitle": "Uzaklaştır",
  "ReportStringId.RibbonXRDesign_Zoom_Caption": "Yakınlaştır",
  "ReportStringId.RibbonXRDesign_Zoom_STipContent": "Doküman tasarımcısının yakınlaştırma seviyesini değiştir",
  "ReportStringId.RibbonXRDesign_Zoom_STipTitle": "Yakınlaştır",
  "ReportStringId.SR_Height": "Yükseklik",
  "ReportStringId.SR_Horizontal_Pitch": "Yatay seviye",
  "ReportStringId.SR_Number_Across": "Çapraz sayı",
  "ReportStringId.SR_Number_Down": "Sayı",
  "ReportStringId.SR_Side_Margins": "Yan Margin'ler",
  "ReportStringId.SR_Top_Margin": "Üst\nmargin",
  "ReportStringId.SR_Vertical_Pitch": "Dikey\nseviye",
  "ReportStringId.SR_Width": "Genişlik",
  "ReportStringId.SSForm_Msg_FileFilter": "Rapor StyleSheet dosyaları (*.repss)|*.repss|Tüm dosyalar (*.*)|*.*",
  "ReportStringId.SSForm_Msg_InvalidFileFormat": "Geçersiz dosya formatı",
  "ReportStringId.SSForm_Msg_MoreThanOneStyle": "Birden fazla stil seçtiniz",
  "ReportStringId.SSForm_Msg_NoStyleSelected": "Stil seçilmedi",
  "ReportStringId.SSForm_Msg_SelectedStylesText": " seçilen stiller...",
  "ReportStringId.SSForm_Msg_StyleNamePreviewPostfix": "stil",
  "ReportStringId.STag_Capt_Format": "{0} {1}",
  "ReportStringId.STag_Capt_Tasks": "Görevler",
  "ReportStringId.STag_Name_Bands": "Şeritler",
  "ReportStringId.STag_Name_Checked": "İşaretli",
  "ReportStringId.STag_Name_ColumnCount": "Sütun Sayısı",
  "ReportStringId.STag_Name_ColumnLayout": "Çoklu Sütun Biçimi",
  "ReportStringId.STag_Name_ColumnMode": "Çoklu Sütun Modu",
  "ReportStringId.STag_Name_ColumnSpacing": "Sütun Aralığı",
  "ReportStringId.STag_Name_ColumnWidth": "Sütun Genişliği",
  "ReportStringId.STag_Name_DataBinding": "Veri İlişkilendirme",
  "ReportStringId.STag_Name_ExpressionBinding": "İfade",
  "ReportStringId.STag_Name_FieldArea": "Yeni Alan için Alan Bölgesi",
  "ReportStringId.STag_Name_FormatString": "Biçimlendirme Kalıbı",
  "ReportStringId.STag_Name_Height": "Yükseklik",
  "ReportStringId.STag_Name_MailMerge": "Mail Merge",
  "ReportStringId.STag_Name_PreviewRowCount": "Önizleme Satır Sayısı",
  "ReportStringId.STag_Name_SummaryFunc": "Özet işlev",
  "ReportStringId.ScriptEditor_ClickValidate": "Betikleri kontrol etmek için \"Doğrula\" butonunu tıklayın",
  "ReportStringId.ScriptEditor_ErrorColumn": "Sütun",
  "ReportStringId.ScriptEditor_ErrorDescription": "Açıklama",
  "ReportStringId.ScriptEditor_ErrorLine": "Satır",
  "ReportStringId.ScriptEditor_NewString": "(Yeni)",
  "ReportStringId.ScriptEditor_ScriptHasBeenChanged": "Betik son doğrulamadan sonra değiştirildiği için Hata Günlüğü güncelliğini kaybetti. Güncel hataları görmek için \"Doğrula\" butonuna tekrar tıklayın.",
  "ReportStringId.ScriptEditor_ScriptsAreValid": "Tüm betikler doğrulandı",
  "ReportStringId.ScriptEditor_Validate": "Doğrula",
  "ReportStringId.SubreportDesigner_EditParameterBindings": "Parametre Bağlayıcıları Düzenle...",
  "ReportStringId.UD_Capt_AlignBottoms": "&Alt Sınırlar",
  "ReportStringId.UD_Capt_AlignCenters": "&Merkezler",
  "ReportStringId.UD_Capt_AlignLefts": "&Sol Sınırlar",
  "ReportStringId.UD_Capt_AlignMiddles": "&Ortalar",
  "ReportStringId.UD_Capt_AlignRights": "Sa&ğ Sınırlar",
  "ReportStringId.UD_Capt_AlignToGrid": "&Grid'e",
  "ReportStringId.UD_Capt_AlignTops": "&Üst Sınırlar",
  "ReportStringId.UD_Capt_BackGroundColor": "Arkaplan &Rengi",
  "ReportStringId.UD_Capt_CenterInFormHorizontally": "&Yatay",
  "ReportStringId.UD_Capt_CenterInFormVertically": "&Dikey",
  "ReportStringId.UD_Capt_Close": "Kapa&t",
  "ReportStringId.UD_Capt_Copy": "Ko&pyala",
  "ReportStringId.UD_Capt_Cut": "&Kes",
  "ReportStringId.UD_Capt_Delete": "S&il",
  "ReportStringId.UD_Capt_Exit": "&Çıkış",
  "ReportStringId.UD_Capt_FontBold": "Kal&ın",
  "ReportStringId.UD_Capt_FontItalic": "&İtalik",
  "ReportStringId.UD_Capt_FontUnderline": "Alt çi&zgi",
  "ReportStringId.UD_Capt_ForegroundColor": "&Önplan Rengi",
  "ReportStringId.UD_Capt_FormattingToolbarName": "Biçimlendirme Araç Çubuğu",
  "ReportStringId.UD_Capt_JustifyCenter": "&Merkez",
  "ReportStringId.UD_Capt_JustifyJustify": "&İki Yana",
  "ReportStringId.UD_Capt_JustifyLeft": "&Sol",
  "ReportStringId.UD_Capt_JustifyRight": "Sa&ğ",
  "ReportStringId.UD_Capt_LayoutToolbarName": "Yerleşim Araç Çubuğu",
  "ReportStringId.UD_Capt_MainMenuName": "Ana Menü",
  "ReportStringId.UD_Capt_MakeSameSizeBoth": "&Her İkisi",
  "ReportStringId.UD_Capt_MakeSameSizeHeight": "&Yükseklik",
  "ReportStringId.UD_Capt_MakeSameSizeSizeToGrid": "&Grid",
  "ReportStringId.UD_Capt_MakeSameSizeWidth": "&Genişlik",
  "ReportStringId.UD_Capt_MdiCascade": "&Basamaklandır",
  "ReportStringId.UD_Capt_MdiTileHorizontal": "&Yatay Döşe",
  "ReportStringId.UD_Capt_MdiTileVertical": "&Dikey Döşe",
  "ReportStringId.UD_Capt_NewReport": "Y&eni",
  "ReportStringId.UD_Capt_NewWizardReport": "&Sihirbaz ile Yeni...",
  "ReportStringId.UD_Capt_OpenFile": "A&ç",
  "ReportStringId.UD_Capt_OrderBringToFront": "&Öne Getir",
  "ReportStringId.UD_Capt_OrderSendToBack": "&Arkaya At",
  "ReportStringId.UD_Capt_Paste": "&Yapıştır",
  "ReportStringId.UD_Capt_Redo": "&Yinele",
  "ReportStringId.UD_Capt_SaveAll": "&Hepsini Kaydet",
  "ReportStringId.UD_Capt_SaveFile": "&Kaydet",
  "ReportStringId.UD_Capt_SaveFileAs": "&Farklı Kaydet...",
  "ReportStringId.UD_Capt_SelectAll": "&Hepsini Seç",
  "ReportStringId.UD_Capt_SpacingDecrease": "&Azalt",
  "ReportStringId.UD_Capt_SpacingIncrease": "A&rtır",
  "ReportStringId.UD_Capt_SpacingMakeEqual": "&Eşitle",
  "ReportStringId.UD_Capt_SpacingRemove": "&Kaldır",
  "ReportStringId.UD_Capt_StatusBarName": "Durum Çubuğu",
  "ReportStringId.UD_Capt_TabbedInterface": "&Sekmeli Arayüz",
  "ReportStringId.UD_Capt_ToolbarName": "Araç Çubuğu",
  "ReportStringId.UD_Capt_Undo": "&Geri Al",
  "ReportStringId.UD_Capt_Zoom": "Yaklaştır",
  "ReportStringId.UD_Capt_ZoomFactor": "Yaklaştırma Oranı: %{0}",
  "ReportStringId.UD_Capt_ZoomIn": "Yaklaştır",
  "ReportStringId.UD_Capt_ZoomOut": "Uzaklaştır",
  "ReportStringId.UD_Capt_ZoomToolbarName": "Yaklaştırma Araç Çubuğu",
  "ReportStringId.UD_FormCaption": "Rapor Tasarımcısı",
  "ReportStringId.UD_Group_Align": "&Hizala",
  "ReportStringId.UD_Group_CenterInForm": "&Form'da Ortala",
  "ReportStringId.UD_Group_DockPanelsList": "&Pencereler",
  "ReportStringId.UD_Group_Edit": "&Düzenle",
  "ReportStringId.UD_Group_File": "&Dosya",
  "ReportStringId.UD_Group_Font": "&Yazı Tipi",
  "ReportStringId.UD_Group_Format": "&Biçim",
  "ReportStringId.UD_Group_HorizontalSpacing": "&Yatay Boşluk",
  "ReportStringId.UD_Group_Justify": "&İki Yana Yasla",
  "ReportStringId.UD_Group_MakeSameSize": "&Boyutlarını Eşitle",
  "ReportStringId.UD_Group_Order": "&Düzen",
  "ReportStringId.UD_Group_TabButtonsList": "Sekme Butonları",
  "ReportStringId.UD_Group_ToolbarsList": "&Araç Çubukları",
  "ReportStringId.UD_Group_VerticalSpacing": "&Dikey Boşluk",
  "ReportStringId.UD_Group_View": "&Görünüm",
  "ReportStringId.UD_Group_Window": "&Pencere",
  "ReportStringId.UD_Hint_AlignBottoms": "Seçili kontrollerin alt sınırlarını hizala",
  "ReportStringId.UD_Hint_AlignCenters": "Seçili kontrollerin merkezlerini dikey hizala",
  "ReportStringId.UD_Hint_AlignLefts": "Seçili kontrollerin sol sınırlarını hizala",
  "ReportStringId.UD_Hint_AlignMiddles": "Seçili kontrollerin merkezlerini yatay hizala",
  "ReportStringId.UD_Hint_AlignRights": "Seçili kontrollerin sağ sınırlarını hizala",
  "ReportStringId.UD_Hint_AlignToGrid": "Seçili kontrollerin yerleşimlerini grid'e hizala",
  "ReportStringId.UD_Hint_AlignTops": "Seçili kontrollerin üst sınırlarını hizala",
  "ReportStringId.UD_Hint_BackGroundColor": "Kontrolün arkaplan rengini ayarla",
  "ReportStringId.UD_Hint_CenterInFormHorizontally": "Seçili kontrollerin merkezlerini şerit içerisinde yatay hizala",
  "ReportStringId.UD_Hint_CenterInFormVertically": "Seçili kontrollerin merkezlerini şerit içerisinde dikey hizala",
  "ReportStringId.UD_Hint_Close": "Raporu kapat",
  "ReportStringId.UD_Hint_Copy": "Kontrolü panoya kopyala",
  "ReportStringId.UD_Hint_Cut": "Kontrolü panoya kopyala ve sil",
  "ReportStringId.UD_Hint_Delete": "Kontrolü sil",
  "ReportStringId.UD_Hint_Exit": "Tasarımcıyı kapat",
  "ReportStringId.UD_Hint_FontBold": "Yazı tipini kalınlaştır",
  "ReportStringId.UD_Hint_FontItalic": "Yazı tipini italikleştir",
  "ReportStringId.UD_Hint_FontUnderline": "Yazı tipinin altını çiz",
  "ReportStringId.UD_Hint_ForegroundColor": "Kontrolün önplan rengini ayarla",
  "ReportStringId.UD_Hint_JustifyCenter": "Kontrolün metnini merkeze hizala",
  "ReportStringId.UD_Hint_JustifyJustify": "Kontrolün metnini iki yana yasla",
  "ReportStringId.UD_Hint_JustifyLeft": "Kontrolün metnini sola hizala",
  "ReportStringId.UD_Hint_JustifyRight": "Kontrolün metnini sağa hizala",
  "ReportStringId.UD_Hint_MakeSameSizeBoth": "Seçili kontrollerin boyutlarını eşitle",
  "ReportStringId.UD_Hint_MakeSameSizeHeight": "Seçili kontrollerin yüksekliklerini eşitle",
  "ReportStringId.UD_Hint_MakeSameSizeSizeToGrid": "Seçili kontrolleri grid'e göre boyutlandır",
  "ReportStringId.UD_Hint_MakeSameSizeWidth": "Seçili kontrollerin genişliklerini eşitle",
  "ReportStringId.UD_Hint_MdiCascade": "Bütün açık dokümanları çakışmalarını sağlayacak şekilde düzenle",
  "ReportStringId.UD_Hint_MdiTileHorizontal": "Bütün açık dokümanları yukarıdan aşağıya düzenle",
  "ReportStringId.UD_Hint_MdiTileVertical": "Bütün açık dokümanları soldan sağa düzenle",
  "ReportStringId.UD_Hint_NewReport": "Boş rapor yarat",
  "ReportStringId.UD_Hint_NewWizardReport": "Sihirbaz kullanarak boş rapor yarat",
  "ReportStringId.UD_Hint_OpenFile": "Rapor Aç",
  "ReportStringId.UD_Hint_OrderBringToFront": "Seçili kontrolleri öne getir",
  "ReportStringId.UD_Hint_OrderSendToBack": "Seçili kontrolleri arkaya at",
  "ReportStringId.UD_Hint_Paste": "Panodan kontrol ekle",
  "ReportStringId.UD_Hint_Redo": "Son işlemi yinele",
  "ReportStringId.UD_Hint_SaveAll": "Bütün raporları kaydet",
  "ReportStringId.UD_Hint_SaveFile": "Raporu kaydet",
  "ReportStringId.UD_Hint_SaveFileAs": "Raporu farklı bir isimle kaydet",
  "ReportStringId.UD_Hint_SelectAll": "Dokümandaki bütün kontrolleri seç",
  "ReportStringId.UD_Hint_SpacingDecrease": "Seçili kontroller arasındaki boşluğu azalt",
  "ReportStringId.UD_Hint_SpacingIncrease": "Seçili kontroller arasındaki boşluğu artır",
  "ReportStringId.UD_Hint_SpacingMakeEqual": "Seçili kontroller arasındaki boşluğu eşitle",
  "ReportStringId.UD_Hint_SpacingRemove": "Seçili kontroller arasındaki boşluğu kaldır",
  "ReportStringId.UD_Hint_TabbedInterface": "Sekmeli ve MDI pencere yerleşim modları arasında geçiş yap",
  "ReportStringId.UD_Hint_Undo": "Son işlemi geri al",
  "ReportStringId.UD_Hint_ViewBars": "Göster/Sakla: {0}",
  "ReportStringId.UD_Hint_ViewDockPanels": "{0} penceresini göster / sakla",
  "ReportStringId.UD_Hint_ViewTabs": "{0} sekmesine geçiş yap",
  "ReportStringId.UD_Hint_Zoom": "Yaklaştırma oranı seçin/girin",
  "ReportStringId.UD_Hint_ZoomIn": "Tasarım yüzüne yaklaştır",
  "ReportStringId.UD_Hint_ZoomOut": "Tasarım yüzünden uzaklaştır",
  "ReportStringId.UD_Msg_ConvertBindingsCaption": "Dönüştür",
  "ReportStringId.UD_Msg_ConvertBindings_LinkText": "İfadeler hakkında daha fazla bilgi edinin",
  "ReportStringId.UD_Msg_ConvertBindings_RememberMyChoice": "Benim tercihim hatırlıyorum ve bana bir daha sorma.",
  "ReportStringId.UD_Msg_MdiReportChanged": "\"{0}\" değiştirildi. Değişiklikleri kaydetmek istiyor musunuz?",
  "ReportStringId.UD_Msg_ReportChanged": "Rapor değiştirildi. Değişiklikleri kaydetmek istiyor musunuz?",
  "ReportStringId.UD_PropertyGrid_Menu_ItemExpression": "{0} ifadesi",
  "ReportStringId.UD_PropertyGrid_NotSetText": "(Yok)",
  "ReportStringId.UD_PropertyGrid_TabAppearance": "Görünüş",
  "ReportStringId.UD_PropertyGrid_TabBehavior": "Davranış",
  "ReportStringId.UD_PropertyGrid_TabData": "Veri",
  "ReportStringId.UD_PropertyGrid_TabFavorites_EmptyText": "favori özellikleri için bu rapor denetimi belirtilmemiştir.",
  "ReportStringId.UD_PropertyGrid_TabMiscellaneous": "Çeşitli",
  "ReportStringId.UD_PropertyGrid_TabProperties": "Özellikler",
  "ReportStringId.UD_ReportDesigner": "Rapor Tasarımcısı",
  "ReportStringId.UD_ReportGallery_Bands": "Bantlar",
  "ReportStringId.UD_ReportGallery_Reports": "Raporlar",
  "ReportStringId.UD_ReportGallery_Styles": "Stiller",
  "ReportStringId.UD_SaveFileDialog_DialogFilter": "Rapor Dosyaları (*{0})|*{1}|Tüm Dosyalar (*.*)|*.*",
  "ReportStringId.UD_TTip_AlignBottom": "Alt Sınırları Hizala",
  "ReportStringId.UD_TTip_AlignHorizontalCenters": "Ortaları Hizala",
  "ReportStringId.UD_TTip_AlignLeft": "Sol Sınırları Hizala",
  "ReportStringId.UD_TTip_AlignRight": "Sağ Sınırları Hizala",
  "ReportStringId.UD_TTip_AlignToGrid": "Grid'e Hizala",
  "ReportStringId.UD_TTip_AlignTop": "Üst Sınırları Hizala",
  "ReportStringId.UD_TTip_AlignVerticalCenters": "Merkezleri Hizala",
  "ReportStringId.UD_TTip_BringToFront": "Öne Getir",
  "ReportStringId.UD_TTip_CenterHorizontally": "Yatay Ortala",
  "ReportStringId.UD_TTip_CenterVertically": "Dikey Ortala",
  "ReportStringId.UD_TTip_DataMemberDescription": "Veri Öğesi: {0}",
  "ReportStringId.UD_TTip_EditCopy": "Kopyala",
  "ReportStringId.UD_TTip_EditCut": "Kes",
  "ReportStringId.UD_TTip_EditPaste": "Yapıştır",
  "ReportStringId.UD_TTip_FileOpen": "Aç",
  "ReportStringId.UD_TTip_FileSave": "Kaydet",
  "ReportStringId.UD_TTip_FormatAlignLeft": "Sola Hizala",
  "ReportStringId.UD_TTip_FormatAlignRight": "Sağa Hizala",
  "ReportStringId.UD_TTip_FormatBackColor": "Arkaplan Rengi",
  "ReportStringId.UD_TTip_FormatBold": "Kalın",
  "ReportStringId.UD_TTip_FormatCenter": "Merkez",
  "ReportStringId.UD_TTip_FormatFontName": "Yazı Tipi Adı",
  "ReportStringId.UD_TTip_FormatFontSize": "Yazı Tipi Boyutu",
  "ReportStringId.UD_TTip_FormatForeColor": "Önplan Rengi",
  "ReportStringId.UD_TTip_FormatItalic": "İtalik",
  "ReportStringId.UD_TTip_FormatJustify": "İki Yana Yasla",
  "ReportStringId.UD_TTip_FormatUnderline": "Alt Çigi",
  "ReportStringId.UD_TTip_HorizSpaceConcatenate": "Yatay Boşluğu Kaldır",
  "ReportStringId.UD_TTip_HorizSpaceDecrease": "Yatay Boşluğu Azalt",
  "ReportStringId.UD_TTip_HorizSpaceIncrease": "Yatay Boşluğu Artır",
  "ReportStringId.UD_TTip_HorizSpaceMakeEqual": "Yatay Boşluğu Eşitle",
  "ReportStringId.UD_TTip_ItemDescription": "Bu nesneyle ilişkili bir kontrol yaratmak için nesneyi sürükleyip bırakın;\n- yada -\nAçılır pencere menüsünden ilişkili bir kontrolü seçmek için SHIFT veya fare sağ butonu ile bu nesneyi sürükleyin;\n- yada -\nHesap alanı yada değişken eklemek için Bağlam Menüsünü kullanın",
  "ReportStringId.UD_TTip_Redo": "Yinele",
  "ReportStringId.UD_TTip_SendToBack": "Arkaya At",
  "ReportStringId.UD_TTip_SizeToControl": "Boyutları Eşitle",
  "ReportStringId.UD_TTip_SizeToControlHeight": "Yükseklikleri Eşitle",
  "ReportStringId.UD_TTip_SizeToControlWidth": "Genişlikleri Eşitle",
  "ReportStringId.UD_TTip_SizeToGrid": "Grid'e göre boyutlandır",
  "ReportStringId.UD_TTip_TableDescription": "Bu nesnenin öğeleri ile bir tablo yaratmak için nesneyi sürükleyip bırakın;\n- yada -\nAlan adlarıyla birlikte 'Başlık' tablosu yaratmak için SHIFT veya fare sağ butonu ile bu nesneyi sürükleyin;\n- yada -\nHesap alanı yada değişken eklemek için Bağlam Menüsünü kullanın",
  "ReportStringId.UD_TTip_Undo": "Geri Al",
  "ReportStringId.UD_TTip_VertSpaceConcatenate": "Dikey Boşluğu Kaldır",
  "ReportStringId.UD_TTip_VertSpaceDecrease": "Dikey Boşluğu Azalt",
  "ReportStringId.UD_TTip_VertSpaceIncrease": "Dikey Boşluğu Artır",
  "ReportStringId.UD_TTip_VertSpaceMakeEqual": "Dikey Boşluğu Eşitle",
  "ReportStringId.UD_Title_ErrorList": "Betik Hataları",
  "ReportStringId.UD_Title_FieldList": "Alan Listesi",
  "ReportStringId.UD_Title_FieldList_AddNewDataSourceText": "Yeni Veri Kaynağı Ekle",
  "ReportStringId.UD_Title_FieldList_NonePickerNodeText": "Hiçbiri",
  "ReportStringId.UD_Title_FieldList_ProjectObjectsText": "Proje Nesneleri",
  "ReportStringId.UD_Title_GroupAndSort": "Grupla ve Sırala",
  "ReportStringId.UD_Title_PropertyGrid": "Özellik Kılavuzu",
  "ReportStringId.UD_Title_ReportExplorer": "Rapor Gezgini",
  "ReportStringId.UD_Title_ReportExplorer_Components": "Bileşenler",
  "ReportStringId.UD_Title_ReportExplorer_FormattingRules": "Biçimlendirme kuralları",
  "ReportStringId.UD_Title_ReportExplorer_NullControl": "Hiçbiri",
  "ReportStringId.UD_Title_ReportExplorer_Styles": "Stiller",
  "ReportStringId.UD_Title_ToolBox": "Araç Kutusu",
  "ReportStringId.UD_XtraReportsPointerItemCaption": "İmleç",
  "ReportStringId.UD_XtraReportsToolboxCategoryName": "Standart Kontroller",
  "ReportStringId.Verb_About": "Hakkında",
  "ReportStringId.Verb_AddFieldToArea": "Bölgeye Alan Ekle",
  "ReportStringId.Verb_Bind": "İlişkilendir",
  "ReportStringId.Verb_Delete": "Sil...",
  "ReportStringId.Verb_EditBands": "Şeritleri Değiştir ve Yeniden Düzenle...",
  "ReportStringId.Verb_EditBindings": "İlişkilendirmeleri Düzenle...",
  "ReportStringId.Verb_EditGroupFields": "GrupAlanlarını Düzenle...",
  "ReportStringId.Verb_EditText": "Yazıyı Düzenle",
  "ReportStringId.Verb_Export": "Kaydet/ihracat...",
  "ReportStringId.Verb_FormatString": "Biçim Kalıbı...",
  "ReportStringId.Verb_Import": "Aç/İçeri Aktar...",
  "ReportStringId.Verb_Insert": "Ekle...",
  "ReportStringId.Verb_LoadReportTemplate": "Rapor Şablonu Yükle...",
  "ReportStringId.Verb_RTFClear": "Temizle",
  "ReportStringId.Verb_RTFLoad": "Dosya Yükle...",
  "ReportStringId.Verb_ReportWizard": "Rapor Sihirbazı'nda Tasarla...",
  "ReportStringId.Verb_RevertCrossTabToPivotGrid": "Orijinal Pivot Kılavuzuna Geri Dön",
  "ReportStringId.Verb_RunDesigner": "Tasarımcıyı Çalıştır...",
  "ReportStringId.Verb_Save": "Kaydet...",
  "ReportStringId.Verb_SummaryWizard": "Özet...",
  "ReportStringId.WAvgDisplayName": "Ağırlıklı ortalama",
  "ReportStringId.Wizard_PageChooseFields_Msg": "Devam etmeden önce rapor için alan seçmelisiniz.",
  "ReportStringId.Wizard_ReportColorScheme_Blue": "Mavi",
  "ReportStringId.Wizard_ReportColorScheme_Coral": "Mercan",
  "ReportStringId.Wizard_ReportColorScheme_Cream": "Krem",
  "ReportStringId.Wizard_ReportColorScheme_Custom": "Özel",
  "ReportStringId.Wizard_ReportColorScheme_Grey": "Gri",
  "ReportStringId.Wizard_ReportColorScheme_Mint": "Nane",
  "ReportStringId.Wizard_ReportColorScheme_Raspberry": "Ahududu",
  "ReportStringId.Wizard_ReportColorScheme_Red": "Kırmızı",
  "ReportStringId.Wizard_ReportColorScheme_Violet": "Menekşe",
  "ReportStringId.Wizard_ReportColorScheme_Yellow": "Sarı",
  "ReportStringId.XRSubreport_NameInfo": "Adı: {0}\n",
  "ReportStringId.XRSubreport_NullReportSourceInfo": "Boş",
  "ReportStringId.XRSubreport_ReportSourceInfo": "Rapor Kaynağı: {0}\n",
  "ReportStringId.XRSubreport_ReportSourceUrlInfo": "Rapor Kaynak Adresi: {0}\n",
  "System.Windows.Forms.CheckState.Checked": "İşaretli",
  "System.Windows.Forms.CheckState.Indeterminate": "Belirsiz",
  "UtilsUIStringId.Cmd_AddCalculatedField": "Hesaplanmış alan ekle",
  "UtilsUIStringId.Cmd_AddParameter": "Parametre ekle",
  "UtilsUIStringId.Cmd_ClearCalculatedFields": "Hesaplanış alanları Kaldır",
  "UtilsUIStringId.Cmd_ClearParameters": "Parametreleri Kaldır",
  "UtilsUIStringId.Cmd_DeleteCalculatedField": "Sil",
  "UtilsUIStringId.Cmd_DeleteParameter": "Sil",
  "UtilsUIStringId.Cmd_EditCalculatedFields": "Hesaplanmış alanları düzenle...",
  "UtilsUIStringId.Cmd_EditExpression": "İfadeleri Düzenle...",
  "UtilsUIStringId.Cmd_EditParameters": "Parametreleri Düzenle",
  "UtilsUIStringId.CollectionEditor_Cancel": "{0} Nesnesi eklemek veya kaldırmak",
  "UtilsUIStringId.FSForm_Cat_Currency": "Para",
  "UtilsUIStringId.FSForm_Cat_DateTime": "Tarih/Saat",
  "UtilsUIStringId.FSForm_Cat_General": "Genel",
  "UtilsUIStringId.FSForm_Cat_Int32": "Int32",
  "UtilsUIStringId.FSForm_Cat_Number": "Sayı",
  "UtilsUIStringId.FSForm_Cat_Percent": "Yüzde",
  "UtilsUIStringId.FSForm_Cat_Special": "Özel",
  "UtilsUIStringId.FSForm_Msg_BadSymbol": "Hata: Geçersiz sembol(ler)",
  "UtilsUIStringId.Msg_ContainsIllegalSymbols": "Giriş biçimlendirme kalıbı geçersiz karakterler içeriyor",
  "UtilsUIStringId.Msg_ErrorTitle": "Hata",
  "UtilsUIStringId.NonePickerNodeText": "Hiçbiri",
  "UtilsUIStringId.ParameterCollectionEditor_Title": "Değişkenler",
  "UtilsUIStringId.Parameter_Type_Boolean": "Boole",
  "UtilsUIStringId.Parameter_Type_DateTime": "TarihSaat",
  "UtilsUIStringId.Parameter_Type_Decimal": "Ondalık",
  "UtilsUIStringId.Parameter_Type_Double": "Çift",
  "UtilsUIStringId.Parameter_Type_Float": "Gezici",
  "UtilsUIStringId.Parameter_Type_Guid": "GUID",
  "UtilsUIStringId.Parameter_Type_Int16": "Sayı (16 bit tamsayı)",
  "UtilsUIStringId.Parameter_Type_Int32": "Sayı (32 bit tamsayı)",
  "UtilsUIStringId.Parameter_Type_Int64": "Sayı (64-bit tamsayı)",
  "UtilsUIStringId.Parameter_Type_String": "Dize",
  "UtilsUIStringId.PropGrid_TTip_Alphabetical": "Alfabetik",
  "UtilsUIStringId.PropGrid_TTip_Categorized": "Kategorilenmiş",
  "UtilsUIStringId.PropGrid_TTip_Properties": "Özellikler"
}
